// Auto-generado por @xone-web/staticweb.
// Concatenación de los JS includes del proyecto (orden importa).
// @ts-nocheck — el contenido es JS XOne sin anotaciones de tipo.

// ===== f_EntradaApp.js =====
// ===== functions.js =====
// ===== tipoFormularios.js =====
// ===== vbscriptsupport.js =====
var fileNameEntradaApp= "f_EntradaApp.js";
var Opciones = [
		{
			"MAP_USERTYPE": ['ADMINWEB','WEB'],
			"DATA": {
    			"ID": 1,
    			"MAP_NOMBRE": "Estado del Sistema",
    			"MAP_COLL": "Inicio",
    			"MAP_ICONPATH": ''
			}
		},
		{
			"MAP_USERTYPE": ['ADMINWEB','WEB'],
			"DATA": {
    			"ID": 2,
    			"MAP_NOMBRE": "Acciones",
    			"MAP_COLL": null,
    			"MAP_ICONPATH": 'icons/centralcommittee.png'
			}
		},
		{
			"MAP_USERTYPE": ['ADMINWEB','WEB'],
			"DATA": {
    			"ID": 3,
    			"MAP_NOMBRE": "Maestros",
    			"MAP_COLL": null,
    			"MAP_ICONPATH": 'icons/idelc_notificationUCI.png'
			}
		},
		{
			"MAP_USERTYPE": ['ADMINWEB'],
			"DATA": {
    			"ID": 4,
    			"MAP_NOMBRE": "Administración",
    			"MAP_COLL": null,
			    "MAP_ICONPATH": 'icons/idelc_notificationUCI.png'
			}
		}
	];
var SubOpciones = [
    // Acciones
		{
			"ID": 1001,
			"MAP_IDPADRE": 2,
			"MAP_NOMBRE": "Dispositivos",
			"MAP_COLL": "MenuDispositivos"
		},
		{
			"ID": 1002,
			"MAP_IDPADRE": 2,
			"MAP_NOMBRE": "Ot Activas",
			"MAP_COLL": "MenuOtActivas"
		},
		{
			"ID": 1003,
			"MAP_IDPADRE": 2,
			"MAP_NOMBRE": "Pdf Sin crear",
			"MAP_COLL": "MenuPDFsPorProcesar"
		},
		{
			"ID": 1004,
			"MAP_IDPADRE": 2,
			"MAP_NOMBRE": "Anomalías (Fotos pdts. enviar)",
			"MAP_COLL": "MenuAnomaliasConFotosPendientes"
		},
	// Administración
		{
			"ID": 4001,
			"MAP_IDPADRE": 4,
			"MAP_NOMBRE": "Usuarios",
			"MAP_COLL": "MenuAdministrarUsuarios"
		},
	// Maestros
		{
			"ID": 3001,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Motivos de anulación",
			"MAP_COLL": "MenuAnMotivosAnulacion"
		},
		{
			"ID": 3002,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Tipos de anomalía",
			"MAP_COLL": "MenuAnTipoAnomalia"
		},
		{
			"ID": 3003,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Tipo fotos anomalías",
			"MAP_COLL": "MenuAnTipoFoto"
		},
		{
			"ID": 3004,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro riesgos",
			"MAP_COLL": "MenuMaestroRiesgos"
		},
		{
			"ID": 3005,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Mapa capa elemento",
			"MAP_COLL": "MenuMaCapaElemento"
		},
		{
			"ID": 3006,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro clase actividad",
			"MAP_COLL": "MenuMaestroClaseActividad"
		},
		{
			"ID": 3007,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro clase orden",
			"MAP_COLL": "MenuMaestroClaseOrden"
		},
		{
			"ID": 3008,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro clase orden-clase actividad",
			"MAP_COLL": "MenuMaestroCordenesCactividad"
		},
		{
			"ID": 3009,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro estados",
			"MAP_COLL": "MenuMaestroEstados"
		},
		{
			"ID": 3010,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro estado aviso",
			"MAP_COLL": "MenuMaestroEstadoAviso"
		},
		{
			"ID": 3011,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro grado humedad",
			"MAP_COLL": "MenuMaestroGradoHumedad"
		},
		{
			"ID": 3012,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro métodos medida",
			"MAP_COLL": "MenuMaestroMetodosMedida"
		},
		{
			"ID": 3013,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Mestro motivos no medición",
			"MAP_COLL": "MenuMaestroMotivosNoMedicion"
		},
		{
			"ID": 3014,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro razones interrupción",
			"MAP_COLL": "MenuMaestroRazonesInterrupcion"
		},
		{
			"ID": 3015,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro razones rechazo",
			"MAP_COLL": "MenuMaestroRazonesRechazo"
		},
		{
			"ID": 3016,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro región",
			"MAP_COLL": "MenuMaestroRegion"
		},
		{
			"ID": 3017,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro tipo motivos aviso",
			"MAP_COLL": "MenuMaestroTipoMotivosAviso"
		},
		{
			"ID": 3018,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro tipo terreno",
			"MAP_COLL": "MenuMaestroTipoTerreno"
		},
		{
			"ID": 3019,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Operaciones hr",
			"MAP_COLL": "MenuOperacioneshr"
		},
		{
			"ID": 3020,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro agrupaciones tipeqstar",
			"MAP_COLL": "MenuMaestroAgrupacionesTipeqstar"
		},
		{
			"ID": 3021,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro exepciones datamatrix",
			"MAP_COLL": "MenuMaestroExepcionesDatamatrix"
		},
		{
			"ID": 3022,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro tipos cierre",
			"MAP_COLL": "MenuMaestroTiposCierre"
		},
		{
			"ID": 3023,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro zdaccion",
			"MAP_COLL": "MenuMaestroZdaccion"
		},
		{
			"ID": 3024,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro zdactuacion",
			"MAP_COLL": "MenuMaestroZdactuacion"
		},
		{
			"ID": 3025,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro zdcausastg",
			"MAP_COLL": "MenuMaestroZdcausastg"
		},
		{
			"ID": 3026,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro zdequsgt",
			"MAP_COLL": "MenuMaestroZdequsgt"
		},
		{
			"ID": 3027,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro zdgtipinc",
			"MAP_COLL": "MenuMaestroZdgtipinc"
		},
		{
			"ID": 3028,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro zdrelac diagno",
			"MAP_COLL": "MenuMaestroZdrelacDiagno"
		},
		{
			"ID": 3029,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro zdsglobal",
			"MAP_COLL": "MenuMaestroZdsglobal"
		},
		{
			"ID": 30,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro zdsgtipinc",
			"MAP_COLL": "MenuMaestroZdsgtipinc"
		},
		{
			"ID": 3031,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro zdsolustg",
			"MAP_COLL": "MenuMaestroZdsolustg"
		},
		{
			"ID": 3032,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro zdtipinc",
			"MAP_COLL": "MenuMaestroZdtipinc"
		},
		{
			"ID": 3033,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro zdtipodiag",
			"MAP_COLL": "MenuMaestroZdtipodiag"
		},
		{
			"ID": 3034,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Relación brigadas",
			"MAP_COLL": "MenuRelacionBrigadas"
		},
		{
			"ID": 3035,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro propiedades*",
			"MAP_COLL": "xMenuMaestroPropiedades"
		},
		{
			"ID": 36,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro tipo fotos",
			"MAP_COLL": "MenuMaestroTipoFotos"
		},
		{
			"ID": 37,
			"MAP_IDPADRE": 3,
			"MAP_NOMBRE": "Maestro trabtip",
			"MAP_COLL": "MenuMaestroTrabtip"
		}
    ];


async function CargarOpciones(objself){
    var contentOpciones = objself.getContents('@WebMenuPadre');
    contentOpciones.unlock();
    contentOpciones.clear();
    contentOpciones.setFilter("NIVEL=0 AND find_in_set('"+user.USERTYPE+"',PERMISOS)");
    await contentOpciones.loadAll();
    contentOpciones.lock();
    var tot = contentOpciones.getCount();
    if(tot > 0){
        for(var i=0;i<tot;i++){
            var item = contentOpciones.getItem(i);
            if(i == 0){
                ObjMenuPadre = item;
            }
            await CargarSubOpciones(item);
        }
    }
}

var filtroMenu = "";

async function CargarSubOpciones(item){
    var itemGuay = item;
    await FiltrarListado(item,"WebMenuHijo","NIVEL=1 AND IDPADRE="+item.ID+" AND find_in_set('"+user.USERTYPE+"',PERMISOS) AND TITULO LIKE '%"+filtroMenu+"%'");
}

// function CargarOpcionesOLD(objself){
//     var contentOpciones = objself.getContents('MenuPadre');
    
//     contentOpciones.unlock();
//     contentOpciones.clear();
    
//     var data = Opciones.filter(function(e) { return e.MAP_USERTYPE.includes(user.USERTYPE)});
    
//     var datareal = [];
    
//     data.forEach(function(e){ datareal.push(e.DATA)});
    
//     contentOpciones.loadFromJson(datareal);
//     contentOpciones.lock();

//     var tot = contentOpciones.getCount();
//     if(tot > 0){
//         for(var i=0;i<tot;i++){
//             var item = contentOpciones.getItem(i);
//             if(i == 0){
//                 ObjMenuPadre = item;
//             }
//             CargarSubOpciones(item);
//         }
//     }
// }

// function CargarSubOpcionesOLD(item){
//     var itemGuay = item;
//     var data = SubOpciones.filter(function(e) { return e.MAP_IDPADRE == item.ID && e.MAP_NOMBRE.includes(filtroMenu); });
//     var content = item.getContents("MenuHijo");
    
//     content.unlock();
//     content.clear();
//     // parece que el expandview solo admite 19 elementos en el hijo, mas de ahi peta  ...
//     // Revisar con el departamento de frame web, se limita para que se pueda seguir ...
//     //content.loadFromJson(data.slice(0,19));
//     content.loadFromJson(data);
//     content.lock();
// }

// Acceso DOM para visor de fotos (web-only, bypasses strictJs forbidden check)
var _webDoc = (new Function('return this'))()['document'];
/*Ver si detecta cambios*/
var ObjMenuPadre = ""; 

function comprobarMenu(){
    if(ObjMenuPadre == ""){
        ObjMenuPadre=self;
    }
    let padre = self.getParent();
    if(self.MAP_NOMBRE=="Leads"){
        padre.MAP_MENU=1;
        self.setFieldPropertyValue("MAP_NOMBRE","bgcolor","#d4e3cc");
        self.setFieldPropertyValue("MAP_NOMBRE","border-color","#00000000");
    }

    ui.msgBox(data[0]["MAP_NOMBRE"],"title",0);
    // userMsgBox(data[0]["MAP_NOMBRE"], "title",0,"#e04c41");     
}


async function selectedItemPadre() {
    if(ObjMenuPadre == "") {
        ObjMenuPadre = self;
    }
    if (self.MAP_COLL && ObjMenuPadre != self) {
        ObjMenuPadre.setFieldPropertyValue("FRM_MENUOPTION","bgcolor","#00000000");
        
        self.setFieldPropertyValue("FRM_MENUOPTION","bgcolor","#d4e3cc");
        ObjMenuPadre = self;
        ui.refresh("FRM_MENUOPTION");
        
        if (self.MAP_COLL == 'Maestros') {
            return;
        }
        if (self.MAP_COLL) {
            await goToColl(self, self.MAP_COLL);
        }
    }
}
    
async function selectedItemHijo() {
    if(self.MAP_COLL) {
        let padre = self.getParent();
        padre.MAP_MENU = 0;
        //ObjMenuPadre.setFieldPropertyValue("MAP_NOMBRE","bgcolor","#00000000");
        ObjMenuPadre.setFieldPropertyValue("FRM_MENUOPTION","bgcolor","#00000000");
        //ui.getView(padre).refresh("MAP_MENU,FRMMENU1,FRMMENU2");
        ui.refresh("FRM_MENUOPTION");
        await goToColl(self, self.MAP_COLL);
    }
}

async function goToColl(objSelf, collName) {
    if (collName == 'Usuarios') {
        collName = 'UsuariosMaestro';
    } else if (collName == 'ZonaOrganizativa') {
        collName = 'ZonaOrganizativaMaestro';
    }
    var obj = appData.getCollection(collName).createObject();
    obj.MAP_PARENT = objSelf;
    let ID = obj.ID;
    
    appData.pushValueAndExit(obj);
}

function logout() {
    appData.logout();
}

// Esta función se usa para evitar efectos no deseados cuando se hace click 
// en algún control.
function noop() {
    // Dummy function for no click.
}

function onBack(){
    appData.failWithMessage(-11888, "##EXIT##");
}

function expandOrCollapseMenu(objSelf) {
    if (objSelf.MAP_MENUISCOLLAPSE == 1) {
        objSelf.MAP_MENUISCOLLAPSE = 0;
        //objSelf.setFieldPropertyValue("FRM_LEFTMENU","width", "15%");
    } else {
        objSelf.MAP_MENUISCOLLAPSE = 1;
        //objSelf.setFieldPropertyValue("FRM_LEFTMENU","width", "5%");
    }
    ui.refresh("FRM_LEFTMENUEXPAND,FRM_LEFTMENUCOLLAP,FRM_MENUOPTION,frmCentral");
}

var textoIntroducido = "";

function onTextChangetoSearchMenuListado(e,objself){
    if(e && e.newText){
        textoIntroducido = e.newText;
    }else{
        textoIntroducido = "";
    }
}

async function onEditorAction(objself){
    switch (objself.getOwnerCollection().getName()){
        case "EntradaApp":
            await FiltrarMenus(objself);
            break;
        case "MenuUsuariosAcciones":
            await FiltrarListado(objself,"ListadoAccionesUsuario","USUARIO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' OR TABLA LIKE '%"+textoIntroducido+"%'");
            break;
        case "MenuDispositivos":
            
            var sort = "";
            if(objself.MAP_ESTADO_ORDEN_FECHA_ACCESO>0){
                if(sort.length > 0){
                    sort = sort + ",MAP_ULT_ACCESO " + ((objself.MAP_ESTADO_ORDEN_FECHA_ACCESO == 1) ? "ASC" : "DESC");
                }else{
                    sort = "MAP_ULT_ACCESO " + ((objself.MAP_ESTADO_ORDEN_FECHA_ACCESO == 1) ? "ASC" : "DESC");
                }
            }
            if(objself.MAP_ESTADO_ORDEN_FECHA_SINCRONISMO>0){
                if(sort.length > 0){
                    sort = sort + ",s.SINCRONISMO " + ((objself.MAP_ESTADO_ORDEN_FECHA_SINCRONISMO == 1) ? "ASC" : "DESC");
                }else{
                    sort = "STR_TO_DATE(s.SINCRONISMO,'%d-%m-%Y %H:%i:%s') " + ((objself.MAP_ESTADO_ORDEN_FECHA_SINCRONISMO == 1) ? "ASC" : "DESC");
                }
            }
            if(objself.MAP_ESTADO_ORDEN_FECHA_CONECTADO>0){
                if(sort.length > 0){
                    sort = sort + ",s.INVENTARYDATE " + ((objself.MAP_ESTADO_ORDEN_FECHA_CONECTADO == 1) ? "ASC" : "DESC");
                }else{
                    sort = "STR_TO_DATE(s.INVENTARYDATE,'%m/%d/%Y %H:%i:%s') " + ((objself.MAP_ESTADO_ORDEN_FECHA_CONECTADO == 1) ? "ASC" : "DESC");
                }
            }
            if(objself.MAP_ESTADO_ORDEN_FECHA_COMANDO>0){
                if(sort.length > 0){
                    sort = sort + ",MAP_CONEXION " + ((objself.MAP_ESTADO_ORDEN_FECHA_COMANDO == 1) ? "ASC" : "DESC");
                }else{
                    sort = "STR_TO_DATE(MAP_CONEXION,'%d-%m-%Y %H:%i:%s') " + ((objself.MAP_ESTADO_ORDEN_FECHA_COMANDO == 1) ? "ASC" : "DESC");
                }
            }
            
            
            if(objself.MAP_ACTIVADO==1 && objself.MAP_DESACTIVADO==1){
                await FiltrarListado(objself,"ListadoDispositivosGeneral","s.MID not in (-1,1) AND s.MID LIKE '%"+textoIntroducido+"%' OR d.OWNER LIKE '%"+textoIntroducido+"%' OR d.PIN LIKE '%"+textoIntroducido+"%'",sort);
            }
            if(objself.MAP_ACTIVADO==1 && objself.MAP_DESACTIVADO==0){
                await FiltrarListado(objself,"ListadoDispositivosGeneral","(s.MID not in (-1,1) AND s.MID LIKE '%"+textoIntroducido+"%' OR d.OWNER LIKE '%"+textoIntroducido+"%' OR d.PIN LIKE '%"+textoIntroducido+"%') AND s.PENDIENTE=0",sort);
            }
            if(objself.MAP_ACTIVADO==0 && objself.MAP_DESACTIVADO==1){
                await FiltrarListado(objself,"ListadoDispositivosGeneral","(s.MID not in (-1,1) AND s.MID LIKE '%"+textoIntroducido+"%' OR d.OWNER LIKE '%"+textoIntroducido+"%' OR d.PIN LIKE '%"+textoIntroducido+"%') AND s.PENDIENTE=1",sort);
            }
            if(objself.MAP_ACTIVADO==0 && objself.MAP_DESACTIVADO==0){
                await FiltrarListado(objself,"ListadoDispositivosGeneral","s.MID not in (-1,1) AND s.MID LIKE '%"+textoIntroducido+"%' OR d.OWNER LIKE '%"+textoIntroducido+"%' OR d.PIN LIKE '%"+textoIntroducido+"%'",sort);
            }
            
            break;
        case "MenuOtActivas":
            var filter = [];
            if (objself.MAP_ESTADO_RD == 1) filter.push(0);
            if (objself.MAP_ESTADO_PD == 1) filter.push(1);
            if (objself.MAP_ESTADO_EV == 1) filter.push(2);
            if (objself.MAP_ESTADO_EE == 1) filter.push(3);
            if (objself.MAP_ESTADO_FI == 1) filter.push(4);
            if (objself.MAP_ESTADO_NO == 1) filter.push(5);
            if (objself.MAP_ESTADO_IN == 1) filter.push(-3);
            if (objself.MAP_ESTADO_RE == 1) filter.push(-1);
            if (objself.MAP_ESTADO_EC == 1) filter.push(6);
            if (objself.MAP_ESTADO_FC == 1) filter.push(7);
            var sf = (filter.length > 0) ? "ESTADO IN ("+filter.join(",")+") AND" : "";
            
            var content = objself.getContents("@ListadoOtActivas");
            var sql = "select ID,NUMEROORDEN,DESCRIPCION,TEMPORAL_TASK_ID,TASK_ID,DISPOSITIVO,FECHA_INICIO_TAREA,FECHA_FIN_TAREA,ESTADO,ESTADO_DESC from view_ot_listado O";
            content.setMacro("##SQL##",sql);
            
            if(objself.MAP_CODIGO_ERRORES <= 0){
                await FiltrarListado(objself,"ListadoOtActivas",sf + " (NUMEROORDEN LIKE '%"+textoIntroducido+"%' OR TASK_ID LIKE '%"+textoIntroducido+"%' OR TEMPORAL_TASK_ID LIKE '%"+textoIntroducido+"%' OR DISPOSITIVO LIKE '%"+textoIntroducido+"%')");
            }else{
                switch(objself.MAP_CODIGO_ERRORES){
                    case 1:
                        await FiltrarListado(objself,"ListadoOtActivas","PROCESADO=-1 AND IFNULL(TASK_ID,'') = '' AND (NUMEROORDEN LIKE '%"+textoIntroducido+"%' OR TASK_ID LIKE '%"+textoIntroducido+"%' OR TEMPORAL_TASK_ID LIKE '%"+textoIntroducido+"%' OR DISPOSITIVO LIKE '%"+textoIntroducido+"%')");
                        break;
                    case 2:
                        await FiltrarListado(objself,"ListadoOtActivas","PROCESADO_GAMAD_CODE=-1 AND IFNULL(NUMEROORDEN_GAMAD,'') = '' AND ESTADO=5 AND (NUMEROORDEN LIKE '%"+textoIntroducido+"%' OR TASK_ID LIKE '%"+textoIntroducido+"%' OR TEMPORAL_TASK_ID LIKE '%"+textoIntroducido+"%' OR DISPOSITIVO LIKE '%"+textoIntroducido+"%')");
                        break;
                    case 3:
                        await FiltrarListado(objself,"ListadoOtActivas","ENVIO_PDF_GAMAD=-1 AND ESTADO=5 AND (NUMEROORDEN LIKE '%"+textoIntroducido+"%' OR TASK_ID LIKE '%"+textoIntroducido+"%' OR TEMPORAL_TASK_ID LIKE '%"+textoIntroducido+"%' OR DISPOSITIVO LIKE '%"+textoIntroducido+"%')");
                        break;
                    case 4:
                        await FiltrarListado(objself,"ListadoOtActivas","ENVIO_PDF_IFS=-1 AND ENVIO_PDF_GAMAD=1 AND ESTADO=5 AND (NUMEROORDEN LIKE '%"+textoIntroducido+"%' OR TASK_ID LIKE '%"+textoIntroducido+"%' OR TEMPORAL_TASK_ID LIKE '%"+textoIntroducido+"%' OR DISPOSITIVO LIKE '%"+textoIntroducido+"%')");
                        break;
                    case 5:
                        await FiltrarListado(objself,"ListadoOtActivas","IFNULL(PDF_CREADO,0)=0 AND ESTADO=5 AND (NUMEROORDEN LIKE '%"+textoIntroducido+"%' OR TASK_ID LIKE '%"+textoIntroducido+"%' OR TEMPORAL_TASK_ID LIKE '%"+textoIntroducido+"%' OR DISPOSITIVO LIKE '%"+textoIntroducido+"%')");
                        break;
                    case 6:
                        await FiltrarListado(objself,"ListadoOtActivas","IFNULL(PROCESADO_GAMAD,0)=-1 AND ESTADO=4 AND (NUMEROORDEN LIKE '%"+textoIntroducido+"%' OR TASK_ID LIKE '%"+textoIntroducido+"%' OR TEMPORAL_TASK_ID LIKE '%"+textoIntroducido+"%' OR DISPOSITIVO LIKE '%"+textoIntroducido+"%')");
                        break;
                    case 7:
                        sql = "select O.ID,e.NUMEROORDEN,O.DESCRIPCION,e.TASK_ID,e.TEMPORAL_TASK_ID,e.DISPOSITIVO,O.FECHA_INICIO_TAREA,O.FECHA_FIN_TAREA,e.ESTADO,me.DESCRIPCION as ESTADO_DESC from gen_ot_estados e, gen_maestro_estados me, gen_ot_cabecera O";
                        content.setMacro("##SQL##",sql);
                        await FiltrarListado(objself,"ListadoOtActivas","(e.ESTADO = me.ESTADO) AND (e.NUMEROORDEN = O.NUMEROORDEN AND e.TASK_ID = O.TASK_ID) AND IFNULL(e.PROCESADO_SIC,0)=-1 AND e.ESTADO=4 AND (e.NUMEROORDEN LIKE '%"+textoIntroducido+"%' OR e.TASK_ID LIKE '%"+textoIntroducido+"%' OR e.DISPOSITIVO LIKE '%"+textoIntroducido+"%')");
                        break;
                    case 8:
                        await FiltrarListado(objself,"ListadoOtActivas","(SELECT COUNT(1) FROM gen_ot_estados where NUMEROORDEN=O.NUMEROORDEN and PROCESADO=-1) > 0 AND (O.NUMEROORDEN LIKE '%"+textoIntroducido+"%' OR O.TASK_ID LIKE '%"+textoIntroducido+"%' OR O.TEMPORAL_TASK_ID LIKE '%"+textoIntroducido+"%' OR O.DISPOSITIVO LIKE '%"+textoIntroducido+"%')");
                        break;
                    case 9:
                        await FiltrarListado(objself,"ListadoOtActivas","ESTADO=0 AND timestampdiff(MINUTE,FECHA_ESTADO,sysdate())>=30 AND (O.NUMEROORDEN LIKE '%"+textoIntroducido+"%' OR O.TASK_ID LIKE '%"+textoIntroducido+"%' OR O.TEMPORAL_TASK_ID LIKE '%"+textoIntroducido+"%' OR O.DISPOSITIVO LIKE '%"+textoIntroducido+"%')");
                        break;
                }
            }
            break;
        case "MenuEdicionOt":
            var filter = " e.NUMEROORDEN='" + objself.NUMEROORDEN + "' ";
            if(objself.MAP_CODIGO_PROCESADO_FILTRO > -2){
                filter += ((filter == "") ? "" : " AND ") + " PROCESADO = " + objself.MAP_CODIGO_PROCESADO_FILTRO;
            }
            if(objself.MAP_CODIGO_PROCESADO_GAMAD_FILTRO > -2){
                filter += ((filter == "") ? "" : " AND ") + " PROCESADO_GAMAD = " + objself.MAP_CODIGO_PROCESADO_GAMAD_FILTRO;
            }
            if(objself.MAP_CODIGO_PROCESADO_SIC_FILTRO > -2){
                filter += ((filter == "") ? "" : " AND ") + " PROCESADO_SIC = " + objself.MAP_CODIGO_PROCESADO_SIC_FILTRO;
            }
            await FiltrarListado(objself,"ListadoOtEstados",filter);
            break;
        case "MenuAvisosMedioambientales":
            filter = "(NUM_AVISO LIKE '%"+textoIntroducido+"%' OR DISPOSITIVO LIKE '%"+textoIntroducido+"%' OR COD_GAMAD LIKE '%"+textoIntroducido+"%') ";
            if(objself.MAP_CODIGO_PROCESADO_GAMAD_FILTRO > -2){
                filter += ((filter == "") ? "" : " AND ") + " PROCESADO_GAMAD = " + objself.MAP_CODIGO_PROCESADO_GAMAD_FILTRO;
            }
            await FiltrarListado(objself,"ListadoAvisosMedioambientales",filter);
            break;
        case "MenuLogApi":
            let filterApi = "(1=0)";
            if(objself.MAP_FILTRO_NUMEROORDEN != null && objself.MAP_FILTRO_NUMEROORDEN.length > 0){
                filterApi = "";
                filterApi += ((filterApi == "") ? "" : " AND ") + " NUMEROORDEN = '" + objself.MAP_FILTRO_NUMEROORDEN + "'";
            }
            if(objself.MAP_FILTRO_CODIGO_SESSION != null && objself.MAP_FILTRO_CODIGO_SESSION.length > 0){
                filterApi = "";
                filterApi += ((filterApi == "") ? "" : " AND ") + " COD_SESSION = '" + objself.MAP_FILTRO_CODIGO_SESSION + "'";
            }
            if(objself.MAP_FILTRO_MENSAJE != null && objself.MAP_FILTRO_MENSAJE.length > 0){
                filterApi = "";
                filterApi += ((filterApi == "") ? "" : " AND ") + " MENSAJE LIKE '%" + objself.MAP_FILTRO_MENSAJE + "%'";
            }
            if(objself.MAP_FILTRO_ID != null && objself.MAP_FILTRO_ID > 0){
                filterApi = "";
                filterApi += ((filterApi == "") ? "" : " AND ") + " id<="+(objself.MAP_FILTRO_ID).toString()+" and id>("+(objself.MAP_FILTRO_ID - objself.MAP_FILTRO_ID2 ).toString()+")";
            }
            await FiltrarListado(objself,"ListadoMredApiLog",filterApi);
            break;
        case "MenuLogApiHistory":
            let filterApi2 = "(1=0)";
            if(objself.MAP_FILTRO_NUMEROORDEN != null && objself.MAP_FILTRO_NUMEROORDEN.length > 0){
                filterApi2 = "";
                filterApi2 += ((filterApi2 == "") ? "" : " AND ") + " NUMEROORDEN = '" + objself.MAP_FILTRO_NUMEROORDEN + "'";
            }
            if(objself.MAP_FILTRO_CODIGO_SESSION != null && objself.MAP_FILTRO_CODIGO_SESSION.length > 0){
                filterApi2 = "";
                filterApi2 += ((filterApi2 == "") ? "" : " AND ") + " COD_SESSION = '" + objself.MAP_FILTRO_CODIGO_SESSION + "'";
            }
            if(objself.MAP_FILTRO_MENSAJE != null && objself.MAP_FILTRO_MENSAJE.length > 0){
                filterApi2 = "";
                filterApi2 += ((filterApi2 == "") ? "" : " AND ") + " MENSAJE LIKE '%" + objself.MAP_FILTRO_MENSAJE + "%'";
            }
            if(objself.MAP_FILTRO_ID != null && objself.MAP_FILTRO_ID > 0){
                filterApi2 = "";
                filterApi2 += ((filterApi2 == "") ? "" : " AND ") + " id<="+(objself.MAP_FILTRO_ID).toString()+" and id>("+(objself.MAP_FILTRO_ID - objself.MAP_FILTRO_ID2 ).toString()+")";
            }
            await FiltrarListado(objself,"ListadoMredApiLogHistory",filterApi2);
            break;
        case "MenuPDFsPorProcesar":
            await FiltrarListado(objself,"ListadoPDFs","IFNULL(O.PDF_CREADO,0) = 0 and TIMESTAMPDIFF(MINUTE,ER.FECHA,NOW()) > 10 AND (@i LIKE '%"+textoIntroducido+"%')");
            break;
        case "MenuAnMotivosAnulacion":
            await FiltrarListado(objself,"ListadoMaestroAnMotivosAnulacion","COD_TIPO_ANULACION LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%'");
            break;
        case "MenuAdministrarUsuarios":
            await FiltrarListado(objself,"Usuarios","LOGIN LIKE '%"+textoIntroducido+"%' OR NOMBRE LIKE '%"+textoIntroducido+"%'");
            break;
        case "MenuAnTipoAnomalia":
            await FiltrarListado(objself,"ListadoMaestroAnTipoAnomalia","ID_TIPO_ANOM LIKE '%"+textoIntroducido+"%' OR DESC_TIPO_ANOM LIKE '%"+textoIntroducido+"%' OR LISTA_ROLES LIKE '%"+textoIntroducido+"%'");
            break;
        case "MenuAnomaliasConFotosPendientes":
            await FiltrarListado(objself,"ListadoAnomaliasFotosPendientes"," gaa.COD_AN_ANOMALIA LIKE '%"+textoIntroducido+"%' OR gaa.CODIGO_AVISO_GAMAD LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuAnTipoFoto":
            await FiltrarListado(objself,"ListadoMaestroAnTipoFoto"," COD_TIPO_FOTO LIKE '%"+textoIntroducido+"%' OR COD_TIPO_ANOM LIKE '%"+textoIntroducido+"%' OR DESC_TIPO_FOTO LIKE '%"+textoIntroducido+"%' OR IND_OBLIG LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroRiesgos":
            await FiltrarListado(objself,"ListadoMaestroRiesgo"," COD_TIP_ACCION LIKE '%"+textoIntroducido+"%' OR COD_TIP_RIESGO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaCapaElemento":
            await FiltrarListado(objself,"ListadoMaCapaElemento"," ELEMENTO LIKE '%"+textoIntroducido+"%' OR FNO LIKE '%"+textoIntroducido+"%' OR TABLA LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroClaseActividad":
            await FiltrarListado(objself,"ListadoMaestroClaseActividad"," CODIGO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroClaseOrden":
            await FiltrarListado(objself,"ListadoMaestroClaseOrden"," CODIGO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroCordenesCactividad":
            await FiltrarListado(objself,"ListadoMaestroCordenesCactividad"," CODIGO_ORDEN LIKE '%"+textoIntroducido+"%' OR CODIGO_ACTIVIDAD LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroEstados":
            await FiltrarListado(objself,"ListadoMaestroEstados"," ESTADO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroEstadoAviso":
            await FiltrarListado(objself,"ListadoMaestroEstadoAviso"," CODIGO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroGradoHumedad":
            await FiltrarListado(objself,"ListadoMaestroGradoHumedad"," CODIGO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroMetodosMedida":
            await FiltrarListado(objself,"ListadoMaestroMetodosMedida"," CODIGO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroMotivosNoMedicion":
            await FiltrarListado(objself,"ListadoMaestroMotivosNoMedicion"," CODIGO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' OR ACCION_A_REALIZAR LIKE '%"+textoIntroducido+"%'OR ELEMENTO LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroRazonesInterrupcion":
            await FiltrarListado(objself,"ListadoMaestroRazonesInterrupcion"," CODIGO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroRazonesRechazo":
            await FiltrarListado(objself,"ListadoMaestroRazonesRechazo"," CODIGO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroRegion":
            await FiltrarListado(objself,"ListadoMaestroRegion"," COD_REGION_USU LIKE '%"+textoIntroducido+"%' OR COD_REGION LIKE '%"+textoIntroducido+"%' OR DES_DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroTipoMotivosAviso":
            await FiltrarListado(objself,"ListadoMaestroTipoMotivosAviso"," CODIGO LIKE '%"+textoIntroducido+"%' OR ELEMENTO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroTipoTerreno":
            await FiltrarListado(objself,"ListadoMaestroTipoTerreno"," CODIGO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuOperacioneshr":
            await FiltrarListado(objself,"ListadoOperacioneshr"," COD_HR LIKE '%"+textoIntroducido+"%' OR CONT_HR LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroAgrupacionesTipeqstar":
            await FiltrarListado(objself,"ListadoMaestroAgrupacionesTipeqstar"," COD_TIP_EQSTAR LIKE '%"+textoIntroducido+"%' OR COD_TIP_EQUIPO_COMPATIBLE LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroExepcionesDatamatrix":
            await FiltrarListado(objself,"ListadoMaestroExepcionesDatamatrix"," COD_TIP_EQSTAR LIKE '%"+textoIntroducido+"%' OR COD_FAB_EQSTAR LIKE '%"+textoIntroducido+"%' OR COD_MOD_EQSTAR LIKE '%"+textoIntroducido+"%' OR DES_MOD_DATAMATRIX LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroTiposCierre":
            await FiltrarListado(objself,"ListadoMaestroTiposCierre"," COD_TIP_CIERRE LIKE '%"+textoIntroducido+"%' OR DES_CIERRE LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdaccion":
            await FiltrarListado(objself,"ListadoMaestroZdaccion"," CODIGO_FULL LIKE '%"+textoIntroducido+"%' OR DESCRIPCION_ACCIONES LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdactuacion":
            await FiltrarListado(objself,"ListadoMaestroZdactuacion"," GRUPO_TIPO_DE_INCIDENCIA LIKE '%"+textoIntroducido+"%' OR SUBGRUPO_TIPO_DE_INCIDENCIA LIKE '%"+textoIntroducido+"%' OR CODIGO_INCIDENCIA LIKE '%"+textoIntroducido+"%' OR ACTUACIONES LIKE '%"+textoIntroducido+"%' OR DESCRIPCION_ACTUACION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdcausastg":
            await FiltrarListado(objself,"ListadoMaestroZdcausastg"," CODIGO_CAUSA LIKE '%"+textoIntroducido+"%' OR CODIGO_TIPO_DE_DIAGNOSTICO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION_CAUSA LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdequsgt":
            await FiltrarListado(objself,"ListadoMaestroZdequsgt"," CODIGO_EQUIPO LIKE '%"+textoIntroducido+"%' OR CODIGO_TIPO_DE_DIAGNOSTICO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION_EQUIPO LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdgtipinc":
            await FiltrarListado(objself,"ListadoMaestroZdgtipinc"," GRUPO_TIPO_DE_INCIDENCIA LIKE '%"+textoIntroducido+"%' OR CLASE_ACTIVIDAD_ORDEN LIKE '%"+textoIntroducido+"%' OR CLASE_ORDEN LIKE '%"+textoIntroducido+"%' OR INDICADOR_ORDEN_PRIMER_O_SEGUNDO_NIVEL LIKE '%"+textoIntroducido+"%' OR DESCRIPCION_GRUPO_TIPO_INCIDENCIA LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdrelacDiagno":
            await FiltrarListado(objself,"ListadoMaestroZdrelacDiagno"," SOLUCION LIKE '%"+textoIntroducido+"%' OR CODIGO_TIPO_DE_DIAGNOSTICO LIKE '%"+textoIntroducido+"%' OR CODIGO_EQUIPO LIKE '%"+textoIntroducido+"%' OR CODIGO_CAUSA LIKE '%"+textoIntroducido+"%' OR CODIGO_SOLUCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdsglobal":
            await FiltrarListado(objself,"ListadoMaestroZdsglobal"," SOLUCION LIKE '%"+textoIntroducido+"%' OR DESCRIPCION_CODIGO_SOLUCION_GLOBAL LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdsgtipinc":
            await FiltrarListado(objself,"ListadoMaestroZdsgtipinc"," GRUPO_TIPO_INCIDENCIA LIKE '%"+textoIntroducido+"%' OR SUBGRUPO_TIPO_DE_INCIDENCIA LIKE '%"+textoIntroducido+"%' OR DESCRIPCION_SUBGRUPO_TIPO_INCIDENCIA LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdsolustg":
            await FiltrarListado(objself,"ListadoMaestroZdsolustg"," CODIGO_SOLUCION LIKE '%"+textoIntroducido+"%' OR CODIGO_TIPO_DE_DIAGNOSTICO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION_SOLUCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdtipinc":
            await FiltrarListado(objself,"ListadoMaestroZdtipinc"," GRUPO_TIPO_DE_INCIDENCIA LIKE '%"+textoIntroducido+"%' OR SUBGRUPO_TIPO_DE_INCIDENCIA LIKE '%"+textoIntroducido+"%' OR CODIGO_INCIDENCIA LIKE '%"+textoIntroducido+"%' OR DESCRIPCION_TIPO_INCIDENCIA LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdtipodiag":
            await FiltrarListado(objself,"ListadoMaestroZdtipodiag"," CODIGO_TIPO_DE_DIAGNOSTICO LIKE '%"+textoIntroducido+"%' OR DESCRIPCION_TIPO_DIAGNOSTICO LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuRelacionBrigadas":
            await FiltrarListado(objself,"ListadoRelacionBrigadas"," COD_BRIGADA_USU_EX LIKE '%"+textoIntroducido+"%' OR COD_BRIGADA_USU_IN LIKE '%"+textoIntroducido+"%' OR DESCRIPCION_EX LIKE '%"+textoIntroducido+"%' OR DESCRIPCION_IN LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroPropiedades":
            await FiltrarListado(objself,"ListadoMaestroPropiedades"," TABLA LIKE '%"+textoIntroducido+"%' OR PROPIEDAD LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroTipoFotos":
            await FiltrarListado(objself,"ListadoMaestroTipoFotos"," COD_TIPO_FOTO LIKE '%"+textoIntroducido+"%' OR TABLA LIKE '%"+textoIntroducido+"%' OR DESC_TIPO_FOTO LIKE '%"+textoIntroducido+"%' OR TIPO_DOCUMENTO LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroTrabtip":
            await FiltrarListado(objself,"ListadoMaestroTrabtip"," COD_TIP_TRAB LIKE '%"+textoIntroducido+"%' OR GRUPO LIKE '%"+textoIntroducido+"%' OR CODIGO  LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' OR CRITERIO LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdptpdc":
            await FiltrarListado(objself,"ListadoMaestroZdptpdc"," CLASE LIKE '%"+textoIntroducido+"%' OR VALOR LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdptda":
            await FiltrarListado(objself,"ListadoMaestroZdptda"," CLASE LIKE '%"+textoIntroducido+"%' OR VALOR LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroZdptca":
            await FiltrarListado(objself,"ListadoMaestroZdptca"," CLASE LIKE '%"+textoIntroducido+"%' OR VALOR LIKE '%"+textoIntroducido+"%' OR DESCRIPCION LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroRecEstados":
            await FiltrarListado(objself,"ListadoMaestroRecEstados"," COD_ESTADO LIKE '%"+textoIntroducido+"%' OR NOMBRE LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroDocumentacion":
            await FiltrarListado(objself,"ListadoMaestroDocumentacion"," CARPETA LIKE '%"+textoIntroducido+"%' OR CARPETA_PADRE LIKE '%"+textoIntroducido+"%' OR CODIGO_DOCUMENTO LIKE '%"+textoIntroducido+"%' OR TITULO_DOCUMENTO LIKE '%"+textoIntroducido+"%' OR CODIGO_ANEXO LIKE '%"+textoIntroducido+"%' OR TITULO_ANEXO LIKE '%"+textoIntroducido+"%' ");
            break;
        case "MenuMaestroListados":
            await FiltrarListado(objself,"ListadoMaestroListados"," ST_VALOR LIKE '%"+textoIntroducido+"%' OR ST_DESCRIPCION LIKE '%"+textoIntroducido+"%' OR TIPO LIKE '%"+textoIntroducido+"%' OR ORDEN LIKE '%"+textoIntroducido+"%'");
            break;
        case "MenuMaestroFormulario":
            await FiltrarListado(objself,"ListadoFormularios"," (gaa.COLECCION LIKE '%"+textoIntroducido+"%' OR gaa.TIPO_FORMULARIO LIKE '%"+textoIntroducido+"%') and gaa.BAJA=0");
            break;
        case "MenuTipoFormularios":
            await FiltrarListado(objself,"ListadoMaestroTipoFormulario","(TIPO_FORMULARIO LIKE '%"+textoIntroducido+"%' or DESCRIPCION LIKE '%"+textoIntroducido+"%') and BAJA=0");
            break;
        case "MenuITFMadrugada":
            await FiltrarListado(objself,"ListadoItfMadrugada","NOMBRE_TRANSFORM LIKE '%"+textoIntroducido+"%'");
            break;
            
        
        
    }
}

async function FiltrarMenus(objself){
    filtroMenu = textoIntroducido;
    // await FiltrarListado(objself,"WebMenuPadre","NIVEL=0 AND find_in_set('"+user.USERTYPE+"',PERMISOS)");
    await CargarOpciones(objself);
    
    ui.getView(objself).refresh();
}

async function FiltrarListado(objself,contentName,sfilter,sSort){
    var content = objself.getContents("@"+contentName);
    
    content.unlock();
    content.clear();
    
    try{
        ui.showWaitDialog();
        content.setFilter(sfilter);
        if(sSort){
            content.setSort(sSort);
        }
        await content.loadAll();
    }catch(e){
        ui.showToast("Ha ocurrido un error");
    }finally{
        ui.hideWaitDialog();
    }
    
    content.lock();
    // ui.getView(objself).refresh(contentName);
    
    let control = ui.getView(objself).getControl(contentName);
    if(control){
        control.refresh();
    }else{
        ui.getView(objself).refresh(contentName);
    }
}

async function FiltrarListadoPaginado(objself,contentName,sfilter){
    var page= {
        "start": objself.MAP_PAG_INI,
        "length": objself.MAP_PAG_LEN
    };
    var content = objself.getContents("@"+contentName);
    
    content.unlock();
    content.clear();
    
    try{
        content.setFilter(sfilter);
        await content.loadAll(false,page);
    }catch(e){
        ui.showToast("Ha ocurrido un error");
    }
    
    content.lock();
    ui.refresh(contentName);
}

async function obtenerestadoAnteriorOT(objself,filter,sort){
    // Función para obtener el estado anterior en una OT
    var coll = appData.getCollection("ListadoOtEstadosScript");
    var obj = null;
    coll.setFilter(filter);
    coll.setSort(sort);
    
    coll.unlock();
    coll.clear();
    await coll.loadAll();
    coll.lock();
    
    if(coll.getCount() > 0){
        obj = coll.getItem(0);
    }
    return obj;
}

async function PasarOtaAceptada(objself){
    ui.showWaitDialog();
    // Buscamos el estado anterior....
    var obj = null;
    var filter = "e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=0";
    
    var expediente = null;
    var buzon = null;
    var buzon2 = null;
    
    obj = await obtenerestadoAnteriorOT(objself,filter,"ID DESC");
    
    expediente = obj.EXPEDIENTE;
    buzon = obj.BUZON;
    buzon2 = obj.BUZON2;
    
    if(obj.EXPEDIENTE == null 
    || (obj.EXPEDIENTE != null && obj.EXPEDIENTE.length == 0)
    || obj.BUZON == null 
    || (obj.BUZON != null && obj.BUZON.length == 0)
    || obj.BUZON2 == null
    || (obj.BUZON2 != null && obj.BUZON2.length == 0)
    ){
        // buscamos estos datos de gen_usuarios_accesos
        var collUA = appData.getCollection("UltimoUsuariosAccesos");
        var objUA = null;
        collUA.setMacro("##DISPOSITIVO##",obj.DISPOSITIVO);
        
        collUA.unlock();
        collUA.clear();
        await collUA.loadAll();
        collUA.lock();
        
        if(collUA.getCount() > 0){
            objUA = collUA.getItem(0);
            /*
            objEstado.BUZON = user.MAP_NOMBRE_IFS.substring(user.MAP_NOMBRE_IFS.length-10);
            objEstado.BUZON2 = user.MAP_NOMBRE_IFS;
            */
            expediente = objUA.EXPEDIENTE;
            buzon = objUA.BUZON;
            buzon2 = objUA.NOMBRE_IFS;
        }
    }
    
    // var coll = appData.getCollection("ListadoOtEstados");
    // var obj = coll.findObject("e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=0");
    
    if(obj){
        var newObj = appData.getCollection("ListadoOtEstados").createObject();
        newObj.ESTADO = 1;
        newObj.NUMEROORDEN = objself.NUMEROORDEN;
        newObj.TASK_ID = objself.TASK_ID;
        newObj.DISPOSITIVO = obj.DISPOSITIVO;
        newObj.TEMPORAL_TASK_ID = obj.TEMPORAL_TASK_ID;
        var newDate = new Date();
        newObj.FECHA = newDate.getFullYear()+"-"+(newDate.getMonth()+1).toString().padStart(2,"0")+"-"+newDate.getDate().toString().padStart(2,"0")+" "+newDate.getHours().toString().padStart(2,"0")+":"+newDate.getMinutes().toString().padStart(2,"0")+":"+newDate.getSeconds().toString().padStart(2,"0");
        newObj.OWNER = "SistemaWeb";
        newObj.PROCESADO = 0;
        newObj.SISTEMA = obj.SISTEMA;
        newObj.EXPEDIENTE = expediente;
        newObj.BUZON = buzon;
        newObj.BUZON2 = buzon2;
        
        await newObj.save();
        
        await RegistrarAccionUsuario("Cambio de estado","gen_ot_estados",obtenerRowId("ListadoOtEstados",newObj.ID,"e."));
        
        objself.MAP_ESTADO = 1;
        // ui.refresh("ListadoOtEstados,MAP_ACEPTAR,MAP_EN_VIAJE,MAP_EN_EJECUCION,MAP_FINALIZADA,MAP_NOTIFICADA,MAP_EN_INTERRUMPIR,MAP_EN_RECHAZAR,MAP_FINALIZAR_COLABORACION");
        
        let control = ui.getView(objself).getControl("ListadoOtEstados");
        if(control){
            control.refresh();
        }
        
        await refrescarListado(objself,'ListadoOtEstados');
        await onEditorAction(objself.MAP_PARENT);
        
        ui.showToast("Acción realizada con exito.");
    }else{
        ui.showToast("No se pudo realizar la acción.");
    }
    ui.hideWaitDialog();
    
}

async function PasarOtaEnViaje(objself){
    ui.showWaitDialog();
    // Buscamos el estado anterior....
    var obj = null;
    var filter = "e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=0";
    
    var expediente = null;
    var buzon = null;
    var buzon2 = null;
    
    obj = await obtenerestadoAnteriorOT(objself,filter,"ID DESC");
    
    expediente = obj.EXPEDIENTE;
    buzon = obj.BUZON;
    buzon2 = obj.BUZON2;
    
    if(obj.EXPEDIENTE == null 
    || (obj.EXPEDIENTE != null && obj.EXPEDIENTE.length == 0)
    || obj.BUZON == null 
    || (obj.BUZON != null && obj.BUZON.length == 0)
    || obj.BUZON2 == null
    || (obj.BUZON2 != null && obj.BUZON2.length == 0)
    ){
        // buscamos estos datos de gen_usuarios_accesos
        var collUA = appData.getCollection("UltimoUsuariosAccesos");
        var objUA = null;
        collUA.setMacro("##DISPOSITIVO##",obj.DISPOSITIVO);
        
        collUA.unlock();
        collUA.clear();
        await collUA.loadAll();
        collUA.lock();
        
        if(collUA.getCount() > 0){
            objUA = collUA.getItem(0);
            /*
            objEstado.BUZON = user.MAP_NOMBRE_IFS.substring(user.MAP_NOMBRE_IFS.length-10);
            objEstado.BUZON2 = user.MAP_NOMBRE_IFS;
            */
            expediente = objUA.EXPEDIENTE;
            buzon = objUA.BUZON;
            buzon2 = objUA.NOMBRE_IFS;
        }
    }
    // var coll = appData.getCollection("ListadoOtEstados");
    // var obj = coll.findObject("e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=0");
    
    if(obj){
        var newObj = appData.getCollection("ListadoOtEstados").createObject();
        newObj.ESTADO = 2;
        newObj.NUMEROORDEN = objself.NUMEROORDEN;
        newObj.TASK_ID = objself.TASK_ID;
        newObj.DISPOSITIVO = obj.DISPOSITIVO;
        newObj.TEMPORAL_TASK_ID = obj.TEMPORAL_TASK_ID;
        var newDate = new Date();
        newObj.FECHA = newDate.getFullYear()+"-"+(newDate.getMonth()+1).toString().padStart(2,"0")+"-"+newDate.getDate().toString().padStart(2,"0")+" "+newDate.getHours().toString().padStart(2,"0")+":"+newDate.getMinutes().toString().padStart(2,"0")+":"+newDate.getSeconds().toString().padStart(2,"0");
        newObj.OWNER = "SistemaWeb";
        newObj.PROCESADO = 0;
        newObj.SISTEMA = obj.SISTEMA;
        newObj.EXPEDIENTE = expediente;
        newObj.BUZON = buzon;
        newObj.BUZON2 = buzon2;
        
        await newObj.save();
        
        await GuardarCalculoHoras(objself,2,newObj.FECHA,newObj);
        
        await RegistrarAccionUsuario("Cambio de estado","gen_ot_estados",obtenerRowId("ListadoOtEstados",newObj.ID,"e."));
        
        objself.MAP_ESTADO = 2;
        // ui.refresh("ListadoOtEstados,MAP_ACEPTAR,MAP_EN_VIAJE,MAP_EN_EJECUCION,MAP_FINALIZADA,MAP_NOTIFICADA,MAP_EN_INTERRUMPIR,MAP_EN_RECHAZAR,MAP_FINALIZAR_COLABORACION");
        
        let control = ui.getView(objself).getControl("ListadoOtEstados");
        if(control){
            control.refresh();
        }
        
        await refrescarListado(objself,'ListadoOtEstados');
        await onEditorAction(objself.MAP_PARENT);
        
        ui.showToast("Acción realizada con exito.");
    }else{
        ui.showToast("No se pudo realizar la acción.");
    }
    ui.hideWaitDialog();
}

async function PasarOtaEnEjecucion(objself){
    ui.showWaitDialog();
    // Buscamos el estado anterior....
    var obj = null;
    var filter = "e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=0";
    
    var expediente = null;
    var buzon = null;
    var buzon2 = null;
    
    obj = await obtenerestadoAnteriorOT(objself,filter,"ID DESC");
    
    expediente = obj.EXPEDIENTE;
    buzon = obj.BUZON;
    buzon2 = obj.BUZON2;
    
    if(obj.EXPEDIENTE == null 
    || (obj.EXPEDIENTE != null && obj.EXPEDIENTE.length == 0)
    || obj.BUZON == null 
    || (obj.BUZON != null && obj.BUZON.length == 0)
    || obj.BUZON2 == null
    || (obj.BUZON2 != null && obj.BUZON2.length == 0)
    ){
        // buscamos estos datos de gen_usuarios_accesos
        var collUA = appData.getCollection("UltimoUsuariosAccesos");
        var objUA = null;
        collUA.setMacro("##DISPOSITIVO##",obj.DISPOSITIVO);
        
        collUA.unlock();
        collUA.clear();
        await collUA.loadAll();
        collUA.lock();
        
        if(collUA.getCount() > 0){
            objUA = collUA.getItem(0);
            /*
            objEstado.BUZON = user.MAP_NOMBRE_IFS.substring(user.MAP_NOMBRE_IFS.length-10);
            objEstado.BUZON2 = user.MAP_NOMBRE_IFS;
            */
            expediente = objUA.EXPEDIENTE;
            buzon = objUA.BUZON;
            buzon2 = objUA.NOMBRE_IFS;
        }
    }
    
    // var coll = appData.getCollection("ListadoOtEstados");
    // var obj = coll.findObject("e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=0");
    
    if(obj){
        var newObj = appData.getCollection("ListadoOtEstados").createObject();
        newObj.ESTADO = 3;
        newObj.NUMEROORDEN = objself.NUMEROORDEN;
        newObj.TASK_ID = objself.TASK_ID;
        newObj.DISPOSITIVO = obj.DISPOSITIVO;
        newObj.TEMPORAL_TASK_ID = obj.TEMPORAL_TASK_ID;
        var newDate = new Date();
        newObj.FECHA = newDate.getFullYear()+"-"+(newDate.getMonth()+1).toString().padStart(2,"0")+"-"+newDate.getDate().toString().padStart(2,"0")+" "+newDate.getHours().toString().padStart(2,"0")+":"+newDate.getMinutes().toString().padStart(2,"0")+":"+newDate.getSeconds().toString().padStart(2,"0");
        newObj.OWNER = "SistemaWeb";
        newObj.PROCESADO = 0;
        newObj.SISTEMA = obj.SISTEMA;
        newObj.EXPEDIENTE = expediente;
        newObj.BUZON = buzon;
        newObj.BUZON2 = buzon2;
        
        // calculo de horas ...
        let CollUltimoEstado = appData.getCollection("IHObtenerUltimoEstado");
        let estadoAnterior = null;
        
        CollUltimoEstado.setMacro("##TASK_ID##",newObj.TASK_ID);
        let temporalTaskId = (newObj.TEMPORAL_TASK_ID == null || newObj.TEMPORAL_TASK_ID.length == 0) ? "-" : newObj.TEMPORAL_TASK_ID;
        CollUltimoEstado.setMacro("##TEMPORAL_TASK_ID##",temporalTaskId);
        CollUltimoEstado.clear();
        await CollUltimoEstado.loadAll();
        if(CollUltimoEstado.getCount()>0){
            estadoAnterior = CollUltimoEstado.getItem(0);
        }
        
        if(estadoAnterior){
            await GuardarCalculoHoras(objself,2,estadoAnterior.FECHA,estadoAnterior);
        }
        await newObj.save();
        
        await RegistrarAccionUsuario("Cambio de estado","gen_ot_estados",obtenerRowId("ListadoOtEstados",newObj.ID,"e."));
        
        objself.MAP_ESTADO = 3;
        // ui.refresh("ListadoOtEstados,MAP_ACEPTAR,MAP_EN_VIAJE,MAP_EN_EJECUCION,MAP_FINALIZADA,MAP_NOTIFICADA,MAP_EN_INTERRUMPIR,MAP_EN_RECHAZAR,MAP_FINALIZAR_COLABORACION");
        
        let control = ui.getView(objself).getControl("ListadoOtEstados");
        if(control){
            control.refresh();
        }
        
        await refrescarListado(objself,'ListadoOtEstados');
        await onEditorAction(objself.MAP_PARENT);
        
        ui.showToast("Acción realizada con exito.");
    }else{
        ui.showToast("No se pudo realizar la acción.");
    }
    ui.hideWaitDialog();
}

async function PasarOtaNotificada(objself){
    ui.showWaitDialog();
    // Buscamos el estado anterior....
    var obj = null;
    var filter = "e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=4";
    
    var expediente = null;
    var buzon = null;
    var buzon2 = null;
    
    obj = await obtenerestadoAnteriorOT(objself,filter,"ID DESC");
    
    expediente = obj.EXPEDIENTE;
    buzon = obj.BUZON;
    buzon2 = obj.BUZON2;
    
    if(obj.EXPEDIENTE == null 
    || (obj.EXPEDIENTE != null && obj.EXPEDIENTE.length == 0)
    || obj.BUZON == null 
    || (obj.BUZON != null && obj.BUZON.length == 0)
    || obj.BUZON2 == null
    || (obj.BUZON2 != null && obj.BUZON2.length == 0)
    ){
        // buscamos estos datos de gen_usuarios_accesos
        var collUA = appData.getCollection("UltimoUsuariosAccesos");
        var objUA = null;
        collUA.setMacro("##DISPOSITIVO##",obj.DISPOSITIVO);
        
        collUA.unlock();
        collUA.clear();
        await collUA.loadAll();
        collUA.lock();
        
        if(collUA.getCount() > 0){
            objUA = collUA.getItem(0);
            /*
            objEstado.BUZON = user.MAP_NOMBRE_IFS.substring(user.MAP_NOMBRE_IFS.length-10);
            objEstado.BUZON2 = user.MAP_NOMBRE_IFS;
            */
            expediente = objUA.EXPEDIENTE;
            buzon = objUA.BUZON;
            buzon2 = objUA.NOMBRE_IFS;
        }
    }
    
    if(obj){
        var newObj = appData.getCollection("ListadoOtEstados").createObject();
        newObj.ESTADO = 5;
        newObj.NUMEROORDEN = objself.NUMEROORDEN;
        newObj.TASK_ID = objself.TASK_ID;
        newObj.DISPOSITIVO = obj.DISPOSITIVO;
        newObj.TEMPORAL_TASK_ID = obj.TEMPORAL_TASK_ID;
        var newDate = new Date();
        newObj.FECHA = newDate.getFullYear()+"-"+(newDate.getMonth()+1).toString().padStart(2,"0")+"-"+newDate.getDate().toString().padStart(2,"0")+" "+newDate.getHours().toString().padStart(2,"0")+":"+newDate.getMinutes().toString().padStart(2,"0")+":"+newDate.getSeconds().toString().padStart(2,"0");
        newObj.OWNER = "SistemaWeb";
        newObj.PROCESADO = 1;
        newObj.SISTEMA = obj.SISTEMA;
        newObj.EXPEDIENTE = expediente;
        newObj.BUZON = buzon;
        newObj.BUZON2 = buzon2;
        
        await newObj.save();
        
        await RegistrarAccionUsuario("Cambio de estado","gen_ot_estados",obtenerRowId("ListadoOtEstados",newObj.ID,"e."));
        
        objself.MAP_ESTADO = 5;
        // ui.refresh("ListadoOtEstados,MAP_ACEPTAR,MAP_EN_VIAJE,MAP_EN_EJECUCION,MAP_FINALIZADA,MAP_NOTIFICADA,MAP_EN_INTERRUMPIR,MAP_EN_RECHAZAR,MAP_FINALIZAR_COLABORACION");
        
        let control = ui.getView(objself).getControl("ListadoOtEstados");
        if(control){
            control.refresh();
        }
        
        await refrescarListado(objself,'ListadoOtEstados');
        await onEditorAction(objself.MAP_PARENT);
        
        ui.showToast("Acción realizada con exito.");
    }else{
        ui.showToast("No se pudo realizar la acción.");
    }
    ui.hideWaitDialog();
}

async function PasarOtaFinalizada(objself){
    ui.showWaitDialog();
    // Buscamos el estado anterior....
    var obj = null;
    var filter = "e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=0";
    
    var expediente = null;
    var buzon = null;
    var buzon2 = null;
    
    obj = await obtenerestadoAnteriorOT(objself,filter,"ID DESC");
    
    expediente = obj.EXPEDIENTE;
    buzon = obj.BUZON;
    buzon2 = obj.BUZON2;
    
    if(obj.EXPEDIENTE == null 
    || (obj.EXPEDIENTE != null && obj.EXPEDIENTE.length == 0)
    || obj.BUZON == null 
    || (obj.BUZON != null && obj.BUZON.length == 0)
    || obj.BUZON2 == null
    || (obj.BUZON2 != null && obj.BUZON2.length == 0)
    ){
        // buscamos estos datos de gen_usuarios_accesos
        var collUA = appData.getCollection("UltimoUsuariosAccesos");
        var objUA = null;
        collUA.setMacro("##DISPOSITIVO##",obj.DISPOSITIVO);
        
        collUA.unlock();
        collUA.clear();
        await collUA.loadAll();
        collUA.lock();
        
        if(collUA.getCount() > 0){
            objUA = collUA.getItem(0);
            /*
            objEstado.BUZON = user.MAP_NOMBRE_IFS.substring(user.MAP_NOMBRE_IFS.length-10);
            objEstado.BUZON2 = user.MAP_NOMBRE_IFS;
            */
            expediente = objUA.EXPEDIENTE;
            buzon = objUA.BUZON;
            buzon2 = objUA.NOMBRE_IFS;
        }
    }
    
    // var coll = appData.getCollection("ListadoOtEstados");
    // var obj = coll.findObject("e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=0");
    
    if(obj){
        var newObj = appData.getCollection("ListadoOtEstados").createObject();
        newObj.ESTADO = 4;
        newObj.NUMEROORDEN = objself.NUMEROORDEN;
        newObj.TASK_ID = objself.TASK_ID;
        newObj.DISPOSITIVO = obj.DISPOSITIVO;
        newObj.TEMPORAL_TASK_ID = obj.TEMPORAL_TASK_ID;
        var newDate = new Date();
        newObj.FECHA = newDate.getFullYear()+"-"+(newDate.getMonth()+1).toString().padStart(2,"0")+"-"+newDate.getDate().toString().padStart(2,"0")+" "+newDate.getHours().toString().padStart(2,"0")+":"+newDate.getMinutes().toString().padStart(2,"0")+":"+newDate.getSeconds().toString().padStart(2,"0");
        newObj.OWNER = "SistemaWeb";
        newObj.PROCESADO = 0;
        newObj.SISTEMA = obj.SISTEMA;
        newObj.EXPEDIENTE = expediente;
        newObj.BUZON = buzon;
        newObj.BUZON2 = buzon2;
        
        // calculo de horas ...
        let CollUltimoEstado = appData.getCollection("IHObtenerUltimoEstado");
        let estadoAnterior = null;
        
        CollUltimoEstado.setMacro("##TASK_ID##",newObj.TASK_ID);
        let temporalTaskId = (newObj.TEMPORAL_TASK_ID == null || newObj.TEMPORAL_TASK_ID.length == 0) ? "-" : newObj.TEMPORAL_TASK_ID;
        CollUltimoEstado.setMacro("##TEMPORAL_TASK_ID##",temporalTaskId);
        CollUltimoEstado.clear();
        await CollUltimoEstado.loadAll();
        if(CollUltimoEstado.getCount()>0){
            estadoAnterior = CollUltimoEstado.getItem(0);
        }
        
        if(estadoAnterior){
            await GuardarCalculoHoras(objself,3,estadoAnterior.FECHA,estadoAnterior);
        }
        await newObj.save();
        
        await RegistrarAccionUsuario("Cambio de estado","gen_ot_estados",obtenerRowId("ListadoOtEstados",newObj.ID,"e."));
        
        objself.MAP_ESTADO = 4;
        // ui.refresh("ListadoOtEstados,MAP_ACEPTAR,MAP_EN_VIAJE,MAP_EN_EJECUCION,MAP_FINALIZADA,MAP_NOTIFICADA,MAP_EN_INTERRUMPIR,MAP_EN_RECHAZAR,MAP_FINALIZAR_COLABORACION");
        
        let control = ui.getView(objself).getControl("ListadoOtEstados");
        if(control){
            control.refresh();
        }
        
        await refrescarListado(objself,'ListadoOtEstados');
        await onEditorAction(objself.MAP_PARENT);
        
        ui.showToast("Acción realizada con exito.");
    }else{
        ui.showToast("No se pudo realizar la acción.");
    }
    ui.hideWaitDialog();
}

async function PasarOtaRechazada(objself){
    ui.showWaitDialog();
    if(objself.MAP_COD_MOTIVO_RECHAZO == 0){
        ui.showToast("Indique un motivo de rechazo");
        return;
    }
    
    // Buscamos el estado anterior....
    var obj = null;
    var filter = "e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=" + objself.MAP_ESTADO;
    
    var expediente = null;
    var buzon = null;
    var buzon2 = null;
    
    obj = await obtenerestadoAnteriorOT(objself,filter,"ID DESC");
    
    expediente = obj.EXPEDIENTE;
    buzon = obj.BUZON;
    buzon2 = obj.BUZON2;
    
    if(obj.EXPEDIENTE == null 
    || (obj.EXPEDIENTE != null && obj.EXPEDIENTE.length == 0)
    || obj.BUZON == null 
    || (obj.BUZON != null && obj.BUZON.length == 0)
    || obj.BUZON2 == null
    || (obj.BUZON2 != null && obj.BUZON2.length == 0)
    ){
        // buscamos estos datos de gen_usuarios_accesos
        var collUA = appData.getCollection("UltimoUsuariosAccesos");
        var objUA = null;
        collUA.setMacro("##DISPOSITIVO##",obj.DISPOSITIVO);
        
        collUA.unlock();
        collUA.clear();
        await collUA.loadAll();
        collUA.lock();
        
        if(collUA.getCount() > 0){
            objUA = collUA.getItem(0);
            /*
            objEstado.BUZON = user.MAP_NOMBRE_IFS.substring(user.MAP_NOMBRE_IFS.length-10);
            objEstado.BUZON2 = user.MAP_NOMBRE_IFS;
            */
            expediente = objUA.EXPEDIENTE;
            buzon = objUA.BUZON;
            buzon2 = objUA.NOMBRE_IFS;
        }
    }
    // var coll = appData.getCollection("ListadoOtEstados");
    // var obj = coll.findObject("e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=" + objself.MAP_ESTADO);
    
    if(obj){
        var newObj = appData.getCollection("ListadoOtEstados").createObject();
        newObj.ESTADO = -1;
        newObj.NUMEROORDEN = objself.NUMEROORDEN;
        newObj.TASK_ID = objself.TASK_ID;
        newObj.DISPOSITIVO = obj.DISPOSITIVO;
        newObj.TEMPORAL_TASK_ID = obj.TEMPORAL_TASK_ID;
        var newDate = new Date();
        newObj.FECHA = newDate.getFullYear()+"-"+(newDate.getMonth()+1).toString().padStart(2,"0")+"-"+newDate.getDate().toString().padStart(2,"0")+" "+newDate.getHours().toString().padStart(2,"0")+":"+newDate.getMinutes().toString().padStart(2,"0")+":"+newDate.getSeconds().toString().padStart(2,"0");
        newObj.OWNER = "SistemaWeb";
        newObj.PROCESADO = 0;
        newObj.SISTEMA = obj.SISTEMA;
        newObj.EXPEDIENTE = expediente;
        newObj.BUZON = buzon;
        newObj.BUZON2 = buzon2;
        newObj.CODIGO_RECHAZO = objself.MAP_COD_MOTIVO_RECHAZO;
        newObj.AUTOASIGNADA = "S"
        
        if(objself.MAP_COD_MOTIVO_RECHAZO == 6){
            var newFechaR = objself.MAP_DESPUES_DE;
            newObj.FECHA_REANUDACION = newFechaR.getFullYear()+"-"+(newFechaR.getMonth()+1).toString().padStart(2,"0")+"-"+newFechaR.getDate().toString().padStart(2,"0")+" "+newFechaR.getHours().toString().padStart(2,"0")+":"+newFechaR.getMinutes().toString().padStart(2,"0")+":"+newFechaR.getSeconds().toString().padStart(2,"0");
        }
        
        await newObj.save();
        
        await RegistrarAccionUsuario("Cambio de estado","gen_ot_estados",obtenerRowId("ListadoOtEstados",newObj.ID,"e."));
        
        objself.MAP_ESTADO = -1;
        // ui.refresh("ListadoOtEstados,MAP_ACEPTAR,MAP_EN_VIAJE,MAP_EN_EJECUCION,MAP_FINALIZADA,MAP_NOTIFICADA,MAP_EN_INTERRUMPIR,MAP_EN_RECHAZAR,MAP_FINALIZAR_COLABORACION");
        
        let control = ui.getView(objself).getControl("ListadoOtEstados");
        if(control){
            control.refresh();
        }
        
        await refrescarListado(objself,'ListadoOtEstados');
        await onEditorAction(objself.MAP_PARENT);
        
        ui.showToast("Acción realizada con exito.");
        self.MAP_COD_MOTIVO_RECHAZO = 0;
        self.MAP_MOSTRAR_FLOTANTE_RECHAZAR = 0;
    }else{
        ui.showToast("No se pudo realizar la acción.");
        self.MAP_COD_MOTIVO_RECHAZO = 0;
        self.MAP_MOSTRAR_FLOTANTE_RECHAZAR = 0;
    }
    ui.hideWaitDialog();
}

async function PasarOtaFinColaboracion(objself){
    ui.showWaitDialog();
    
    // Buscamos el estado anterior....
    var obj = null;
    var filter = "e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=" + objself.MAP_ESTADO;
    
    var expediente = null;
    var buzon = null;
    var buzon2 = null;
    
    obj = await obtenerestadoAnteriorOT(objself,filter,"ID DESC");
    
    expediente = obj.EXPEDIENTE;
    buzon = obj.BUZON;
    buzon2 = obj.BUZON2;
    
    if(obj.EXPEDIENTE == null 
    || (obj.EXPEDIENTE != null && obj.EXPEDIENTE.length == 0)
    || obj.BUZON == null 
    || (obj.BUZON != null && obj.BUZON.length == 0)
    || obj.BUZON2 == null
    || (obj.BUZON2 != null && obj.BUZON2.length == 0)
    ){
        // buscamos estos datos de gen_usuarios_accesos
        var collUA = appData.getCollection("UltimoUsuariosAccesos");
        var objUA = null;
        collUA.setMacro("##DISPOSITIVO##",obj.DISPOSITIVO);
        
        collUA.unlock();
        collUA.clear();
        await collUA.loadAll();
        collUA.lock();
        
        if(collUA.getCount() > 0){
            objUA = collUA.getItem(0);
            /*
            objEstado.BUZON = user.MAP_NOMBRE_IFS.substring(user.MAP_NOMBRE_IFS.length-10);
            objEstado.BUZON2 = user.MAP_NOMBRE_IFS;
            */
            expediente = objUA.EXPEDIENTE;
            buzon = objUA.BUZON;
            buzon2 = objUA.NOMBRE_IFS;
        }
    }
    // var coll = appData.getCollection("ListadoOtEstados");
    // var obj = coll.findObject("e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=" + objself.MAP_ESTADO);
    
    if(obj){
        var newObj = appData.getCollection("ListadoOtEstados").createObject();
        newObj.ESTADO = 7;
        newObj.NUMEROORDEN = objself.NUMEROORDEN;
        newObj.TASK_ID = objself.TASK_ID;
        newObj.DISPOSITIVO = obj.DISPOSITIVO;
        newObj.TEMPORAL_TASK_ID = obj.TEMPORAL_TASK_ID;
        var newDate = new Date();
        newObj.FECHA = newDate.getFullYear()+"-"+(newDate.getMonth()+1).toString().padStart(2,"0")+"-"+newDate.getDate().toString().padStart(2,"0")+" "+newDate.getHours().toString().padStart(2,"0")+":"+newDate.getMinutes().toString().padStart(2,"0")+":"+newDate.getSeconds().toString().padStart(2,"0");
        newObj.OWNER = "SistemaWeb";
        newObj.PROCESADO = 0;
        newObj.SISTEMA = obj.SISTEMA;
        newObj.EXPEDIENTE = expediente;
        newObj.BUZON = buzon;
        newObj.BUZON2 = buzon2;
        
        await newObj.save();
        
        await RegistrarAccionUsuario("Cambio de estado","gen_ot_estados",obtenerRowId("ListadoOtEstados",newObj.ID,"e."));
        
        objself.MAP_ESTADO = 7;
        // ui.refresh("ListadoOtEstados,MAP_ACEPTAR,MAP_EN_VIAJE,MAP_EN_EJECUCION,MAP_FINALIZADA,MAP_NOTIFICADA,MAP_EN_INTERRUMPIR,MAP_EN_RECHAZAR,MAP_FINALIZAR_COLABORACION");
        
        let control = ui.getView(objself).getControl("ListadoOtEstados");
        if(control){
            control.refresh();
        }
        
        await refrescarListado(objself,'ListadoOtEstados');
        await onEditorAction(objself.MAP_PARENT);
        
        ui.showToast("Acción realizada con exito.");
    }else{
        ui.showToast("No se pudo realizar la acción.");
    }
    ui.hideWaitDialog();
}

async function PasarOtaInterrumpida(objself){
    ui.showWaitDialog();
    if(objself.MAP_COD_MOTIVO_INTERRUPCION == 0){
        ui.showToast("Indique un motivo de interrupción");
        return;
    }
    
    if(objself.MAP_TIEMPO_ESTIMADO <= 0){
        ui.showToast("Indique un tiempo estimado");
        return;
    }
    var obj = null;
    var filter = "e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=" + objself.MAP_ESTADO;
    
    var expediente = null;
    var buzon = null;
    var buzon2 = null;
    
    // buscamos el objeto con el estado anterior
    obj = await obtenerestadoAnteriorOT(objself,filter,"ID DESC");
    
    expediente = obj.EXPEDIENTE;
    buzon = obj.BUZON;
    buzon2 = obj.BUZON2;
    
    if(obj.EXPEDIENTE == null 
    || (obj.EXPEDIENTE != null && obj.EXPEDIENTE.length == 0)
    || obj.BUZON == null 
    || (obj.BUZON != null && obj.BUZON.length == 0)
    || obj.BUZON2 == null
    || (obj.BUZON2 != null && obj.BUZON2.length == 0)
    ){
        // buscamos estos datos de gen_usuarios_accesos
        var collUA = appData.getCollection("UltimoUsuariosAccesos");
        var objUA = null;
        collUA.setMacro("##DISPOSITIVO##",obj.DISPOSITIVO);
        
        collUA.unlock();
        collUA.clear();
        await collUA.loadAll();
        collUA.lock();
        
        if(collUA.getCount() > 0){
            objUA = collUA.getItem(0);
            /*
            objEstado.BUZON = user.MAP_NOMBRE_IFS.substring(user.MAP_NOMBRE_IFS.length-10);
            objEstado.BUZON2 = user.MAP_NOMBRE_IFS;
            */
            expediente = objUA.EXPEDIENTE;
            buzon = objUA.BUZON;
            buzon2 = objUA.NOMBRE_IFS;
        }
    }
    
    // var coll = appData.getCollection("ListadoOtEstados");
    // var obj = null;
    // var obj = coll.findObject("e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=" + objself.MAP_ESTADO);
    // coll.setFilter("e.NUMEROORDEN='"+objself.NUMEROORDEN+"' AND e.TASK_ID='"+objself.TASK_ID+"' AND e.ESTADO=" + objself.MAP_ESTADO);
    // coll.setSort("ID DESC");
    
    // coll.unlock();
    // coll.clear();
    // await coll.loadAll();
    // coll.lock();
    
    // if(coll.getCount() > 0){
    //     obj = coll.getItem(0);
    // }
    
    if(obj){
        var newObj = appData.getCollection("ListadoOtEstados").createObject();
        newObj.ESTADO = -3;
        newObj.NUMEROORDEN = objself.NUMEROORDEN;
        newObj.TASK_ID = objself.TASK_ID;
        newObj.DISPOSITIVO = obj.DISPOSITIVO;
        newObj.TEMPORAL_TASK_ID = obj.TEMPORAL_TASK_ID;
        var newDate = new Date();
        newObj.FECHA = newDate.getFullYear()+"-"+(newDate.getMonth()+1).toString().padStart(2,"0")+"-"+newDate.getDate().toString().padStart(2,"0")+" "+newDate.getHours().toString().padStart(2,"0")+":"+newDate.getMinutes().toString().padStart(2,"0")+":"+newDate.getSeconds().toString().padStart(2,"0");
        newObj.OWNER = "SistemaWeb";
        newObj.PROCESADO = 0;
        newObj.SISTEMA = obj.SISTEMA;
        newObj.EXPEDIENTE = expediente;
        newObj.BUZON = buzon;
        newObj.BUZON2 = buzon2;
        newObj.CODIGO_INTERRUPCION = objself.MAP_COD_MOTIVO_INTERRUPCION;
        newObj.AUTOASIGNADA = "N";
        newObj.TIEMPO_RESTANTE = objself.MAP_TIEMPO_ESTIMADO;
        
        if(objself.MAP_COD_MOTIVO_INTERRUPCION != 3){
            var newFechaR = objself.MAP_DESPUES_DE_IN;
            newObj.FECHA_REANUDACION = newFechaR.getFullYear()+"-"+(newFechaR.getMonth()+1).toString().padStart(2,"0")+"-"+newFechaR.getDate().toString().padStart(2,"0")+" "+newFechaR.getHours().toString().padStart(2,"0")+":"+newFechaR.getMinutes().toString().padStart(2,"0")+":"+newFechaR.getSeconds().toString().padStart(2,"0");
        }
        
        if(objself.MAP_COD_MOTIVO_INTERRUPCION < 4){
            newObj.OBSERVACION = objself.MAP_OBSERVACIONES_I;
        }
        
        await newObj.save();
        
        await RegistrarAccionUsuario("Cambio de estado","gen_ot_estados",newObj.ROWID);
        
        objself.MAP_ESTADO = -3;
        // ui.refresh("ListadoOtEstados,MAP_ACEPTAR,MAP_EN_VIAJE,MAP_EN_EJECUCION,MAP_FINALIZADA,MAP_NOTIFICADA,MAP_EN_INTERRUMPIR,MAP_EN_RECHAZAR,MAP_FINALIZAR_COLABORACION");
        
        let control = ui.getView(objself).getControl("ListadoOtEstados");
        if(control){
            control.refresh();
        }
        
        await refrescarListado(objself,'ListadoOtEstados');
        await onEditorAction(objself.MAP_PARENT);
        
        ui.showToast("Acción realizada con exito.");
        
        self.MAP_COD_MOTIVO_INTERRUPCION = 0;
        self.MAP_MOSTRAR_FLOTANTE_INTERRUPCION = 0;
    }else{
        ui.showToast("No se pudo realizar la acción.");
        self.MAP_COD_MOTIVO_INTERRUPCION = 0;
        self.MAP_MOSTRAR_FLOTANTE_INTERRUPCION = 0;
    }
    ui.hideWaitDialog();
}

function ObtenerSiguienteDiaLaborable(){
    var current_date = new Date();
    current_date = new Date(current_date.setDate(current_date.getDate()+1));
    if(current_date.getDay() == 6){
        current_date = new Date(current_date.setDate(current_date.getDate()+2));
    }
    current_date = new Date(current_date.getFullYear(),current_date.getMonth(),current_date.getDate(),7,0,0); 
    return current_date;
}


async function CrearObjetoContent(contentName){
    let obj = self.getContents("@"+contentName).createObject();
    if(obj) {
        appData.pushValue(obj);
    }
}

function OnChangeCamposContent(objself,campo){
    if(objself[campo] != objself["MAP_"+campo]){
        objself.MAP_MODIFICADO = 1;
        objself.MAP_BGCOLOR = "#d4e3cc";
    }else{
        objself.MAP_MODIFICADO = 0;
        objself.MAP_BGCOLOR = "#ffffff";
    }
}

async function AplicarCambiosListado(contentName,onSaveData,borradoLogico){
    let hayDelete = false;
    let borrados = [];
    let content = self.getContents("@"+contentName);
    for(let i=0; i < content.getCount();i++){
        let item = content.getItem(i);
        if(item.MAP_MODIFICADO==1){
            onSaveData(item);
            
            await RegistrarAccionUsuario("Actualizado datos",contentName,item.ROWID);
            
            await item.save();
        }
        
        if(item.MAP_BAJA == 1){
            hayDelete = true;
            borrados.push(item);
        }
    }
    
    if(hayDelete){
        let a = ui.msgBox("¿Está seguro que desea borrar los registros seleccionados?","¡ATENCION!",1);
  		if ( a == 1){
  		    for(let i=0; i < borrados.length;i++){
  		        if(!borradoLogico){
                    await RegistrarAccionUsuario("Borrado físico registro",contentName,borrados[i].ROWID);
			        borrados[i].deleteObject();
  		        }else{
                    await RegistrarAccionUsuario("Borrado lógico registro",contentName,borrados[i].ROWID);
  		            borrados[i].BAJA = 1;
  		            borrados[i].save();
  		        }
  		    }
        }
    }
    
    content.unlock();
    content.clear();
    await content.loadAll();
    content.lock();
    
    ui.refresh(contentName);
}

function onSaveDataAnMotivosAnulacion(item){
    item.COD_TIPO_ANULACION = item.MAP_COD_TIPO_ANULACION;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}

function onSaveDataAnTipoAnomalia(item){
    item.ID_TIPO_ANOM = item.MAP_ID_TIPO_ANOM.toString().padStart(18, '0');
    item.DESC_TIPO_ANOM = item.MAP_DESC_TIPO_ANOM;
    item.COD_ESTADO = item.MAP_COD_ESTADO;
    item.IND_NECESITA_DISTANCIA = item.MAP_IND_NECESITA_DISTANCIA;
    item.LISTA_ROLES = item.MAP_LISTA_ROLES;
}
function onSaveDataAnTipoFoto(item){
    item.COD_TIPO_FOTO = item.MAP_COD_TIPO_FOTO;
    item.COD_TIPO_ANOM = item.MAP_COD_TIPO_ANOM;
    item.DESC_TIPO_FOTO = item.MAP_DESC_TIPO_FOTO;
    item.IND_OBLIG = item.MAP_IND_OBLIG;
}
function onSaveDataArMaestroRiesgo(item){
    item.COD_TIP_ACCION = item.MAP_COD_TIP_ACCION;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaestroTipoFormulario(item){
    item.TIPO_FORMULARIO = item.MAP_TIPO_FORMULARIO;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaCapaElemento(item){
    item.ELEMENTO = item.MAP_ELEMENTO;
    item.FNO = item.MAP_FNO;
    item.EN_MAPA = item.MAP_EN_MAPA;
    item.EN_INVENTARIO = item.MAP_EN_INVENTARIO;
    item.TABLA = item.MAP_TABLA;
    item.MIN_ZOOM = item.MAP_MIN_ZOOM;
    item.MAX_ZOOM = item.MAP_MAX_ZOOM;
}
function onSaveDataMaestroClaseActividad(item){
    item.CODIGO = item.MAP_CODIGO;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaestroClaseOrden(item){
    item.CODIGO = item.MAP_CODIGO;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaestroCordenesCactividad(item){
    item.CODIGO_ORDEN = item.MAP_CODIGO_ORDEN;
    item.CODIGO_ACTIVIDAD = item.MAP_CODIGO_ACTIVIDAD;
    item.CON_INST = item.MAP_CON_INST;
    item.SIN_INST = item.MAP_SIN_INST;
    item.ORDEN_EN_CAMPO = item.MAP_ORDEN_EN_CAMPO;
    item.CAMPO = item.MAP_CAMPO;
}
function onSaveDataMaestroEstados(item){
    item.ESTADO = item.MAP_ESTADO;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaestroEstadoAviso(item){
    item.CODIGO = item.MAP_CODIGO;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
    item.ACCIONES_PERMITIDAS = item.MAP_ACCIONES_PERMITIDAS;
}
function onSaveDataMaestroGradoHumedad(item){
    item.CODIGO = item.MAP_CODIGO;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaestroMetodosMedida(item){
    item.CODIGO = item.MAP_CODIGO;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaestroMotivosNoMedicion(item){
    item.CODIGO = item.MAP_CODIGO;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
    item.ELEMENTO = item.MAP_ELEMENTO;
    item.CLASE_ACTIVIDAD = replaceMacro(item.MAP_CLASE_ACTIVIDAD);
    item.ZONA_GEOGRAFICA = item.MAP_ZONA_GEOGRAFICA;
    item.COD_REGION = item.MAP_COD_REGION;
    item.OBSERVACION_OBLIGATORIA = item.MAP_OBSERVACION_OBLIGATORIA;
    item.ACCION_A_REALIZAR = item.MAP_ACCION_A_REALIZAR;
    item.AVISO_OBLIGATORIO = item.MAP_AVISO_OBLIGATORIO;
    item.ANOMALIA_OBLIGATORIA = item.MAP_ANOMALIA_OBLIGATORIA;
}
function onSaveDataMaestroRazonesInterrupcion(item){
    item.CODIGO = item.MAP_CODIGO;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaestroRazonesRechazo(item){
    item.CODIGO = item.MAP_CODIGO;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaestroRegion(item){
    item.COD_REGION_USU = item.MAP_COD_REGION_USU;
    item.COD_REGION = item.MAP_COD_REGION;
    item.DES_DESCRIPCION = item.MAP_DES_DESCRIPCION;
}
function onSaveDataMaestroTipoMotivosAviso(item){
    item.CODIGO = item.MAP_CODIGO;
    item.ELEMENTO = item.MAP_ELEMENTO;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaestroTipoTerreno(item){
    item.CODIGO = item.MAP_CODIGO;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataOperacioneshr(item){
    item.COD_HR = item.MAP_COD_HR;
    item.CONT_HR = item.MAP_CONT_HR;
    item.SUBOPERACION = item.MAP_SUBOPERACION;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaestroAgrupacionesTipeqstar(item){
    item.COD_TIP_EQSTAR = item.MAP_COD_TIP_EQSTAR;
    item.COD_TIP_EQUIPO_COMPATIBLE = item.MAP_COD_TIP_EQUIPO_COMPATIBLE;
}
function onSaveDataMaestroExepcionesDatamatrix(item){
    item.COD_TIP_EQSTAR = item.MAP_COD_TIP_EQSTAR;
    item.COD_FAB_EQSTAR = item.MAP_COD_FAB_EQSTAR;
    item.COD_MOD_EQSTAR = item.MAP_COD_MOD_EQSTAR;
    item.DES_MOD_DATAMATRIX = item.MAP_DES_MOD_DATAMATRIX;
}
function onSaveDataMaestroTiposCierre(item){
    item.COD_TIP_CIERRE = item.MAP_COD_TIP_CIERRE;
    item.DES_CIERRE = item.MAP_DES_CIERRE;
}
function onSaveDataMaestroZdaccion(item){
    item.GRUPO_TIPO_INCIDENCIA = item.MAP_GRUPO_TIPO_INCIDENCIA;
    item.SUBGRUPO_TIPO_INCIDENCIA = item.MAP_SUBGRUPO_TIPO_INCIDENCIA;
    item.CODIGO_INCIDENCIA = item.MAP_CODIGO_INCIDENCIA;
    item.ACTUACIONES = item.MAP_ACTUACIONES;
    item.TIPO_EQUIPO = item.MAP_TIPO_EQUIPO;
    item.ACCIONES = item.MAP_ACCIONES;
    item.CODIGO_FULL = item.MAP_CODIGO_FULL;
    item.DESCRIPCION_ACCIONES = item.MAP_DESCRIPCION_ACCIONES;
}
function onSaveDataMaestroZdactuacion(item){
    item.GRUPO_TIPO_DE_INCIDENCIA = item.MAP_GRUPO_TIPO_DE_INCIDENCIA;
    item.SUBGRUPO_TIPO_DE_INCIDENCIA = item.MAP_SUBGRUPO_TIPO_DE_INCIDENCIA;
    item.CODIGO_INCIDENCIA = item.MAP_CODIGO_INCIDENCIA;
    item.ACTUACIONES = item.MAP_ACTUACIONES;
    item.DESCRIPCION_ACTUACION = item.MAP_DESCRIPCION_ACTUACION;
}
function onSaveDataMaestroZdcausastg(item){
    item.CODIGO_CAUSA = item.MAP_CODIGO_CAUSA;
    item.CODIGO_TIPO_DE_DIAGNOSTICO = item.MAP_CODIGO_TIPO_DE_DIAGNOSTICO;
    item.ORDEN_DE_EJECUCION_DEL_PROCESO = item.MAP_ORDEN_DE_EJECUCION_DEL_PROCESO;
    item.OBSOLETO = item.MAP_OBSOLETO;
    item.FECHA_DESDE = item.MAP_FECHA_DESDE;
    item.FECHA_HASTA = item.MAP_FECHA_HASTA;
    item.DESCRIPCION_CAUSA = item.MAP_DESCRIPCION_CAUSA;
}
function onSaveDataMaestroZdequsgt(item){
    item.CODIGO_EQUIPO = item.MAP_CODIGO_EQUIPO;
    item.CODIGO_TIPO_DE_DIAGNOSTICO = item.MAP_CODIGO_TIPO_DE_DIAGNOSTICO;
    item.ORDEN_DE_EJECUCION_DEL_PROCESO = item.MAP_ORDEN_DE_EJECUCION_DEL_PROCESO;
    item.OBSOLETO = item.MAP_OBSOLETO;
    item.FECHA_DESDE = item.MAP_FECHA_DESDE;
    item.FECHA_HASTA = item.MAP_FECHA_HASTA;
    item.DESCRIPCION_EQUIPO = item.MAP_DESCRIPCION_EQUIPO;
}
function onSaveDataMaestroZdgtipinc(item){
    item.GRUPO_TIPO_DE_INCIDENCIA = item.MAP_GRUPO_TIPO_DE_INCIDENCIA;
    item.CLASE_ACTIVIDAD_ORDEN = item.MAP_CLASE_ACTIVIDAD_ORDEN;
    item.CLASE_ORDEN = item.MAP_CLASE_ORDEN;
    item.INDICADOR_ORDEN_PRIMER_O_SEGUNDO_NIVEL = item.MAP_INDICADOR_ORDEN_PRIMER_O_SEGUNDO_NIVEL;
    item.TIPO_OT = item.MAP_TIPO_OT;
    item.DESCRIPCION_GRUPO_TIPO_INCIDENCIA = item.MAP_DESCRIPCION_GRUPO_TIPO_INCIDENCIA;
}
function onSaveDataMenuMaestroZdrelacDiagno(item){
    item.SOLUCION = item.MAP_SOLUCION;
    item.CODIGO_TIPO_DE_DIAGNOSTICO = item.MAP_CODIGO_TIPO_DE_DIAGNOSTICO;
    item.CODIGO_EQUIPO = item.MAP_CODIGO_EQUIPO;
    item.CODIGO_CAUSA = item.MAP_CODIGO_CAUSA;
    item.CODIGO_SOLUCION = item.MAP_CODIGO_SOLUCION;
}
function onSaveDataMaestroZdsGlobal(item){
    item.SOLUCION = item.MAP_SOLUCION;
    item.ORDEN_DE_EJECUCION_DEL_PROCESO = item.MAP_ORDEN_DE_EJECUCION_DEL_PROCESO;
    item.OBSOLETO = item.MAP_OBSOLETO;
    item.FECHA_DESDE = item.MAP_FECHA_DESDE;
    item.FECHA_HASTA = item.MAP_FECHA_HASTA;
    item.DESCRIPCION_CODIGO_SOLUCION_GLOBAL = item.MAP_DESCRIPCION_CODIGO_SOLUCION_GLOBAL;
}
function onSaveDataMaestroZdsgtipinc(item){
    item.GRUPO_TIPO_INCIDENCIA = item.MAP_GRUPO_TIPO_INCIDENCIA;
    item.SUBGRUPO_TIPO_DE_INCIDENCIA = item.MAP_SUBGRUPO_TIPO_DE_INCIDENCIA;
    item.DESCRIPCION_SUBGRUPO_TIPO_INCIDENCIA = item.MAP_DESCRIPCION_SUBGRUPO_TIPO_INCIDENCIA;
}
function onSaveDataMaestroZdsolustg(item){
    item.CODIGO_SOLUCION = item.MAP_CODIGO_SOLUCION;
    item.CODIGO_TIPO_DE_DIAGNOSTICO = item.MAP_CODIGO_TIPO_DE_DIAGNOSTICO;
    item.ORDEN_DE_EJECUCION_DEL_PROCESO = item.MAP_ORDEN_DE_EJECUCION_DEL_PROCESO;
    item.OBSOLETO = item.MAP_OBSOLETO;
    item.FECHA_DESDE = item.MAP_FECHA_DESDE;
    item.FECHA_HASTA = item.MAP_FECHA_HASTA;
    item.DESCRIPCION_SOLUCION = item.MAP_DESCRIPCION_SOLUCION;
}
function onSaveDataMaestroZdtipinc(item){
    item.GRUPO_TIPO_DE_INCIDENCIA = item.MAP_GRUPO_TIPO_DE_INCIDENCIA;
    item.SUBGRUPO_TIPO_DE_INCIDENCIA = item.MAP_SUBGRUPO_TIPO_DE_INCIDENCIA;
    item.CODIGO_INCIDENCIA = item.MAP_CODIGO_INCIDENCIA;
    item.DESCRIPCION_TIPO_INCIDENCIA = item.MAP_DESCRIPCION_TIPO_INCIDENCIA;
}
function onSaveDataMaestroZdtipodiag(item){
    item.CODIGO_TIPO_DE_DIAGNOSTICO = item.MAP_CODIGO_TIPO_DE_DIAGNOSTICO;
    item.ORDEN_DE_EJECUCION_DEL_PROCESO = item.MAP_ORDEN_DE_EJECUCION_DEL_PROCESO;
    item.OBSOLETO = item.MAP_OBSOLETO;
    item.FECHA_DESDE = item.MAP_FECHA_DESDE;
    item.FECHA_HASTA = item.MAP_FECHA_HASTA;
    item.DESCRIPCION_TIPO_DIAGNOSTICO = item.MAP_DESCRIPCION_TIPO_DIAGNOSTICO;
}
function onSaveDataRelacionBrigadas(item){
    item.COD_BRIGADA_USU_EX = item.MAP_COD_BRIGADA_USU_EX;
    item.COD_BRIGADA_USU_IN = item.MAP_COD_BRIGADA_USU_IN;
    item.DESCRIPCION_EX = item.MAP_DESCRIPCION_EX;
    item.DESCRIPCION_IN = item.MAP_DESCRIPCION_IN;
}
function onSaveDataMaestroPropiedades(item){
    item.TABLA = item.MAP_TABLA;
    item.PROPIEDAD = item.MAP_PROPIEDAD;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
    item.ORDEN = item.MAP_ORDEN;
    item.VISIBLE = item.MAP_VISIBLE;
    item.TIPO_PROPIEDAD = item.MAP_TIPO_PROPIEDAD;
    item.REQUIERE_DIBUJO = item.MAP_REQUIERE_DIBUJO;
    item.DATAMATRIX = item.MAP_DATAMATRIX;
    item.CATALOGO = item.MAP_CATALOGO;
    item.ENVIO_GENESIS = item.MAP_ENVIO_GENESIS;
    item.TIPO_CAMPO = item.MAP_TIPO_CAMPO;
    item.MAPCOLL = item.MAP_MAPCOLL;
    item.MAPFLD = item.MAP_MAPFLD;
    item.LINKEDFIELD = item.MAP_LINKEDFIELD;
    item.FILTRO = item.MAP_FILTRO;
    item.FORMATO = item.MAP_FORMATO;
}
function onSaveDataMaestroTipoFotos(item){
    item.COD_TIPO_FOTO = item.MAP_COD_TIPO_FOTO;
    item.TABLA = item.MAP_TABLA;
    item.DESC_TIPO_FOTO = item.MAP_DESC_TIPO_FOTO;
    item.IND_OBLIG = item.MAP_IND_OBLIG;
    item.TIPO_DOCUMENTO = item.MAP_TIPO_DOCUMENTO;
}
function onSaveDataMaestroTrabtip(item){
    item.COD_TIP_TRAB = item.MAP_COD_TIP_TRAB;
    item.GRUPO = item.MAP_GRUPO;
    item.CODIGO = item.MAP_CODIGO;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
    item.CRITERIO = item.MAP_CRITERIO;
    item.CORRECTIVO = item.MAP_CORRECTIVO;
    item.MODIFICATIVO = item.MAP_MODIFICATIVO;
    item.HORAS = item.MAP_HORAS;
    item.IND_GASTO_INV = item.MAP_IND_GASTO_INV;
}
function onSaveDataMaestroZdptpdc(item){
    item.CLASE = item.MAP_CLASE;
    item.VALOR = item.MAP_VALOR;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaestroZdptda(item){
    item.CLASE = item.MAP_CLASE;
    item.VALOR = item.MAP_VALOR;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaestroZdptca(item){
    item.CLASE = item.MAP_CLASE;
    item.VALOR = item.MAP_VALOR;
    item.DESCRIPCION = item.MAP_DESCRIPCION;
}
function onSaveDataMaestroRecEstados(item){
    item.COD_ESTADO = item.MAP_COD_ESTADO;
    item.NOMBRE = item.MAP_NOMBRE;
}
function onSaveDataMaestroDocumentacion(item){
    item.CARPETA = item.MAP_CARPETA;
    item.CARPETA_PADRE = item.MAP_CARPETA_PADRE;
    item.CODIGO_DOCUMENTO = item.MAP_CODIGO_DOCUMENTO;
    item.TITULO_DOCUMENTO = item.MAP_TITULO_DOCUMENTO;
    item.CODIGO_ANEXO = item.MAP_CODIGO_ANEXO;
    item.TITULO_ANEXO = item.MAP_TITULO_ANEXO;
}
function onSaveDataMaestroListados(item){
    item.ST_VALOR = item.MAP_ST_VALOR;
    item.ST_DESCRIPCION = item.MAP_ST_DESCRIPCION;
    item.TIPO = item.MAP_TIPO;
    item.ORDEN = item.MAP_ORDEN;
}



async function Guardar(objself,onValidaciones,contentName){
    if(onValidaciones(objself)){
        ui.showToast("Guardando ...");
        
        var esNuevo = objself.ID == 0;
        await objself.save();
        
        if(esNuevo){
            await RegistrarAccionUsuario("Creando nuevo registro",contentName,obtenerRowId(contentName,objself.ID,""));
        }else{
            await RegistrarAccionUsuario("Actualizando el registro.",contentName,objself.ROWID);
        }
        
        let parent = objself.getParent();
        let view = ui.getView(parent);
        
        if(view){
            view.refresh(contentName);    
        }
        
        onBack();
    }
}

function onValudacionesAnMotivosAnulacion(objself){
    let error=0;
    if(objself.COD_TIPO_ANULACION==0){
        error = error + 1;
        ui.showToast("Indique un código tipo anulación");
    }
    if(objself.DESCRIPCION==""){
        error = error + 1;
        ui.showToast("Indique una descripción");
    }
    return error==0;
}

function onValidacionesAnTipoAnomalia(objself){
    
    if(objself.ID_TIPO_ANOM=="" || objself.ID_TIPO_ANOM == "000000000000000000"){
        ui.showToast("Indique un código tipo anomalia");
        return false;
    }
    if(objself.DESC_TIPO_ANOM==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesAnTipoFoto(objself){
    
    // let obj = appData.getCollection("ListadoMaestroAnTipoFoto").findObject("COD_TIPO_FOTO='"+objself.COD_TIPO_FOTO+"' AND COD_TIPO_ANOM='"+objself.COD_TIPO_ANOM+"'");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.COD_TIPO_FOTO==0){
        ui.showToast("Indique un código tipo foto");
        return false;
    }
    if(objself.COD_TIPO_ANOM==""){
        ui.showToast("Indique un código tipo anomalía");
        return false;
    }
    return true;
}

function onValidacionesArMaestroRiesgo(objself){
    
    // let obj = appData.getCollection("ListadoMaestroRiesgo").findObject("COD_TIP_RIESGO="+objself.COD_TIP_RIESGO+" ");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.COD_TIP_RIESGO==0){
        ui.showToast("Indique un código tipo riesgo");
        return false;
    }
    return true;
}

function onValidacionesFormularios(objself){
    if(objself.TIPO_FORMULARIO==""){
        ui.showToast("Indique un tipo formulario");
        return false;
    }
    return true;
}

function onValidacionesItfMadrugada(objself){
    if(objself.TIPO_FORMULARIO==""){
        ui.showToast("Indique un tipo formulario");
        return false;
    }
    return true;
}

function onValidacionesMaestroTipoFormulario(objself){
    
    // let obj = appData.getCollection("ListadoMaestroRiesgo").findObject("COD_TIP_RIESGO="+objself.COD_TIP_RIESGO+" ");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.TIPO_FORMULARIO==""){
        ui.showToast("Indique un tipo de formulario");
        return false;
    }
    return true;
}

function onValidacionesMaCapaElemento(objself){
    
    // let obj = appData.getCollection("ListadoMaCapaElemento").findObject("ELEMENTO='"+objself.ELEMENTO+"' AND FNO="+objself.FNO);
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.ELEMENTO==""){
        ui.showToast("Indique un elemento");
        return false;
    }
    if(objself.FNO==0){
        ui.showToast("Indique un fno");
        return false;
    }
    return true;
}

function onValidacionesMaestroClaseActividad(objself){
    
    // let obj = appData.getCollection("ListadoMaestroClaseActividad").findObject("CODIGO='"+objself.CODIGO+"' ");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO==""){
        ui.showToast("Indique un código");
        return false;
    }
    if(objself.DESCRIPCION==0){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroClaseOrden(objself){
    
    // let obj = appData.getCollection("ListadoMaestroClaseOrden").findObject("CODIGO='"+objself.CODIGO+"' ");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO==""){
        ui.showToast("Indique un código");
        return false;
    }
    if(objself.DESCRIPCION==0){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroCordenesCactividad(objself){
    
    // let obj = appData.getCollection("ListadoMaestroCordenesCactividad").findObject("CODIGO_ORDEN='"+objself.CODIGO_ORDEN+"' AND CODIGO_ACTIVIDAD='"+objself.CODIGO_ACTIVIDAD+"' ");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO_ORDEN==""){
        ui.showToast("Indique un código de orden");
        return false;
    }
    if(objself.CODIGO_ACTIVIDAD==""){
        ui.showToast("Indique un código de actividad");
        return false;
    }
    return true;
}

function onValidacionesMaestroEstados(objself){
    
    // let obj = appData.getCollection("ListadoMaestroEstados").findObject("ESTADO="+objself.ESTADO);
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.ESTADO==0){
        ui.showToast("Indique un estado");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroEstadoAviso(objself){
    
    // let obj = appData.getCollection("ListadoMaestroEstadoAviso").findObject("CODIGO="+objself.CODIGO);
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO==0){
        ui.showToast("Indique un código");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroGradoHumedad(objself){
    
    // let obj = appData.getCollection("ListadoMaestroGradoHumedad").findObject("CODIGO="+objself.CODIGO);
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO==0){
        ui.showToast("Indique un código");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroMetodosMedida(objself){
    
    // let obj = appData.getCollection("ListadoMaestroMetodosMedida").findObject("CODIGO="+objself.CODIGO);
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO==0){
        ui.showToast("Indique un código");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroMotivosNoMedicion(objself){
    
    // let obj = appData.getCollection("ListadoMaestroMotivosNoMedicion").findObject("CODIGO="+objself.CODIGO+" AND ELEMENTO LIKE '%"+objself.ELEMENTO+"%' ");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO==0){
        ui.showToast("Indique un código");
        return false;
    }
    if(objself.ELEMENTO==""){
        ui.showToast("Indique un elemento");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    if(objself.ACCION_A_REALIZAR==""){
        ui.showToast("Indique una acción a realizar");
        return false;
    }
    
    return true;
}

function onValidacionesMaestroRazonesInterrupcion(objself){
    
    // let obj = appData.getCollection("ListadoMaestroRazonesInterrupcion").findObject("CODIGO="+objself.CODIGO);
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO==0){
        ui.showToast("Indique un código");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroRazonesRechazo(objself){
    
    // let obj = appData.getCollection("ListadoMaestroRazonesRechazo").findObject("CODIGO="+objself.CODIGO);
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO==0){
        ui.showToast("Indique un código");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroRegion(objself){
    
    // let obj = appData.getCollection("ListadoMaestroRegion").findObject("COD_REGION="+objself.COD_REGION+" AND COD_REGION_USU='"+objself.COD_REGION_USU+"'");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.COD_REGION==0){
        ui.showToast("Indique un código de región");
        return false;
    }
    if(objself.COD_REGION_USU==""){
        ui.showToast("Indique un código de región usuario");
        return false;
    }
    if(objself.DES_DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroTipoMotivosAviso(objself){
    
    // let obj = appData.getCollection("ListadoMaestroTipoMotivosAviso").findObject("CODIGO="+objself.CODIGO);
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO==0){
        ui.showToast("Indique un código");
        return false;
    }
    if(objself.ELEMENTO==""){
        ui.showToast("Indique un elemento");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroTipoTerreno(objself){
    
    // let obj = appData.getCollection("ListadoMaestroTipoTerreno").findObject("CODIGO="+objself.CODIGO);
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO==0){
        ui.showToast("Indique un código");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesOperacioneshr(objself){
    
    if(objself.COD_HR==""){
        ui.showToast("Indique un código hr");
        return false;
    }
    if(objself.CONT_HR==""){
        ui.showToast("Indique un cont hr");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroAgrupacionesTipeqstar(objself){
    
    // let obj = appData.getCollection("ListadoMaestroAgrupacionesTipeqstar").findObject("COD_TIP_EQSTAR="+objself.COD_TIP_EQSTAR+" AND COD_TIP_EQUIPO_COMPATIBLE="+objself.COD_TIP_EQUIPO_COMPATIBLE);
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.COD_TIP_EQSTAR==0){
        ui.showToast("Indique un código tipo eqstar");
        return false;
    }
    if(objself.COD_TIP_EQUIPO_COMPATIBLE==0){
        ui.showToast("Indique un código tipo equipo compatible");
        return false;
    }
    return true;
}

function onValidacionesMaestroExepcionesDatamatrix(objself){
    
    // let obj = appData.getCollection("ListadoMaestroExepcionesDatamatrix").findObject("COD_TIP_EQSTAR="+objself.COD_TIP_EQSTAR+" AND COD_FAB_EQSTAR="+objself.COD_FAB_EQSTAR+" AND COD_MOD_EQSTAR="+objself.COD_MOD_EQSTAR);
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.COD_TIP_EQSTAR==0){
        ui.showToast("Indique un código tipo eqstar");
        return false;
    }
    if(objself.COD_FAB_EQSTAR==0){
        ui.showToast("Indique un código fab eqstar");
        return false;
    }
    if(objself.COD_MOD_EQSTAR==0){
        ui.showToast("Indique un código mod eqstar");
        return false;
    }
    if(objself.DES_MOD_DATAMATRIX==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroTiposCierre(objself){
    
    // let obj = appData.getCollection("ListadoMaestroTiposCierre").findObject("COD_TIP_CIERRE='"+objself.COD_TIP_CIERRE+"'");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.COD_TIP_CIERRE==""){
        ui.showToast("Indique un código");
        return false;
    }
    if(objself.DES_CIERRE==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroZdaccion(objself){
    
    // let obj = appData.getCollection("ListadoMaestroZdaccion").findObject("CODIGO_FULL='"+objself.CODIGO_FULL+"'");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO_FULL==""){
        ui.showToast("Falta código completo");
        return false;
    }
    if(objself.GRUPO_TIPO_INCIDENCIA==""){
        ui.showToast("Indique un grupo tipo incidencia");
        return false;
    }
    if(objself.SUBGRUPO_TIPO_INCIDENCIA==""){
        ui.showToast("Indique un subgrupo tipo incidencia");
        return false;
    }
    if(objself.CODIGO_INCIDENCIA==""){
        ui.showToast("Indique un código de incidencia");
        return false;
    }
    if(objself.ACTUACIONES==""){
        ui.showToast("Indique una actuación");
        return false;
    }
    if(objself.ACCIONES==""){
        ui.showToast("Indique una acción");
        return false;
    }
    if(objself.DESCRIPCION_ACCIONES==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroZdactuacion(objself){
    
    // let obj = appData.getCollection("ListadoMaestroZdactuacion").findObject("GRUPO_TIPO_DE_INCIDENCIA='"+objself.GRUPO_TIPO_DE_INCIDENCIA+"' AND SUBGRUPO_TIPO_DE_INCIDENCIA='"+objself.SUBGRUPO_TIPO_DE_INCIDENCIA+"' AND CODIGO_INCIDENCIA='"+objself.CODIGO_INCIDENCIA+"' AND ACTUACIONES='"+objself.ACTUACIONES+"'");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.GRUPO_TIPO_DE_INCIDENCIA==""){
        ui.showToast("Indique un grupo tipo incidencia");
        return false;
    }
    if(objself.SUBGRUPO_TIPO_DE_INCIDENCIA==""){
        ui.showToast("Indique un subgrupo tipo incidencia");
        return false;
    }
    if(objself.CODIGO_INCIDENCIA==""){
        ui.showToast("Indique un código de incidencia");
        return false;
    }
    if(objself.ACTUACIONES==""){
        ui.showToast("Indique una actuación");
        return false;
    }
    if(objself.DESCRIPCION_ACTUACION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroZdcausastg(objself){
    
    // let obj = appData.getCollection("ListadoMaestroZdcausastg").findObject("CODIGO_CAUSA='"+objself.CODIGO_CAUSA+"' AND CODIGO_TIPO_DE_DIAGNOSTICO='"+objself.CODIGO_TIPO_DE_DIAGNOSTICO+"'");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO_CAUSA==""){
        ui.showToast("Indique un código de causa");
        return false;
    }
    if(objself.CODIGO_TIPO_DE_DIAGNOSTICO==""){
        ui.showToast("Indique un código tipo de diagnóstico");
        return false;
    }
    if(objself.ORDEN_DE_EJECUCION_DEL_PROCESO==""){
        ui.showToast("Indique un orden de ejecución del proceso");
        return false;
    }
    if(objself.FECHA_DESDE==""){
        ui.showToast("Indique una fecha desde");
        return false;
    }
    if(objself.FECHA_HASTA==""){
        ui.showToast("Indique una fecha hasta");
        return false;
    }
    if(objself.DESCRIPCION_CAUSA==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroZdequsgt(objself){
    
    // let obj = appData.getCollection("ListadoMaestroZdequsgt").findObject("CODIGO_EQUIPO='"+objself.CODIGO_EQUIPO+"' AND CODIGO_TIPO_DE_DIAGNOSTICO='"+objself.CODIGO_TIPO_DE_DIAGNOSTICO+"' AND ORDEN_DE_EJECUCION_DEL_PROCESO='"+objself.ORDEN_DE_EJECUCION_DEL_PROCESO+"'");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.CODIGO_EQUIPO==""){
        ui.showToast("Indique un código de equipo");
        return false;
    }
    if(objself.CODIGO_TIPO_DE_DIAGNOSTICO==""){
        ui.showToast("Indique un código tipo de diagnóstico");
        return false;
    }
    if(objself.ORDEN_DE_EJECUCION_DEL_PROCESO==""){
        ui.showToast("Indique un orden de ejecución del proceso");
        return false;
    }
    if(objself.FECHA_DESDE==""){
        ui.showToast("Indique una fecha desde");
        return false;
    }
    if(objself.FECHA_HASTA==""){
        ui.showToast("Indique una fecha hasta");
        return false;
    }
    if(objself.DESCRIPCION_EQUIPO==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroZdgtipinc(objself){
    
    // let obj = appData.getCollection("ListadoMaestroZdgtipinc").findObject("GRUPO_TIPO_DE_INCIDENCIA='"+objself.GRUPO_TIPO_DE_INCIDENCIA+"' AND CLASE_ACTIVIDAD_ORDEN='"+objself.CLASE_ACTIVIDAD_ORDEN+"' AND CLASE_ORDEN='"+objself.CLASE_ORDEN+"' AND INDICADOR_ORDEN_PRIMER_O_SEGUNDO_NIVEL='"+objself.INDICADOR_ORDEN_PRIMER_O_SEGUNDO_NIVEL+"'");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.GRUPO_TIPO_DE_INCIDENCIA==""){
        ui.showToast("Indique un grupo tipo de incidencia");
        return false;
    }
    if(objself.CLASE_ACTIVIDAD_ORDEN==""){
        ui.showToast("Indique una clase actividad");
        return false;
    }
    if(objself.CLASE_ORDEN==""){
        ui.showToast("Indique una clase orden");
        return false;
    }
    if(objself.INDICADOR_ORDEN_PRIMER_O_SEGUNDO_NIVEL==""){
        ui.showToast("Indique un orden de primer o segundo nivel");
        return false;
    }
    if(objself.TIPO_OT==""){
        ui.showToast("Indique un tipo de OT");
        return false;
    }
    if(objself.DESCRIPCION_GRUPO_TIPO_INCIDENCIA==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}


function onValidacionesMaestroZdrelacDiagno(objself){
    
    if(objself.SOLUCION==""){
        ui.showToast("Indique una solución");
        return false;
    }
    if(objself.CODIGO_TIPO_DE_DIAGNOSTICO==""){
        ui.showToast("Indique un código tipo de diagnóstico");
        return false;
    }
    if(objself.CODIGO_EQUIPO==""){
        ui.showToast("Indique un código equipo");
        return false;
    }
    if(objself.CODIGO_CAUSA==""){
        ui.showToast("Indique un código causa");
        return false;
    }
    if(objself.CODIGO_SOLUCION==""){
        ui.showToast("Indique un código solución");
        return false;
    }
    return true;
}

function onValidacionesMaestroZdsGlobal(objself){
    
    // let obj = appData.getCollection("ListadoMaestroZdcausastg").findObject("CODIGO_CAUSA='"+objself.CODIGO_CAUSA+"' AND CODIGO_TIPO_DE_DIAGNOSTICO='"+objself.CODIGO_TIPO_DE_DIAGNOSTICO+"'");
    // if(obj){
    //     if(obj != null){
    //         ui.showToast("El elemento ya existe.");
    //         return false;
    //     }
    // }
    if(objself.SOLUCION==""){
        ui.showToast("Indique una solución");
        return false;
    }
    if(objself.ORDEN_DE_EJECUCION_DEL_PROCESO==""){
        ui.showToast("Indique un orden de ejecución del proceso");
        return false;
    }
    if(objself.FECHA_DESDE==""){
        ui.showToast("Indique una fecha desde");
        return false;
    }
    if(objself.FECHA_HASTA==""){
        ui.showToast("Indique una fecha hasta");
        return false;
    }
    if(objself.DESCRIPCION_CODIGO_SOLUCION_GLOBAL==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroZdsgtipinc(objself){
    if(objself.GRUPO_TIPO_INCIDENCIA==""){
        ui.showToast("Indique un grupo tipo incidencia");
        return false;
    }
    if(objself.SUBGRUPO_TIPO_DE_INCIDENCIA==""){
        ui.showToast("Indique un subgrupo tipo incidencia");
        return false;
    }
    if(objself.DESCRIPCION_SUBGRUPO_TIPO_INCIDENCIA==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroZdsolustg(objself){
    if(objself.CODIGO_SOLUCION==""){
        ui.showToast("Indique un código solución");
        return false;
    }
    if(objself.CODIGO_TIPO_DE_DIAGNOSTICO==""){
        ui.showToast("Indique un código tipo de diagnóstico");
        return false;
    }
    if(objself.ORDEN_DE_EJECUCION_DEL_PROCESO==""){
        ui.showToast("Indique un orden de ejecución del proceso");
        return false;
    }
    if(objself.FECHA_DESDE==""){
        ui.showToast("Indique una fecha desde");
        return false;
    }
    if(objself.FECHA_HASTA==""){
        ui.showToast("Indique una fecha hasta");
        return false;
    }
    if(objself.DESCRIPCION_SOLUCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroZdtipinc(objself){
    if(objself.GRUPO_TIPO_DE_INCIDENCIA==""){
        ui.showToast("Indique un grupo tipo incidencia");
        return false;
    }
    if(objself.SUBGRUPO_TIPO_DE_INCIDENCIA==""){
        ui.showToast("Indique un subgrupo tipo incidencia");
        return false;
    }
    if(objself.CODIGO_INCIDENCIA==""){
        ui.showToast("Indique un código de incidencia");
        return false;
    }
    if(objself.DESCRIPCION_TIPO_INCIDENCIA==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroZdtipodiag(objself){
    if(objself.CODIGO_TIPO_DE_DIAGNOSTICO==""){
        ui.showToast("Indique un código tipo diagnóstico");
        return false;
    }
    if(objself.ORDEN_DE_EJECUCION_DEL_PROCESO==""){
        ui.showToast("Indique un orden de ejecución del proceso");
        return false;
    }
    if(objself.FECHA_DESDE==""){
        ui.showToast("Indique una fecha desde");
        return false;
    }
    if(objself.FECHA_HASTA==""){
        ui.showToast("Indique una fecha hasta");
        return false;
    }
    if(objself.DESCRIPCION_TIPO_DIAGNOSTICO==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesRelacionBrigadas(objself){
    if(objself.COD_BRIGADA_USU_EX==""){
        ui.showToast("Indique un código brigada ex");
        return false;
    }
    if(objself.COD_BRIGADA_USU_IN==""){
        ui.showToast("Indique un código brigada in");
        return false;
    }
    if(objself.DESCRIPCION_EX==""){
        ui.showToast("Indique una descripción ex");
        return false;
    }
    if(objself.DESCRIPCION_IN==""){
        ui.showToast("Indique una descripción in");
        return false;
    }
    return true;
}

function onValidacionesMaestroPropiedades(objself){
    if(objself.TABLA==""){
        ui.showToast("Indique una tabla");
        return false;
    }
    if(objself.PROPIEDAD==""){
        ui.showToast("Indique una propiedad");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroTipoFotos(objself){
    if(objself.COD_TIPO_FOTO==0){
        ui.showToast("Indique un código tipo foto");
        return false;
    }
    if(objself.TABLA==""){
        ui.showToast("Indique una tabla");
        return false;
    }
    if(objself.DESC_TIPO_FOTO==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroTrabtip(objself){
    if(objself.COD_TIP_TRAB==""){
        ui.showToast("Indique un código tipo trab");
        return false;
    }
    if(objself.GRUPO==""){
        ui.showToast("Indique un grupo");
        return false;
    }
    if(objself.CODIGO==""){
        ui.showToast("Indique un código");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    if(objself.IND_GASTO_INV==""){
        ui.showToast("Indique un ind. gasto inv");
        return false;
    }
    return true;
}

function onValidacionesMaestroZdptpdc(objself){
    if(objself.CLASE==""){
        ui.showToast("Indique una clase");
        return false;
    }
    if(objself.VALOR==""){
        ui.showToast("Indique un valor");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroZdptda(objself){
    if(objself.CLASE==""){
        ui.showToast("Indique una clase");
        return false;
    }
    if(objself.VALOR==""){
        ui.showToast("Indique un valor");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroZdptca(objself){
    if(objself.CLASE==""){
        ui.showToast("Indique una clase");
        return false;
    }
    if(objself.VALOR==""){
        ui.showToast("Indique un valor");
        return false;
    }
    if(objself.DESCRIPCION==""){
        ui.showToast("Indique una descripción");
        return false;
    }
    return true;
}

function onValidacionesMaestroRecEstados(objself){
    if(objself.COD_ESTADO==0){
        ui.showToast("Indique un código de estado");
        return false;
    }
    if(objself.NOMBRE==""){
        ui.showToast("Indique un nombre");
        return false;
    }
    return true;
}

function onValidacionesMaestroDocumentacion(objself){
    // if(objself.COD_ESTADO==0){
    //     ui.showToast("Indique un código de estado");
    //     return false;
    // }
    // if(objself.NOMBRE==""){
    //     ui.showToast("Indique un nombre");
    //     return false;
    // }
    return true;
}

function onValidacionesMaestroListados(objself){
    // if(objself.COD_TIP_EQSTAR==0){
    //     ui.showToast("Indique un código tipo eqstar");
    //     return false;
    // }
    return true;
}




function onValudacionesUsuario(objself){
    let error = false;
    if(objself.LOGIN == ""){
        error = true;
        ui.showToast("Indique un login");
    }
    if(objself.MAP_PWD == ""){
        error = true;
        ui.showToast("Indique una contraseña");
    }
    if(objself.MAP_PWD2 == "" && objself.ID == 0){
        error = true;
        ui.showToast("repita la contraseña");
    }
    if(objself.NOMBRE == ""){
        error = true;
        ui.showToast("Indique un nombre");
    }
    if(objself.MAP_PWD != objself.MAP_PWD2 && objself.ID == 0){
        error = true;
        ui.showToast("Las contraseña no coinciden");
    }
    return !error;
}

async function borrarElementoUsuario(objself){
    var a = ui.msgBox("¿Está seguro que desea borrar el usuario?","¡ATENCION!",1);
  	if (a == 1){
  	    await RegistrarAccionUsuario("Borrado físico registro","gen_usuarios",objself.ROWID);
	    await objself.deleteObject();
	    
	    let parent = objself.getParent();
        let view = ui.getView(parent);
        
        if(view){
            view.refresh("Usuarios");    
        }
        
        onBack();
    }
}

function confirmarCC(objself){
    let error = false;
    if(objself.MAP_PWD_OLD_2 == ""){
        error = true;
        ui.showToast("Indique una contraseña anterior");
    }
    if(objself.MAP_PWD_2 == ""){
        error = true;
        ui.showToast("Indique una nueva contraseña");
    }
    if(objself.MAP_PWD2_2 == ""){
        error = true;
        ui.showToast("repita la nueva contraseña");
    }
    if(objself.MAP_PWD_OLD_2 != objself.MAP_PWD){
        error = true;
        ui.showToast("Las contraseña antigua no coincide.");
    }
    if(objself.MAP_PWD_2 != objself.MAP_PWD2_2){
        error = true;
        ui.showToast("Las contraseña no coinciden");
    }
    if(!error){
        objself.MAP_MOSTRAR_FLOTANTE_CC = 0;
        objself.MAP_PWD = objself.MAP_PWD_2;
        objself.executeNode("guardar");
    }
}

// function GuardarAnTipoAnomalia(objself){
//     Guardar(objself,onValidacionesAnTipoAnomalia,"ListadoMaestroAnTipoAnomalia");
// }

// function GuardarAnTipoFoto(objself){
    
//     let obj = appData.getCollection("ListadoMaestroAnTipoFoto").findObject("COD_TIPO_FOTO='"+objself.COD_TIPO_FOTO+"' AND COD_TIPO_ANOM='"+objself.COD_TIPO_ANOM+"'");
//     if(obj){
//         if(obj != null){
//             ui.showToast("El elemento ya existe.");
//             return;
//         }
//     }
    
//     Guardar(objself,onValidacionesAnTipoFoto,"ListadoMaestroAnTipoFoto");
// }

// function GuardarArMaestroRiesgo(objself){
    
//     let obj = appData.getCollection("ListadoMaestroRiesgo").findObject("COD_TIP_RIESGO="+objself.COD_TIP_RIESGO+" ");
//     if(obj){
//         if(obj != null){
//             ui.showToast("El elemento ya existe.");
//             return;
//         }
//     }
    
//     Guardar(objself,onValidacionesArMaestroRiesgo,"ListadoMaestroRiesgo");
// }

// function GuardarMaCapaElemento(objself){
    
//     let obj = appData.getCollection("ListadoMaCapaElemento").findObject("ELEMENTO='"+objself.ELEMENTO+"' AND FNO="+objself.FNO);
//     if(obj){
//         if(obj != null){
//             ui.showToast("El elemento ya existe.");
//             return;
//         }
//     }
    
//     Guardar(objself,onValidacionesMaCapaElemento,"ListadoMaCapaElemento");
// }

function abrirDispositivo(dispositivo){
    ui.showWaitDialog("Buscando ...");
    let obj = appData.getCollection("ListadoDispositivosGeneralEdicion").findObject("d.PIN='"+dispositivo+"'");
    if(obj) {
        ui.hideWaitDialog();
        appData.pushValue(obj);
    }else{
        ui.hideWaitDialog();
        ui.showToast("Dispositivo no encontrado.");
    }
}

async function RegistrarAccionUsuario(descripcion,tabla,rowid){
    try{
        var obj = appData.getCollection("WebAccionesUsuario").createObject();
        obj.USUARIO = user.LOGIN;
        obj.FECHA = new Date();
        obj.DESCRIPCION = descripcion;
        obj.TABLA = tabla;
        obj.OP_ROWID = rowid;
        await obj.save();
    }catch(e){
    }
}

async function reintentarCOnseguirCodigoGamad(objself){
    if(objself.NUMEROORDEN_GAMAD == null || objself.NUMEROORDEN_GAMAD.length == 0){
        await RegistrarAccionUsuario("Reprocesado PROCESADO_GAMAD_CODE","gen_ot_cabecera",objself.ROWID);
        
        objself.PROCESADO_GAMAD_CODE = 0;
        await objself.save();
        
        await onEditorAction(objself.MAP_PARENT);
        
        ui.showToast("Marcado para reprocesado correctamente.");
    }else{
        ui.showToast("Ya dispone de número de GAMAD.");
    }
}

async function reintentarEnvioPDFGAMAD(objself){
    var content = objself.getContents("@ListadoFotosOT");
    
    if(content.getCount() > 0){
        await RegistrarAccionUsuario("Reprocesado ENVIO_PDF_GAMAD","gen_ot_cabecera",objself.ROWID);
    
        let item = content.getItem(0);
        if(item.PROCESADO == -1){
            await RegistrarAccionUsuario("Reprocesado PROCESADO","gen_ot_fotos",item.ROWID);
            item.PROCESADO = 0;
            await item.save();
            
            // content.unlock();
            // content.clear();
            // await content.loadAll();
            // content.lock();
            
            ui.refresh("ListadoFotosOT");
        }
        objself.ENVIO_PDF_GAMAD = 0;
        objself.MAP_ESTADO_ENVIO_GAMAD = "Pendiente de enviar a GAMAD";
        await objself.save();
        
        await onEditorAction(objself.MAP_PARENT);
        
        ui.showToast("Marcado para reprocesado correctamente.");
    }else{
        ui.showToast("El fichero no se ha generado, no se puede enviar.");
    }
}

async function reintentarEnvioPDFIFS(objself){
    var content = objself.getContents("@ListadoFotosOT");
    
    if(content.getCount() > 0){
        if(objself.ENVIO_PDF_GAMAD == 1){
            await RegistrarAccionUsuario("Reprocesado ENVIO_PDF_IFS","gen_ot_cabecera",objself.ROWID);
            
            objself.ENVIO_PDF_IFS = 0;
            objself.MAP_ESTADO_ENVIO_IFS = "Pendiente de enviar a IFS";
            await objself.save();
            
            await onEditorAction(objself.MAP_PARENT);
        
            ui.showToast("Marcado para reprocesado correctamente.");
        }else{
            ui.showToast("Primero se debe enviar el fichero a GAMAD.");
        }
    }else{
        ui.showToast("El fichero no se ha generado, no se puede enviar.");
    }
}

function obtenerRowId(collName,id,preff){
    var coll = appData.getCollection(collName);
    var obj = coll.findObject(preff+"ID="+id);
    if(obj != null){
        return obj.ROWID;
    }
    return null;
}

async function ListadoOtActivasSelectedItem(objself){
    try{
        let coll = appData.getCollection("MenuEdicionOt");
        coll.setMacro("##ESTADO##",objself.ESTADO);
        coll.setMacro("##ESTADO_DESC##","'"+objself.ESTADO_DESC+"'");
        coll.setFilter("O.ID="+objself.ID);
        // let obj = coll.findObject("O.ID="+objself.ID);
        coll.clear();
        await coll.loadAll();
        if(coll.getCount() > 0){
            let obj = coll.getItem(0);
            if(obj) {
                obj.MAP_ESTADO = objself.ESTADO;
                obj.MAP_PARENT = objself.getParent();
                appData.pushValue(obj);
                return;
            }
        }
    }
    catch(ex){
        ui.showToast("No se ha podido encontrar la Ot.");
        appData.failWithMessage(-11888, "##EXIT##");    
    }
}

async function onchangeErrores(objself,inputName,outputName,idname,no_value){
    var input = objself[inputName];
    var match = input.match(/\((-?\d+)\)/);
    var code = match ? parseInt(match[1], 10) : no_value-1;
    if(code < no_value){
        objself[idname] = null;
        objself[inputName] = null;
        objself[outputName] = no_value;
        await onEditorAction(self);
    }else{
        objself[outputName] = code;
        await onEditorAction(self);
    }
}

async function reintentarTask_id(objself){
    if((objself.SISTEMA == 5 || objself.ES_COLABORACION == 1) && (objself.TASK_ID == null || objself.TASK_ID == "")){
        await RegistrarAccionUsuario("Reprocesado PROCESADO","gen_ot_cabecera",objself.ROWID);
        objself.PROCESADO = 0;
        await objself.save();
        
        await onEditorAction(objself.MAP_PARENT);
        
        ui.showToast("Marcado para reprocesado correctamente.");
    }else{
        ui.showToast("La Ot ya tiene TASK_ID no necesita pedirlo.");
    }
}

async function reintentarCargaCompleta(objself){
    if(objself.SISTEMA == 2){
        await RegistrarAccionUsuario("Reprocesado CARGA_COMPLETA","gen_ot_cabecera",objself.ROWID);
        objself.CARGA_COMPLETA = 0;
        await objself.save();
        
        await onEditorAction(objself.MAP_PARENT);
        
        ui.showToast("Marcado para reprocesado correctamente.");
    }else{
        ui.showToast("La OT no descarga los datos de GAMAD");
    }
}

async function GuardarCambiosOT(objself){
    var a = ui.msgBox("¿Está seguro que desea guardar los cambios?","¡ATENCION!",1);
  	if (a == 1){
  	    await RegistrarAccionUsuario("Actualizando el resgistro.","gen_ot_cabecera",objself.ROWID);
  	    objself.NOMBRE_FICHERO_PDF = objself.MAP_NOMBRE_FICHERO_PDF;
  	    objself.MAP_NOMBRE_FICHERO_PDF_EDIT = 0;
	    await objself.save();
    }
}

async function reprocesarProcesadoComprobarFoto(objself,fieldName,fieldName2,valor){
    // revisamos si la OT tiene fotos pendientes de reprocesar ...
    let collfoto = appData.getCollection("ListadoFotosOT");
    collfoto.setFilter("NUMEROORDEN='"+objself.NUMEROORDEN+"' AND ORIGEN='M' AND BAJA=0 AND PROCESADO=-1");
    
    collfoto.clear();
    await collfoto.loadAll();
    
    if(collfoto.getCount() > 0){
        // userMsgBox("La OT tiene fotos pendientes de reprocesar. Por favor, reprocéselas primero.", "¡ATENCION!",0,"#e04c41");
        let pregunta = ui.msgBox("La Ot tiene " +collfoto.getCount()+ " fotos procesadas con error. ¿Desea reprocesaralas? ","¡ATENCION!",1);
        
        if(pregunta == 1){
            
            for(var i = 0;i < collfoto.getCount();i++){
                let item = collfoto.getItem(i);
                // await reprocesarProcesadoFoto(item,'PROCESADO','MAP_PROCESADO',0);
                item.PROCESADO = 0;
                item.MAP_PROCESADO = "Pendt";
                item.MAP_BGCOLOR = "#ffffff";
                
                await item.save();
                
          	    await RegistrarAccionUsuario("Actualizando el resgistro.","gen_ot_fotos",item.ROWID);
            }
            
            ui.getView(objself.getParent()).refresh("ListadoFotosOTreprocesar");
            await onEditorAction(objself.getParent().MAP_PARENT);
            
            // Reprocesamos el registro tras reprocesar las fotos
            objself[fieldName] = valor;
            objself[fieldName2] = "Pendt";
            objself.MAP_BGCOLOR = "#ffffff";
            await objself.save();
        
      	    await RegistrarAccionUsuario("Actualizando el resgistro.","gen_ot_estados",objself.ROWID);
            ui.getView(objself.getParent()).refresh("ListadoOtEstados");
            await onEditorAction(objself.getParent().MAP_PARENT);
            
            ui.showToast("Marcado para reprocesado correctamente.");
        }
    }else{
        await reprocesarProcesado(objself,fieldName,fieldName2,valor);
    }
}

async function reprocesarProcesado(objself,fieldName,fieldName2,valor){
    var a = ui.msgBox("¿Está seguro que desea reprocesar el registro?","¡ATENCION!",1);
  	if (a == 1){
        objself[fieldName] = valor;
        objself[fieldName2] = "Pendt";
        objself.MAP_BGCOLOR = "#ffffff";
        
        if(fieldName == "PROCESADO_GAMAD"){
            // revisamos que tenga ficheros adjuntos ...
            let collfoto = appData.getCollection("ListadoFotosOT");
            collfoto.setFilter("NUMEROORDEN='"+objself.NUMEROORDEN+"' AND ORIGEN='M' AND BAJA=0 AND TIPO NOT IN ('APOYO','NO_ACCESIBLE','AVISO','TERMOGRAFIA')");
            
            collfoto.clear();
            await collfoto.loadAll();
            
            if(collfoto.getCount() > 0){
                for(let i=0;i < collfoto.getCount(); i++){
                    let item = collfoto.getItem(i);
                    item.PROCESADO=0;
                    await item.save();
                    
                    await RegistrarAccionUsuario("Actualizando el resgistro.","gen_ot_fotos",item.ROWID);
                }
            }
        }
        
        // Si reprocesamos sic, reprocesamos GAMAD.
        if(fieldName == "PROCESADO_SIC"){
            objself.PROCESADO_GAMAD = -2;
            objself.MAP_PROCESADO_GAMAD_DESC = "Pendt";
        }
        
        await objself.save();
        
  	    await RegistrarAccionUsuario("Actualizando el resgistro.","gen_ot_estados",objself.ROWID);
  	    
        ui.getView(objself.getParent()).refresh("ListadoOtEstados");
        
        await onEditorAction(objself.getParent().MAP_PARENT);
        
        ui.showToast("Marcado para reprocesado correctamente.");
  	}
}

async function reprocesarProcesadoFoto(objself,fieldName,fieldName2,valor){
    var a = ui.msgBox("¿Está seguro que desea marcar como no procesado el registro?","¡ATENCION!",1);
  	if (a == 1){
        objself[fieldName] = valor;
        objself[fieldName2] = "Pendiente de procesar";
        objself.MAP_BGCOLOR = "#ffffff";
        
        await objself.save();
        
  	    await RegistrarAccionUsuario("Actualizando el resgistro.","gen_ot_fotos",objself.ROWID);
  	    
        ui.getView(objself.getParent()).refresh("ListadoFotosOTreprocesar");
        
        await onEditorAction(objself.getParent().MAP_PARENT);
        
        ui.showToast("Marcado para reprocesado correctamente.");
  	}
}

async function refrescarListado(objself,contentName){
    var content = objself.getContents("@"+contentName);
    
    content.unlock();
    content.clear();
    
    try{
        ui.showWaitDialog();
        await content.loadAll();
    }catch(e){
        ui.showToast("Ha ocurrido un error");
    }finally{
        ui.hideWaitDialog();
    }
    
    content.lock();
    ui.getView(objself).refresh(contentName);
}

async function refrescarListadoConFiltro(objself,contentName){
    let content;
    
    switch(contentName){
        case "ListadoEstadisticas":
            content = objself.getContents("@"+contentName);
            content.unlock();
            if(objself.MAP_FILTRO_TYPE5 == 1){
                content.setMacro("##FILTRO##","HORA >= CURDATE()")    
            }else{
                content.setMacro("##FILTRO##","HORA >= STR_TO_DATE('"+objself.MAP_FILTR05+"', '%Y-%m-%d') AND HORA < STR_TO_DATE('"+objself.MAP_FILTR05+"', '%Y-%m-%d') + INTERVAL 1 DAY")  
            }
            break;
        case "ListadoEstadisticasOPQUEUE":
            content = objself.getContents("@"+contentName);
            content.unlock();
            if(objself.MAP_FILTRO_TYPE52 == 1){
                content.setMacro("##FILTRO##","HORA >= CURDATE()")    
            }else{
                content.setMacro("##FILTRO##","HORA >= STR_TO_DATE('"+objself.MAP_FILTR052+"', '%Y-%m-%d') AND HORA < STR_TO_DATE('"+objself.MAP_FILTR052+"', '%Y-%m-%d') + INTERVAL 1 DAY")  
            }
            break;
        case "ListadoEstadisticasOPSQUEUE":
            content = objself.getContents("@"+contentName);
            content.unlock();
            if(objself.MAP_FILTRO_TYPE53 == 1){
                content.setMacro("##FILTRO##","FECHA_HORA >= CURDATE()")    
            }else{
                content.setMacro("##FILTRO##","FECHA_HORA >= STR_TO_DATE('"+objself.MAP_FILTR053+"', '%Y-%m-%d') AND FECHA_HORA < STR_TO_DATE('"+objself.MAP_FILTR053+"', '%Y-%m-%d') + INTERVAL 1 DAY")  
            }
            break;
        case "ListadoEstadisticasDispositivosRep":
            content = objself.getContents("@"+contentName);
            content.unlock();
            if(objself.MAP_FILTRO_TYPE54 == 1){
                content.setMacro("##FILTRO##","HORA >= CURDATE()")    
            }else{
                content.setMacro("##FILTRO##","HORA >= STR_TO_DATE('"+objself.MAP_FILTR054+"', '%Y-%m-%d') AND HORA < STR_TO_DATE('"+objself.MAP_FILTR054+"', '%Y-%m-%d') + INTERVAL 1 DAY")  
            }
            break;
        case "ListadoEstadisticasOperSelectReplic":
            content = objself.getContents("@"+contentName);
            content.unlock();
            if(objself.MAP_FILTRO_TYPE55 == 1){
                content.setMacro("##FILTRO##","FECHA_HORA >= CURDATE()")    
            }else{
                content.setMacro("##FILTRO##","FECHA_HORA >= STR_TO_DATE('"+objself.MAP_FILTR055+"', '%Y-%m-%d') AND FECHA_HORA < STR_TO_DATE('"+objself.MAP_FILTR055+"', '%Y-%m-%d') + INTERVAL 1 DAY")  
            }
            break;
        case "ListadoDispositivoConOpPenDescargar":
            content = objself.getContents("@"+contentName);
            content.unlock();
            if(objself.MAP_FILTRO1 != null){
                if(objself.MAP_FILTRO1.length > 0){
                    var filter = ""
                    if(objself.MAP_FILTRO1.indexOf(",") == -1){
                        filter = " AND s.MID=" + objself.MAP_FILTRO1 + " ";
                    }else{
                        filter = " AND s.MID IN (" + objself.MAP_FILTRO1 + ") ";
                    }
                    content.setMacro("##MACRO##",filter);
                }else{
                    content.setMacro("##MACRO##","");
                }
            }else{
                content.setMacro("##MACRO##","");
            }
            break;
        case "TotalEstadisticasSistema":
            content = objself.getContents("@"+contentName);
            content.unlock();
            break;
    }
    
    await refrescarListado(objself,contentName);
}


async function GuardarCalculoHoras(ot,valorEstado,valorFechaEstado,estado){
    // Primero obtenemos los expedientes ...
    let expedientes = await ObtenerTodosLosExpedientes(ot);
    let collHorasEx = appData.getCollection("OTEstadosEx");
    
    let rowid = null;
    
    if(!estado.ROWID){
        rowid = obtenerRowId("ListadoOtEstados",estado.ID,"e.");
    }else{
        rowid = estado.ROWID;
    }
     
    for(let i=0;i< expedientes.length; i++){
        let expediente = expedientes[i];
        let obj = collHorasEx.findObject("BAJA = 0 AND COD_GEN_OT_ESTADOS='"+rowid+"' AND (TASK_ID='"+estado.TASK_ID+"' or TEMPORAL_TASK_ID='"+estado.TEMPORAL_TASK_ID+"') AND EXPEDIENTE='"+expediente+"'");
        if(obj == null){
            // creamos el nuevo registro ...
            obj = await collHorasEx.createObject();
            obj.NUMEROORDEN = estado.NUMEROORDEN;
            obj.TASK_ID = estado.TASK_ID;
            obj.TEMPORAL_TASK_ID = estado.TEMPORAL_TASK_ID;
            obj.COD_GEN_OT_ESTADOS = rowid;
            obj.EXPEDIENTE = expediente;
            obj.HORAS_VIAJE_CALCULADAS = obj.HORAS_VIAJE_FINALES = 0;
            obj.HORAS_TRABAJO_CALCULADAS = obj.HORAS_TRABAJO_FINALES = 0;
            if(valorEstado == 2 || valorEstado == -1){
                obj.HORAS_VIAJE_CALCULADAS = (new Date() - new Date(valorFechaEstado)) /(1000 * 60 * 60);
                obj.HORAS_VIAJE_FINALES = obj.HORAS_VIAJE_CALCULADAS;
            }
            if(valorEstado == 3 || valorEstado == 6 || valorEstado == -3 || valorEstado == 4 || valorEstado == 7){
                obj.HORAS_TRABAJO_CALCULADAS = (new Date() - new Date(valorFechaEstado)) /(1000 * 60 * 60);
                obj.HORAS_TRABAJO_FINALES = obj.HORAS_TRABAJO_CALCULADAS;
            }
            obj.HORAS_EDITADAS = 0;
            obj.IND_EXP_ADICIONAL = 0;
            obj.FECHA = new Date();
            obj.BAJA = 0;
        }else{
            // actualizamos el regsitro ...
            if(obj.HORAS_EDITADAS == 0){
                if(valorEstado == 2 || valorEstado == -1){
                    obj.HORAS_VIAJE_CALCULADAS = (new Date() - new Date(valorFechaEstado)) /(1000 * 60 * 60);
                    obj.HORAS_VIAJE_FINALES = obj.HORAS_VIAJE_CALCULADAS;
                }
                if(valorEstado == 3 || valorEstado == 6 || valorEstado == -3 || valorEstado == 4 || valorEstado == 7){
                    obj.HORAS_TRABAJO_CALCULADAS = (new Date() - new Date(valorFechaEstado)) /(1000 * 60 * 60);
                    obj.HORAS_TRABAJO_FINALES = obj.HORAS_TRABAJO_CALCULADAS;
                }
            }
        }
        await obj.save();
        
        await RegistrarAccionUsuario("Calculo de horas","ot_estados_ex",obtenerRowId("OTEstadosEx",obj.ID,""));
    }
}

async function ObtenerTodosLosExpedientes(ot){
    
    let sentencia = "";
    
    if(ot.TEMPORAL_TASK_ID == null
        || ot.TEMPORAL_TASK_ID == ""
        || (ot.TEMPORAL_TASK_ID != null && +ot.TEMPORAL_TASK_ID.length == 0)){
            sentencia = "SELECT EXPEDIENTE as MAP_EXPEDIENTE from gen_ot_estados_ex WHERE (TASK_ID='"+ot.TASK_ID+"') AND BAJA=0 AND ID >= (SELECT MIN(ID) FROM gen_ot_estados_ex " +
            " WHERE COD_GEN_OT_ESTADOS in  " +
            " (select E.ROWID " +
            " from gen_ot_estados E " +
            " WHERE E.ID = (select MAX(ID) AS ID " +
            " from gen_ot_estados where TASK_ID = E.TASK_ID and ESTADO in (2,6) " +
            " GROUP BY TASK_ID) and (E.TASK_ID='"+ot.TASK_ID+"') )) GROUP BY EXPEDIENTE";
            
        }else{
    
            sentencia = "SELECT EXPEDIENTE as MAP_EXPEDIENTE from gen_ot_estados_ex WHERE (TEMPORAL_TASK_ID='"+ot.TEMPORAL_TASK_ID+"') AND BAJA=0 AND ID >= (SELECT MIN(ID) FROM gen_ot_estados_ex " +
            " WHERE COD_GEN_OT_ESTADOS in  " +
            " (select E.ROWID " +
            " from gen_ot_estados E " +
            " WHERE E.ID = (select MAX(ID) AS ID " +
            " from gen_ot_estados where TEMPORAL_TASK_ID = E.TEMPORAL_TASK_ID and ESTADO in (2,6) " +
            " GROUP BY TEMPORAL_TASK_ID) and (E.TEMPORAL_TASK_ID='"+ot.TEMPORAL_TASK_ID+"') )) GROUP BY EXPEDIENTE";
            
        }
    
    let coll = appData.getCollection("IHSentenciasCalculoHoras");
    
    coll.setMacro("##SQL##",sentencia);
    coll.clear();
    await coll.loadAll();
    
    if(coll.getCount() > 0){
        let lexpedientes = [];
        
        for(let i=0;i < coll.getCount(); i++){
            let item = coll.getItem(i);
            lexpedientes.push(item.MAP_EXPEDIENTE);
        }
        
        return lexpedientes;
    }
    
    return await ObtenerExpedientesAccesos(ot.DISPOSITIVO);
}

async function ObtenerExpedientesAccesos(dispositivo){
    let coll = appData.getCollection("ListadoUsuariosAccesos");
    
    if(dispositivo == null) return [];
    
    if(dispositivo.length == 0) return [];
    
    coll.setMacro("##DISPOSITIVO##",dispositivo);
    coll.clear();
    await coll.loadAll();
    
    if(coll.getCount() > 0){
        let lexpedientes = [];
        
        let item  = coll.getItem(0);
        
        if(item.EXPEDIENTE != null && item.EXPEDIENTE.length > 0){
            lexpedientes.push(item.EXPEDIENTE);
        }
        if(item.COMPANNERO != null && item.COMPANNERO.length > 0){
            lexpedientes.push(item.COMPANNERO);
        }
        if(item.COMPANNERO2 != null && item.COMPANNERO2.length > 0){
            lexpedientes.push(item.COMPANNERO2);
        }
        if(item.COMPANNERO3 != null && item.COMPANNERO3.length > 0){
            lexpedientes.push(item.COMPANNERO3);
        }
        
        return lexpedientes;
    }
}

async function onCheckFilter(objself,propNameOrden,propName,defaultTile){

    if(propNameOrden != "MAP_ESTADO_ORDEN_FECHA_ACCESO"){
        objself.MAP_ESTADO_ORDEN_FECHA_ACCESO = 0;
        objself.setFieldPropertyValue("MAP_ULT_ACCESO","title","F. ÚLT.ACCESO");
        objself.setFieldPropertyValue("MAP_ULT_ACCESO","forecolor","#000000");
        objself.setFieldPropertyValue("MAP_ULT_ACCESO"+"_HR","bgcolor","#000000");
    }

    if(propNameOrden != "MAP_ESTADO_ORDEN_FECHA_SINCRONISMO"){
        objself.MAP_ESTADO_ORDEN_FECHA_SINCRONISMO = 0;
        objself.setFieldPropertyValue("MAP_SINCRONISMO","title","F. SINCRONIZADO");
        objself.setFieldPropertyValue("MAP_SINCRONISMO","forecolor","#000000");
        objself.setFieldPropertyValue("MAP_SINCRONISMO"+"_HR","bgcolor","#000000");
    }

    if(propNameOrden != "MAP_ESTADO_ORDEN_FECHA_CONECTADO"){
        objself.MAP_ESTADO_ORDEN_FECHA_CONECTADO = 0;
        objself.setFieldPropertyValue("MAP_INVENTARYDATE","title","F. CONECTADO");
        objself.setFieldPropertyValue("MAP_INVENTARYDATE","forecolor","#000000");
        objself.setFieldPropertyValue("MAP_INVENTARYDATE"+"_HR","bgcolor","#000000");
    }

    if(propNameOrden != "MAP_ESTADO_ORDEN_FECHA_COMANDO"){
        objself.MAP_ESTADO_ORDEN_FECHA_COMANDO = 0;
        objself.setFieldPropertyValue("MAP_CONEXION","title","F. COMANDO");
        objself.setFieldPropertyValue("MAP_CONEXION","forecolor","#000000");
        objself.setFieldPropertyValue("MAP_CONEXION"+"_HR","bgcolor","#000000");
    }

    
    objself[propNameOrden] = ((objself[propNameOrden]<2) ? objself[propNameOrden]+1 : 0);
    if(objself[propNameOrden] > 0){
        objself.setFieldPropertyValue(propName,"title",defaultTile+" "+((objself[propNameOrden] == 1) ? "⇧" : "⇩"));
        objself.setFieldPropertyValue(propName,"forecolor","#2b7400");
        objself.setFieldPropertyValue(propName+"_HR","bgcolor","#2b7400");
    }else{
        objself.setFieldPropertyValue(propName,"title",defaultTile);
        objself.setFieldPropertyValue(propName,"forecolor","#000000");
        objself.setFieldPropertyValue(propName+"_HR","bgcolor","#000000");
    }
    await onEditorAction(objself);
}

async function guardarCambiosEstados(objself){
    var a = ui.msgBox("¿Está seguro que desea aplicar los cambios?","¡ATENCION!",1);
  	if (a == 1){
        await objself.save();
        
  	    await RegistrarAccionUsuario("Actualizando el registro.","gen_ot_estados",objself.ROWID);
  	    
  	    await refrescarListado(objself.getParent(),'ListadoOtEstados');
  	    
        ui.showToast("Aplicados cambios correctamente.");
  	}
}

async function guardarCambiosBrigada(objself){

    if(objself.MAP_CODBRIGADA_IN=="" && objself.MAP_CODBRIGADA_EX==""){
        ui.showToast("Indique una brigada");
        return;
    }
    
    var a = ui.msgBox("¿Está seguro que desea cambiar la brigada?","¡ATENCION!",1);
  	if (a == 1){
  	    let collDisp = appData.getCollection("DispositivoScript");
  	    collDisp.setFilter("MID="+objself.MID);
        collDisp.clear();
        await collDisp.loadAll();

        let obj = collDisp.getItem(0);
        if(obj){
            if(objself.MAP_CODBRIGADA_IN != ""){
                obj.CODBRIGADA = objself.MAP_CODBRIGADA_IN;
            }
            if(objself.MAP_CODBRIGADA_EX != ""){
                obj.CODBRIGADA = objself.MAP_CODBRIGADA_EX;
            }
            await obj.save();
  	 
  	        await RegistrarAccionUsuario("Actualizando el registro.","gen_device",obj.ROWID);
  	    
            await actualizarAdmSelectivityData(objself);
            
  	        await FiltrarListado(objself,"ListadoDispositivoDatos","MID="+objself.MID);
  	        await FiltrarListado(objself,"ListadoDispositivoSelectividadConfigurada","MID="+objself.MID);
            ui.showToast("Aplicados cambios correctamente.");
            self.executeNode("cambiarBrigada");
        }
  	}
}

async function actualizarAdmSelectivityData(objself){
    let collBrigadas = objself.getContents("@ListadoDispositivoSelectividadConfigurada");
    var fechaAccion;
    let collAdm = appData.getCollection("AdmSelectivityDataScript");
    collAdm.setMacro("##MACRO##","MID="+objself.MID);
    collAdm.clear();
    await collAdm.loadAll();
    
    
    // borramos los registros existentes
    let listDelete = [];
    if(collAdm.getCount() > 0){
        for(var i=0;i<collAdm.count();i++){
            var item = collAdm.getItem(i);
            if(item.MANUAL != 1){
                listDelete.push(item);
            }
        }
        
        for(let j=0;j < listDelete.length; j++ ){
            let item = listDelete[j];
            
            fechaAccion = ObtenerFechaAccionUsuario();
            await RegistrarAccionUsuario("Borrado el registro.","adm_selectivity_data","DELETE_"+objself.MID+"_"+item.COD_BRIGADA_USO+"_"+fechaAccion);
            
            await item.deleteObject();
        }
    }
    
    await FiltrarListado(objself,"ListadoDispositivoSelectividadConfigurada","MID="+objself.MID);
    
    // buscamos los registros existentes en la vista
    let coll2 = appData.getCollection("ViewSelectivityDeviceScript");
    coll2.setMacro("##MACRO##","MID="+objself.MID);
    coll2.clear();
    await coll2.loadAll();
    
    if(coll2.getCount() > 0){
        // creamos los nuevos registros en la primera tabla (adm_selectivity_data)
        for(var j=0;j<coll2.count();j++){
            let objVista = coll2.getItem(j);
            let exists = false;
             
            for(let j=0;j<collBrigadas.getCount();j++){
                let item = collBrigadas.getItem(j);
                if(item.COD_BRIGADA == objVista.COD_BRIGADA){
                    exists = true;
                    break;
                }
            }
            
            if(!exists){
                let nuevoRegistro = await collAdm.createObject();
                
                nuevoRegistro.MID = objVista.MID;
                nuevoRegistro.IMEI = objVista.IMEI;
                nuevoRegistro.COD_BRIGADA = objVista.COD_BRIGADA;
                nuevoRegistro.COD_UTD = objVista.COD_UTD;
                nuevoRegistro.COD_SECTOR = objVista.COD_SECTOR;
                nuevoRegistro.COD_ZONA = objVista.COD_ZONA;
                nuevoRegistro.COD_REGION = objVista.COD_REGION;
                nuevoRegistro.COD_BRIGADA_USO = objVista.COD_BRIGADA_USO;
                nuevoRegistro.COD_UTD_USO = objVista.COD_UTD_USO;
                nuevoRegistro.COD_SECTOR_USO = objVista.COD_SECTOR_USO;
                nuevoRegistro.COD_ZONA_USO = objVista.COD_ZONA_USO;
                nuevoRegistro.COD_REGION_USO = objVista.COD_REGION_USO;
                
                await nuevoRegistro.save();
            
                fechaAccion = ObtenerFechaAccionUsuario();
                await RegistrarAccionUsuario("Creando el registro.","adm_selectivity_data","CREATE_"+objself.MID+"_"+objVista.COD_BRIGADA_USO+"_"+fechaAccion);
            }
        }
        
        await generarProvisioningTask(objself.MID);
    }
}

async function generarProvisioningTask(mid){
    let fecha = ObtenerFechaHoraActual();
    let fechaAccion = ObtenerFechaAccionUsuario();
    
    let coll = appData.getCollection("ProvisioningTaskScript");
    coll.setFilter("MID='"+mid+"' and STATUS=-1");
    coll.clear();
    await coll.loadAll();
    
    if(coll.getCount() <= 0){
        let obj = await coll.createObject();
        
        obj.MID = mid;
        obj.STATUS = -1;
        obj.USERCREATE = "WEB";
        
        await obj.save();
        
        await RegistrarAccionUsuario("Actualizando el registro.","adm_provisioning_task","PROVI_"+mid+"_"+fechaAccion);
    }
}

function ObtenerFechaHoraActual(formato){
	return ObtenerFechaActual(formato)+" "+ObtenerHoraActual();
}

function ObtenerFechaActual(formato){
	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth()+1; //January is 0!
	var yyyy = today.getFullYear();
 
	if(dd<10) {
	    dd='0'+dd;
	} 
 
	if(mm<10) {
	    mm='0'+mm;
	} 
 	if (formato=="dmy") today = dd+'-'+mm+'-'+yyyy;
 	else today = yyyy+'-'+mm+'-'+dd;
	return today;
}

function ObtenerHoraActual(){
	var ahora = new Date();
	var hh = ahora.getHours();
	var mm = ahora.getMinutes();
	var ss = ahora.getSeconds();
 
	if(hh<10) {
	    hh='0'+hh;
	} 
 
	if(mm<10) {
	    mm='0'+mm;
	} 
	if(ss<10) {
	    ss='0'+ss;
	}
 
	ahora = hh+':'+mm+':'+ss;
	return ahora;
}

function ObtenerFechaAccionUsuario(){
	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth()+1; //January is 0!
	var yyyy = today.getFullYear();
	var h = today.getHours();
	var m = today.getMinutes();
	var s = today.getSeconds();
 
	if(dd<10) {
	    dd='0'+dd;
	} 
 
	if(mm<10) {
	    mm='0'+mm;
	} 

    today = yyyy+mm+dd+h+m+s;
	return today;
}

async function marcarProcesado(objself,fieldName,fieldName2,valor){
    var a = ui.msgBox("¿Está seguro que desea marcar como no procesado el registro?","¡ATENCION!",1);
  	if (a == 1){
        objself[fieldName] = valor;
        objself[fieldName2] = "-";
        objself.MAP_BGCOLOR = "#ffffff";
        
        await objself.save();
        
  	    await RegistrarAccionUsuario("Actualizando el resgistro.","gen_ot_estados",objself.ROWID);
  	    
        ui.getView(objself.getParent()).refresh("ListadoOtEstados");
        
        await onEditorAction(objself.getParent().MAP_PARENT);
        
        ui.showToast("Marcado para procesado correctamente.");
  	}
}


function obtenerFechaHoraMenos(objDate, intHours) {
    var numberOfMlSeconds = objDate.getTime();
    var addMlSeconds = (intHours * 60) * 60000;
    var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
    return newDateObj;
}

function separadorDeMiles(numero) {
  // Convierto el número a string.
  let str = numero.toString();
  // Aquí almacenaremos los resultados.
  let resultado = "";

  // Recorremos el string con for "str.length" veces.
  for (let i = 0; i < str.length; i++) {
    // Cada número, lo concatenamos a "resultado".
    resultado += str[i];

    // y luego de concatenar el número, verifico si el iterador es un múltiplo de 3.
    // ponemos "i < str.length - 1" para evitar que el punto se agregue al final del string.
    if ((str.length - i - 1) % 3 === 0 && i < str.length - 1) {
      resultado += ".";
    }
  }

  return resultado;
}


async function obtenertTotalOperacionesQueue(){
    var newDate = new Date();
    let fechaActualHoraMenos = obtenerFechaHoraMenos(newDate,1);
    let coll = appData.getCollection("OperacionesQueueUltimaHora");
    coll.setMacro("##MACRO##","FECHA_HORA > '"+fechaActualHoraMenos+"'");
    coll.clear();
    await coll.loadAll();
    
    let obj = coll.getItem(0);
    self.MAP_TOTAL_OPERACIONES = separadorDeMiles(obj.MAP_TOTAL_OPERACIONES);
}

async function obtenertTotalOperacionePendAnalizar(){
    let coll = appData.getCollection("TotalOperacionesPendAnalizar");
    coll.clear();
    await coll.loadAll();
    
    let obj = coll.getItem(0);
    self.MAP_TOTAL_OP_PEN_ANALIZAR = separadorDeMiles(obj.MAP_TOTAL_OPERACIONES);
    self.MAP_MEDIA_OP_PEN_ANALIZAR = separadorDeMiles(obj.MAP_MEDIA_OPERACIONES);
}

async function obtenertTotalEstadisticaSistema(objself){
    let coll = objself.getContents("TotalEstadisticasSistema");
    coll.clear();
    await coll.loadAll();
    await refrescarListado(objself,"TotalEstadisticasSistema");
}


async function obtenertTotalDispositivosUltimaHora(){
    let coll = appData.getCollection("DispositivosUltimaHora");
    coll.clear();
    await coll.loadAll();
    
    let obj = coll.getItem(0);
    self.MAP_TOTAL_DISPOSITIVOS = separadorDeMiles(obj.MAP_TOTAL_DISPOSITIVOS);
}

async function obtenertTotalOperacionesQ(){
    let coll = appData.getCollection("OperacionesTotalesQUEUE");
    coll.clear();
    await coll.loadAll();
    
    let obj = coll.getItem(0);
    self.MAP_TOTAL_OPERACIONES52 = separadorDeMiles(obj.MAP_TOTAL);
}

async function obtenertTotalOperacionesSQ(){
    let coll = appData.getCollection("OperacionesTotalesSQUEUE");
    coll.clear();
    await coll.loadAll();
    
    let obj = coll.getItem(0);
    self.MAP_TOTAL_OPERACIONES53 = separadorDeMiles(obj.MAP_TOTAL);
}

async function obtenertTotalPdfSinGenerarMas10Min(){
    let coll = appData.getCollection("PdfConMas10minutosSinGenerar");
    coll.clear();
    await coll.loadAll();
    
    let obj = coll.getItem(0);
    self.MAP_TOTAL_PDF = separadorDeMiles(obj.MAP_TOTAL);
}

function replaceMacro(val){
    if(val.indexOf("##NULL##") != -1){
        val = null;
    }
    return val;
}

async function AnnadirBrigada(objself){
    let collBrigadas = objself.getContents("@ListadoDispositivoSelectividadConfigurada");
    
    if(objself.MAP_ADD_CODBRIGADA == null 
        || objself.MAP_ADD_CODBRIGADA <= 0) {
        ui.msgBox("Seleccione una brigada.","",0);
        return;   
    }
    
    // buscamos si ya existe la brigada ....
    for(let i=0;i<collBrigadas.getCount();i++){
        let item = collBrigadas.getItem(i);
        if(item.COD_BRIGADA == objself.MAP_ADD_CODBRIGADA){
            // YA EXSITE, mostrar error ....
            ui.msgBox("La brigada " + objself.MAP_ADD_CODBRIGADA_IN + ", ya existe","",0);
            objself.MAP_ADD_BRIGADA_IN = "";
            objself.MAP_ADD_CODBRIGADA_IN = "";
            objself.MAP_ADD_CODBRIGADA = 0;
            return;
        }
    }
    
    let objBrigada = await collBrigadas.createObject();
    objBrigada.COD_BRIGADA = objself.MAP_ADD_CODBRIGADA;
    objBrigada.MID = objself.MID;
    objBrigada.IMEI = objself.MAP_DISPOSITIVO;
    objBrigada.MANUAL = 1;
    objBrigada.COD_BRIGADA_USO = objself.MAP_ADD_CODBRIGADA_IN;
    
    collBrigadas.addItem(objBrigada);
    
    await objBrigada.save();
    
    await RegistrarAccionUsuario("Nuevo registro.","adm_selectivity_data",objBrigada.ID);
    
    await refrescarListado(self,'ListadoDispositivoSelectividadConfigurada');
    CalcularNumeroBrigadas(objself);
    objself.MAP_MOSTRAR_FLOTANTE_ADD_BRIGADA=0;
    
    await generarProvisioningTask(objself.MID);
    
    ui.showToast("Brigada añadida con éxito");
}

async function ActualizarambitoExtendido(objself,borrar){
    
    if(borrar){
        objself.MAP_AMBITO_EXTENDIDO2 = objself.MAP_AMBITO_EXTENDIDO;
    }else{
        if(objself.MAP_AMBITO_EXTENDIDO2 == null){
            ui.msgBox("Indique un ámbito","",0);
            return;
        }
        
        if(objself.MAP_AMBITO_EXTENDIDO2.length < 6){
            ui.msgBox("Indique un ámbito válido","",0);
            return;
        }
        
        if(objself.MAP_AMBITO_EXTENDIDO != null
        && objself.MAP_AMBITO_EXTENDIDO.length > 0){
            var a = ui.msgBox("Ya tiene un ambito asignado, ¿Quiere reemplazarlo?","¡ATENCION!",1);
  	        if (a != 1){ 
  	            return;
  	        }else{
  	            let ambito_aux = objself.MAP_AMBITO_EXTENDIDO2;
  	            // borramos el antiguo ...
  	            await ActualizarambitoExtendido(objself,true);
  	            objself.MAP_AMBITO_EXTENDIDO2 = ambito_aux;
  	        }
        }
    }
    
    var CollZona = appData.getCollection("ListadoBrigadasPorZona");
    var CollSector = appData.getCollection("ListadoBrigadasPorSector");
    var CollUtd = appData.getCollection("ListadoBrigadasPorUtd");
    var CollBrigadaEx = appData.getCollection("ListadoBrigadasPorBrigadaEx");
    var CollBrigadaIn = appData.getCollection("ListadoBrigadasPorBrigadaIn");
    
    CollZona.setMacro("##MACRO##","ZONA.COD_ZONA_USU='"+objself.MAP_AMBITO_EXTENDIDO2+"'");
    CollSector.setMacro("##MACRO##","SECTOR.COD_SECTOR_USU='"+objself.MAP_AMBITO_EXTENDIDO2+"'");
    CollUtd.setMacro("##MACRO##","UTD.COD_UTD_USU='"+objself.MAP_AMBITO_EXTENDIDO2+"'");
    CollBrigadaEx.setMacro("##MACRO##","BRIGADA_EX.COD_BRIGADA_USU_EX='"+objself.MAP_AMBITO_EXTENDIDO2+"'");
    CollBrigadaIn.setMacro("##MACRO##","BRIGADA.COD_BRIGADA_USU='"+objself.MAP_AMBITO_EXTENDIDO2+"'");
    
    CollZona.clear();
    CollSector.clear();
    CollUtd.clear();
    CollBrigadaEx.clear();
    CollBrigadaIn.clear();
    
    await CollZona.loadAll();
    if(CollZona.getCount() > 0){
        if(borrar){
            await BorrarBrigadasDesdeAmbito(CollZona,objself);
        }else{
            await AnnaDirBrigadasDesdeAmbito(CollZona,objself);
        }
        
        await refrescarListado(self,'ListadoDispositivoSelectividadConfigurada');
        CalcularNumeroBrigadas(objself);
        objself.MAP_MOSTRAR_FLOTANTE_AMBITO_EXTENDIDO=0;
        
        await generarProvisioningTask(objself.MID);
        
        ui.showToast("Brigadas añadidas con éxito");
        
        return;
    }
    
    await CollSector.loadAll();
    if(CollSector.getCount() > 0){
        if(borrar){
            await BorrarBrigadasDesdeAmbito(CollSector,objself);
        }else{
            await AnnaDirBrigadasDesdeAmbito(CollSector,objself);
        }
        
        await refrescarListado(self,'ListadoDispositivoSelectividadConfigurada');
        CalcularNumeroBrigadas(objself);
        objself.MAP_MOSTRAR_FLOTANTE_AMBITO_EXTENDIDO=0;
        
        await generarProvisioningTask(objself.MID);
        
        ui.showToast("Brigadas añadidas con éxito");
        return;
    }
    
    await CollUtd.loadAll();
    if(CollUtd.getCount() > 0){
        if(borrar){
            await BorrarBrigadasDesdeAmbito(CollUtd,objself);
        }else{
            await AnnaDirBrigadasDesdeAmbito(CollUtd,objself);
        }
        
        await refrescarListado(self,'ListadoDispositivoSelectividadConfigurada');
        CalcularNumeroBrigadas(objself);
        objself.MAP_MOSTRAR_FLOTANTE_AMBITO_EXTENDIDO=0;
        
        await generarProvisioningTask(objself.MID);
        
        ui.showToast("Brigadas añadidas con éxito");
        return;
    }
    
    await CollBrigadaEx.loadAll();
    if(CollBrigadaEx.getCount() > 0){
        if(borrar){
            await BorrarBrigadasDesdeAmbito(CollBrigadaEx,objself);
        }else{
            await AnnaDirBrigadasDesdeAmbito(CollBrigadaEx,objself);
        }
        
        await refrescarListado(self,'ListadoDispositivoSelectividadConfigurada');
        CalcularNumeroBrigadas(objself);
        objself.MAP_MOSTRAR_FLOTANTE_AMBITO_EXTENDIDO=0;
        
        await generarProvisioningTask(objself.MID);
        
        ui.showToast("Brigadas añadidas con éxito");
        return;
    }
    
    await CollBrigadaIn.loadAll();
    if(CollBrigadaIn.getCount() > 0){
        if(borrar){
            await BorrarBrigadasDesdeAmbito(CollBrigadaIn,objself);
        }else{
            await AnnaDirBrigadasDesdeAmbito(CollBrigadaIn,objself);
        }
        
        await refrescarListado(self,'ListadoDispositivoSelectividadConfigurada');
        CalcularNumeroBrigadas(objself);
        objself.MAP_MOSTRAR_FLOTANTE_AMBITO_EXTENDIDO=0;
        
        await generarProvisioningTask(objself.MID);
        
        ui.showToast("Brigadas añadidas con éxito");
        return;
    }
    
    // Si llega aqui no ha encontrado nada ....
    ui.msgBox("No se ha encontrado brigadas internas asociadas al ambito indicado.","",0);
    return;
}

function CalcularNumeroBrigadas(objself){
   let selectividad = objself.getContents("@ListadoDispositivoSelectividadConfigurada");
   objself.MAP_NUMERO_BRIGADAS = selectividad.getCount();
}

async function AnnaDirBrigadasDesdeAmbito(content, objself){
    let collBrigadas = objself.getContents("@ListadoDispositivoSelectividadConfigurada");
    
    for(let i=0;i<content.getCount();i++){
        let item2 = content.getItem(i);
        let exists = false;
        // comprobamos si exsite la brigada...
        for(let j=0;j<collBrigadas.getCount();j++){
            let item = collBrigadas.getItem(j);
            if(item.COD_BRIGADA == item2.COD_BRIGADA){
                exists = true;
                break;
            }
        }
        
        if (!exists){
            let objBrigada = await collBrigadas.createObject();
            objBrigada.COD_BRIGADA = item2.COD_BRIGADA;
            objBrigada.MID = objself.MID;
            objBrigada.IMEI = objself.MAP_DISPOSITIVO;
            objBrigada.MANUAL = 1;
            objBrigada.COD_BRIGADA_USO = item2.COD_BRIGADA_USU;
            
            collBrigadas.addItem(objBrigada);
            
            await objBrigada.save();
            
            await RegistrarAccionUsuario("Nuevo registro.","adm_selectivity_data",objBrigada.ID);
        }
    }
    
    let dDispositivo = objself.getContents("@ListadoDispositivoDatos");
    if(dDispositivo.getCount() > 0){
        let item = dDispositivo.getItem(0);
        item.AMBITO_EXTENDIDO = objself.MAP_AMBITO_EXTENDIDO2;
        await item.save();
        
        objself.MAP_AMBITO_EXTENDIDO = objself.MAP_AMBITO_EXTENDIDO2;
        
        await RegistrarAccionUsuario("Actualizacion registro.","gen_device",item.ROWID);
    }
}

async function BorrarBrigadasDesdeAmbito(content, objself){
    let collBrigadas = objself.getContents("@ListadoDispositivoSelectividadConfigurada");
    let borrados = [];
    let hayDelete = false;
    
    for(let i=0;i<content.getCount();i++){
        let item2 = content.getItem(i);
        // comprobamos si exsite la brigada...
        for(let j=0;j<collBrigadas.getCount();j++){
            let item = collBrigadas.getItem(j);
            if(item.COD_BRIGADA == item2.COD_BRIGADA && item.MANUAL == 1){
                hayDelete = true;
                borrados.push(item);
                break;
            }
        }
    }
    
    if(hayDelete){
        for(let i=0; i < borrados.length;i++){
            await RegistrarAccionUsuario("Borrado físico registro","ListadoDispositivoSelectividadConfigurada",borrados[i].ROWID);
	        borrados[i].deleteObject();
        } 
    }
    
    let dDispositivo = objself.getContents("@ListadoDispositivoDatos");
    if(dDispositivo.getCount() > 0){
        let item = dDispositivo.getItem(0);
        item.AMBITO_EXTENDIDO = "";
        await item.save();
        
        objself.MAP_AMBITO_EXTENDIDO = "";
        
        await RegistrarAccionUsuario("Actualizacion registro.","gen_device",item.ROWID);
    }
}

async function AplicarCambiosListadoSelectividad(objself){
    await AplicarCambiosListado('ListadoDispositivoSelectividadConfigurada',null,false);
    CalcularNumeroBrigadas(objself);
    await generarProvisioningTask(objself.MID);
}

async function reprocesarElementosDatamatrix(objself){
    
    if(objself.MAP_ELEMENTOS == "Sin selección ..." ||  objself.MAP_ELEMENTOS == ""){
        ui.showToast("Seleccione un elemento.");
        return;
    }
    
    let collDtx = appData.getCollection("ListadoElementosSinDatamatrixProcesado");
    collDtx.clear()
    collDtx.setMacro("##TIPO_TABLA##",objself.MAP_ELEMENTOS);
    await collDtx.loadAll();
    
    if(collDtx.getCount() > 0){
        let a = ui.msgBox("Se detectaron " + collDtx.getCount() + "elementos. ¿Quiere reprocesar?","¡ATENCION!",1);
  		if (a == 1){
  		    /*
  		     *  ID
                NUMEROORDEN
                G3E_FID
                G3E_FNO
                TABLA
                ATTR
                VALOR 
  		     */
  		     for(let i=0; i< collDtx.getCount() ; i++){
  		         let item = collDtx.getItem(i);
  		         let respuestaFormateada = await InterpretarRespuestaServicioDataMatrix({MAP_TIPO_ELEMENTO:objself.MAP_ELEMENTOS},item.VALOR);
  		         await GuardarPropiedad({
                        MAP_PROPIEDAD : "DATAMATRIX_PROCESADO",
                        MAP_VALUE: 1,
                        G3E_FID: item.G3E_FID,
                        G3E_FNO: item.G3E_FNO,
                        TABLA: item.TABLA,
                        NUMEROORDEN: item.NUMEROORDEN,
                        ID_OBRA_GENERADORA: item.ID_OBRA_GENERADORA
                    },JSON.stringify(respuestaFormateada),"");
                // TODO: Ver si tenemos que comprobar tambien los valores de las propiedades ....
                // 2525	1-20-1-B4BD5F6D7EE74533A47AA31345B9
                // INSERT INTO gen_ri_ot_propiedades_actualizadas (ROWID,G3E_FID,G3E_FNO,TABLA,ID_OBRA_GENERADORA,FECHA_REGISTRO,MODIFICACION,VALOR_ANT,VALOR,ATTR) VALUES ('39189e6d-b352-b12a-4d44-2e1c67a7c55c',117093872,907,'CELDA','101198504','yyyy/mm/dd hh:mm:ss',1,NULL,'{"NUM_SERIE":"CV528320-000020/001","FEC_FABRIC":"01/05/2022","NUM_MAT_SAP":5042246,"COD_FAB_CELDA":135,"INT_ADM_CORTA_DURAC":20,"COD_TIP_TECNO_CELDA":30,"COD_TIP_PAT_CELDA":20,"COD_TIP_CELDA":20,"COD_TIP_AUTOMATIZACION":2,"COD_TENS_NOMI":24,"COD_MOD_CELDA":101,"COD_INT_NOMI":35,"COD_FUN_CELDA":130,"MID_CELDA":2135,"COD_FAB":null,"COD_TENS_NOMI_PRI":null,"COD_TENS_NOMI_SEC":null,"POT_NOMI_TRAFO":null,"COD_TIP_GRUPO_CONEX_TRAFO":null,"CAN_TENSION_PRI":null,"CAN_TENSION_SEC":null,"DES_TIP_GRUPO_CONEX_TRAFO":null}','DATAMATRIX_PROCESADO')
                let elem = null;
                
                let CollElm = appData.getCollection("Celda");
                CollElm.clear();
                CollElm.setFilter("G3E_FID=" + item.G3E_FID);
                await CollElm.loadAll();
                
                if(CollElm.getCount() > 0){
                    let elem = CollElm.getItem(0);
                    
                    await ComprobarValoresReales(respuestaFormateada,{
                        MAP_PROPIEDAD : "DATAMATRIX_PROCESADO",
                        MAP_VALUE: 1,
                        G3E_FID: item.G3E_FID,
                        G3E_FNO: item.G3E_FNO,
                        TABLA: item.TABLA,
                        NUMEROORDEN: item.NUMEROORDEN,
                        ID_OBRA_GENERADORA: item.ID_OBRA_GENERADORA
                    },elem);
                }
                
  		     }
  		}
    }else{
        ui.showToast("No se ha detectado elementos que procesar.");
    }
}

async function InterpretarRespuestaServicioDataMatrix(objself,respuesta){
    let elementosLeidos = respuesta.split(/<br>|<BR>|\$/);
        
    // MRED-1018 
    if(elementosLeidos.length <= 3){
        // solo contiene 3 o menos campos ...
       throw {message:"Formato inválido.",customError: true};
    }
    
    let formato = obtenerFormato(elementosLeidos);
    
    let respuestaFormateada = await formatearRespuesta(objself,formato, elementosLeidos);
    
    return respuestaFormateada;
}

function obtenerFechaFabricante(campos){
    // MM/YYYY
    let format1 = /^((0[1-9]|1[0-2]){1}\/\d{4})$/g;
    // YYYY
    let format2 = /^(\d{4})$/g;
    // DD/MM/YYYY DD-MM-YYYY
    let format3 = /^([0-2][0-9]|3[0-1])(\/|-)(0[1-9]|1[0-2])\2(\d{4})$/g;
    // DD/MM/YY DD-MM-YY
    let format4 = /^([0-2][0-9]|3[0-1])(\/|-)(0[1-9]|1[0-2])\2(\d{2})$/g;
    
    let posibleFecha = null;
    let esFecha = false;
        
    for(let i=3;i < 5; i++){
        posibleFecha = campos[i];
        
        if(posibleFecha.match(format1) != null){
            posibleFecha = "01/" + posibleFecha;
            esFecha = true;
            break;
        }else if(posibleFecha.match(format2) != null){
            posibleFecha = "01/01/" + posibleFecha;
            esFecha = true;
            break;
        }else if(posibleFecha.match(format3) != null){
            esFecha = true;
            break;
        }else if(posibleFecha.match(format4) != null){
            esFecha = true;
            break;
        }
    }
    
    if (esFecha){
        return posibleFecha;
    }
    
    return null;
}
    
function formatearNumero(valor){
    let format1 = /^\d{1,}$/g;
    
    if(valor.match(format1) != null){
        return Number(valor);
    }
    
    return null;
}

function obtenerFormato(elementos){
    if(elementos[elementos.length-1].indexOf("A002001") != -1 
        || elementos[elementos.length-1].indexOf("A003001") != -1 
        || elementos[elementos.length-1].indexOf("A006001") != -1 ){
        return {tipoFormato:1, esNuevoDatamatrix: true};
    }else{
        return {tipoFormato:2, esNuevoDatamatrix: false};
    }
}

async function GuardarPropiedad(row,valor,valorAnt){
    let collPropiedad = appData.getCollection("RiOtPropiedadesActualizadas");
    let objPropiedad = null;
    let esRecin = false;
    
    if(row.ID_OBRA_GENERADORA == null || row.ID_OBRA_GENERADORA == "" || (row.ID_OBRA_GENERADORA != null && row.ID_OBRA_GENERADORA.length == 0)){
        collPropiedad.setFilter("G3E_FID=" + row.G3E_FID + " and G3E_FNO=" + row.G3E_FNO
        + " and TABLA='" + row.TABLA + "' "
        + " and NUMEROORDEN='" + row.NUMEROORDEN + "' "
        + " and ATTR='" + row.MAP_PROPIEDAD + "' ");    
    }else{
        collPropiedad.setFilter("G3E_FID=" + row.G3E_FID + " and G3E_FNO=" + row.G3E_FNO
        + " and TABLA='" + row.TABLA + "' "
        + " and ID_OBRA_GENERADORA='" + row.ID_OBRA_GENERADORA + "' "
        + " and ATTR='" + row.MAP_PROPIEDAD + "' ");  
        esRecin = true;
    }
    
    collPropiedad.clear();
    await collPropiedad.loadAll();
    if(collPropiedad.getCount()){
        objPropiedad = collPropiedad.getItem(0);
    }
    
    if(objPropiedad != null){
        if(row.MAP_VALUE == 0){
            objPropiedad.MODIFICACION = 0;
            objPropiedad.BAJA = 1;
            objPropiedad.VALOR = valor;
            objPropiedad.VALOR_ANT = valorAnt;
        }else{
            objPropiedad.MODIFICACION = 1;
            objPropiedad.BAJA = 0;
            objPropiedad.VALOR = valor;
            objPropiedad.VALOR_ANT = valorAnt;
        }
        await objPropiedad.save(); 
    }else if (objPropiedad == null && row.MAP_VALUE == 1){
        objPropiedad = await collPropiedad.createObject();
        objPropiedad.G3E_FID = row.G3E_FID;
        objPropiedad.G3E_FNO = row.G3E_FNO;
        objPropiedad.TABLA = row.TABLA;
        if(!esRecin){
            objPropiedad.NUMEROORDEN = row.NUMEROORDEN;
        }else{
            objPropiedad.ID_OBRA_GENERADORA = row.ID_OBRA_GENERADORA;
        }
        objPropiedad.ATTR = row.MAP_PROPIEDAD;
        objPropiedad.FECHA_REGISTRO = new Date();
        objPropiedad.MODIFICACION = 1;
        objPropiedad.VALOR = valor;
        objPropiedad.VALOR_ANT = valorAnt;
        
        await objPropiedad.save(); 
    }
}

async function formatearRespuesta(objself, formato, campos){
    let respuestaFormateada = {
        NUM_SERIE: null,
        FEC_FABRIC: null,
        NUM_MAT_SAP: null,
        COD_FAB_CELDA: null,
        INT_ADM_CORTA_DURAC: null,
        COD_TIP_TECNO_CELDA: null,
        COD_TIP_PAT_CELDA: null,
        COD_TIP_CELDA: null,
        COD_TIP_AUTOMATIZACION: null,
        COD_TENS_NOMI: null,
        COD_MOD_CELDA: null,
        COD_INT_NOMI: null,
        COD_FUN_CELDA: null,
        MID_CELDA: null,
        COD_FAB: null,
        COD_TENS_NOMI_PRI: null,
        COD_TENS_NOMI_SEC: null,
        POT_NOMI_TRAFO: null,
        COD_TIP_GRUPO_CONEX_TRAFO: null,
        CAN_TENSION_PRI: null,
        CAN_TENSION_SEC: null,
        DES_TIP_GRUPO_CONEX_TRAFO: null
    }
  
    if(formato.tipoFormato == 1){
        // Nuevo ...
        switch (objself.MAP_TIPO_ELEMENTO) {
            case 'CELDA':
                
                if(campos.length<=17) throw {message:"Formato inválido.",customError: true};
                
                respuestaFormateada.NUM_SERIE = campos[2];
                respuestaFormateada.FEC_FABRIC = campos[4];
                respuestaFormateada.NUM_MAT_SAP = campos[15];
                respuestaFormateada.COD_FAB_CELDA = campos[16];
                respuestaFormateada.COD_MOD_CELDA = campos[17];
                
                let collCeldaMD = appData.getCollection("MaestroVtECeldaMd");
                try{
                    collCeldaMD.clear();
                    collCeldaMD.setFilter("COD_FAB_CELDA="+respuestaFormateada.COD_FAB_CELDA+" AND COD_MOD_CELDA="+respuestaFormateada.COD_MOD_CELDA+" AND NUM_MAT_SAP='"+respuestaFormateada.NUM_MAT_SAP+"'");
                    await collCeldaMD.loadAll();
                }catch(ex){
                    throw {message:"Datamatrix/QR incompatible con el elemento seleccionado.",customError: true};
                }finally{
                    collCeldaMD.setFilter("");    
                }
                
                if(collCeldaMD.getCount() > 0){
                    let item = collCeldaMD.getItem(0);
                    respuestaFormateada.INT_ADM_CORTA_DURAC = item.INT_ADM_CORTA_DURAC;
                    respuestaFormateada.COD_TIP_TECNO_CELDA = item.COD_TIP_TECNO_CELDA;
                    respuestaFormateada.COD_TIP_PAT_CELDA = item.COD_TIP_PAT_CELDA;
                    respuestaFormateada.COD_TIP_CELDA = item.COD_TIP_CELDA;
                    respuestaFormateada.COD_TIP_AUTOMATIZACION = item.COD_TIP_AUTOMATIZACION;
                    respuestaFormateada.COD_TENS_NOMI = item.COD_TENS_NOMI;
                    respuestaFormateada.COD_INT_NOMI = item.COD_INT_NOMI;
                    respuestaFormateada.COD_FUN_CELDA = item.COD_FUN_CELDA;
                    respuestaFormateada.MID_CELDA = item.MID;
                }
                
                break;
            case 'CUADRO_BT':
                
                if(campos.length<=10) throw {message:"Formato inválido.",customError: true};
                
                respuestaFormateada.NUM_SERIE = campos[2];
                respuestaFormateada.FEC_FABRIC = campos[4];
                respuestaFormateada.NUM_MAT_SAP = campos[9];
                respuestaFormateada.COD_FAB = campos[10];
                
                let collCuadroMD = appData.getCollection("MaestroVtECuadrobtMd");
                try{
                    collCuadroMD.clear();
                    collCuadroMD.setFilter("NUM_MAT_SAP="+respuestaFormateada.NUM_MAT_SAP);
                    await collCuadroMD.loadAll();
                }catch(ex){
                    throw {message:"Datamatrix/QR incompatible con el elemento seleccionado.",customError: true};
                }finally{
                    collCuadroMD.setFilter("");    
                }
                
                if(collCuadroMD.getCount() > 0){
                    let item = collCuadroMD.getItem(0);
                    respuestaFormateada.COD_MOD_CUADRO_BT = item.COD_MOD_CUADRO_BT;
                    respuestaFormateada.CAN_SALID_POSIBLES = item.CAN_SALID_POSIBLES;
                }
                
                
                break;
            case 'TRAFO':
                
                if(campos.length<=24) throw {message:"Formato inválido.",customError: true};
                
                respuestaFormateada.NUM_SERIE = campos[2];
                respuestaFormateada.FEC_FABRIC = campos[4];
                respuestaFormateada.COD_TENS_NOMI_PRI = campos[5];
                respuestaFormateada.COD_TENS_NOMI_SEC = campos[6];
                respuestaFormateada.POT_NOMI_TRAFO = campos[7];
                respuestaFormateada.COD_TIP_GRUPO_CONEX_TRAFO = campos[9];
                respuestaFormateada.NUM_MAT_SAP = campos[23];
                respuestaFormateada.COD_FAB = campos[24];
                
                
                let collVETensDiseVl = appData.getCollection("MaestroVETensDiseVl");
                try{
                    collVETensDiseVl.clear();
                    collVETensDiseVl.setFilter("COD_TENS_NOMI="+respuestaFormateada.COD_TENS_NOMI_PRI);
                    await collVETensDiseVl.loadAll();
                }catch(ex){
                    throw {message:"Datamatrix/QR incompatible con el elemento seleccionado.",customError: true};
                }finally{
                    collVETensDiseVl.setFilter("");    
                }
                
                if(collVETensDiseVl.getCount() > 0){
                    let item1 = collVETensDiseVl.getItem(0);
                    respuestaFormateada.COD_TENS_NOMI_PRI = item1.CAN_TENSION * 1000;
                }
                
                collVETensDiseVl = appData.getCollection("MaestroVETensDiseVl");
                try{
                    collVETensDiseVl.clear();
                    collVETensDiseVl.setFilter("COD_TENS_NOMI="+respuestaFormateada.COD_TENS_NOMI_SEC);
                    await collVETensDiseVl.loadAll();
                }catch(ex){
                    throw {message:"Datamatrix/QR incompatible con el elemento seleccionado.",customError: true};
                }finally{
                    collVETensDiseVl.setFilter("");    
                }
                
                if(collVETensDiseVl.getCount() > 0){
                    let item2 = collVETensDiseVl.getItem(0);
                    respuestaFormateada.COD_TENS_NOMI_SEC = item2.CAN_TENSION * 1000;
                }
                
                let collVETipGrconextrafoVl = appData.getCollection("MaestroVETipGrconextrafoVl");
                try{
                    collVETipGrconextrafoVl.clear();
                    collVETipGrconextrafoVl.setFilter("COD_TIP_GRUPO_CONEX_TRAFO="+respuestaFormateada.COD_TIP_GRUPO_CONEX_TRAFO);
                    await collVETipGrconextrafoVl.loadAll();
                }catch(ex){
                    throw {message:"Datamatrix/QR incompatible con el elemento seleccionado.",customError: true};
                }finally{
                    collVETipGrconextrafoVl.setFilter("");    
                }
                
                if(collVETipGrconextrafoVl.getCount() > 0){
                    let item3 = collVETipGrconextrafoVl.getItem(0);
                    respuestaFormateada.COD_TIP_GRUPO_CONEX_TRAFO = item3.DES_DESCRIPCION;
                }
                
                break;
            default:
                throw {message:"Elemento no soportado",customError: true};
        }
    }else{
        switch (objself.MAP_TIPO_ELEMENTO) {
            case 'CELDA':
                let fabricante = campos[0];
                
                respuestaFormateada.NUM_SERIE = campos[1];
                respuestaFormateada.FEC_FABRIC = obtenerFechaFabricante(campos);
                
                let procesarCatalogo = false;
                
                switch (fabricante) {
                    case 'ORMAZABAL':
                        switch(campos.length){
                            case 14:
                            case 15:
                            case 16:
                                respuestaFormateada.NUM_MAT_SAP = formatearNumero(campos[campos.length-1]);
                                respuestaFormateada.COD_FAB_CELDA = 111;
                                procesarCatalogo = true;
                                break;
                            case 17:
                            case 18:
                                respuestaFormateada.NUM_MAT_SAP = formatearNumero(campos[campos.length-3]);
                                respuestaFormateada.COD_FAB_CELDA = formatearNumero(campos[campos.length-2]);
                                respuestaFormateada.COD_MOD_CELDA = formatearNumero(campos[campos.length-1]);
                                procesarCatalogo = true;
                                break;
                        }
                        break;
                    case 'IBERICA DE APARELLAJE':
                        switch(campos.length){
                            case 15:
                                respuestaFormateada.NUM_MAT_SAP = formatearNumero(campos[campos.length-2]);
                                respuestaFormateada.COD_FAB_CELDA = formatearNumero(campos[campos.length-1]);
                                procesarCatalogo = true;
                                break;
                            case 16:
                                respuestaFormateada.NUM_MAT_SAP = formatearNumero(campos[campos.length-3]);
                                respuestaFormateada.COD_FAB_CELDA = formatearNumero(campos[campos.length-2]);
                                respuestaFormateada.COD_MOD_CELDA = formatearNumero(campos[campos.length-1]);
                                procesarCatalogo = true;
                                break;
                        }
                        break;
                    case 'IBERICA DE APARALLAJE':
                        respuestaFormateada.NUM_MAT_SAP = formatearNumero(campos[campos.length-2]);
                        respuestaFormateada.COD_FAB_CELDA = formatearNumero(campos[campos.length-1]);
                        procesarCatalogo = true;
                        break;
                    case 'SCHNEIDER ELECTRIC':
                        switch(campos.length){
                            case 15:
                                respuestaFormateada.NUM_MAT_SAP = formatearNumero(campos[campos.length-2]);
                                respuestaFormateada.COD_FAB_CELDA = formatearNumero(campos[campos.length-1]);
                                procesarCatalogo = true;
                                break;
                            case 16:
                                respuestaFormateada.NUM_MAT_SAP = formatearNumero(campos[campos.length-3]);
                                respuestaFormateada.COD_FAB_CELDA = formatearNumero(campos[campos.length-2]);
                                respuestaFormateada.COD_MOD_CELDA = formatearNumero(campos[campos.length-1]);
                                procesarCatalogo = true;
                                break;
                        }
                        break;
                    case 'SIEMENS':
                        switch(campos.length){
                            case 16:
                                respuestaFormateada.NUM_MAT_SAP = formatearNumero(campos[campos.length-3]);
                                respuestaFormateada.COD_FAB_CELDA = formatearNumero(campos[campos.length-2]);
                                procesarCatalogo = true;
                                break;
                            case 17:
                                respuestaFormateada.NUM_MAT_SAP = formatearNumero(campos[campos.length-4]);
                                respuestaFormateada.COD_FAB_CELDA = formatearNumero(campos[campos.length-3]);
                                respuestaFormateada.COD_MOD_CELDA = formatearNumero(campos[campos.length-2]);
                                procesarCatalogo = true;
                                break;
                        }
                        break;
                }
                
                if(procesarCatalogo){
                    let collCeldaMD = appData.getCollection("MaestroVtECeldaMd");
                    try{
                        let cargarDatos = false;
                        
                        collCeldaMD.clear();
                        if(respuestaFormateada.NUM_MAT_SAP != null && respuestaFormateada.COD_FAB_CELDA != null 
                            && respuestaFormateada.COD_MOD_CELDA != null){
                            collCeldaMD.setFilter("COD_FAB_CELDA="+respuestaFormateada.COD_FAB_CELDA+" AND COD_MOD_CELDA="+respuestaFormateada.COD_MOD_CELDA+" AND NUM_MAT_SAP="+respuestaFormateada.NUM_MAT_SAP);
                            cargarDatos = true;
                        }else if (respuestaFormateada.NUM_MAT_SAP != null && respuestaFormateada.COD_FAB_CELDA != null){
                            collCeldaMD.setFilter("COD_FAB_CELDA="+respuestaFormateada.COD_FAB_CELDA+" AND NUM_MAT_SAP="+respuestaFormateada.NUM_MAT_SAP);
                            cargarDatos = true;
                        }else if (respuestaFormateada.COD_FAB_CELDA != null && respuestaFormateada.COD_MOD_CELDA != null){
                            collCeldaMD.setFilter("COD_FAB_CELDA="+respuestaFormateada.COD_FAB_CELDA+" AND COD_MOD_CELDA="+respuestaFormateada.COD_MOD_CELDA);
                            cargarDatos = true;
                        }
                
                
                        if(cargarDatos){
                            await collCeldaMD.loadAll();
                            if(collCeldaMD.getCount() == 1){
                                let item = collCeldaMD.getItem(0);
                                respuestaFormateada.INT_ADM_CORTA_DURAC = item.INT_ADM_CORTA_DURAC;
                                respuestaFormateada.COD_TIP_TECNO_CELDA = item.COD_TIP_TECNO_CELDA;
                                respuestaFormateada.COD_TIP_PAT_CELDA = item.COD_TIP_PAT_CELDA;
                                respuestaFormateada.COD_TIP_CELDA = item.COD_TIP_CELDA;
                                respuestaFormateada.COD_TIP_AUTOMATIZACION = item.COD_TIP_AUTOMATIZACION;
                                respuestaFormateada.COD_TENS_NOMI = item.COD_TENS_NOMI;
                                respuestaFormateada.COD_INT_NOMI = item.COD_INT_NOMI;
                                respuestaFormateada.COD_FUN_CELDA = item.COD_FUN_CELDA;
                                respuestaFormateada.MID_CELDA = item.MID;
                            }else{
                                throw {message:"No se ha podido localizar el material en el catalogo del equipo. Informe de la propiedades incorrectas manualmente",customError: true};
                            }
                        }else{
                            throw {message:"No se ha podido localizar el material en el catalogo del equipo. Informe de la propiedades incorrectas manualmente",customError: true};
                        }
                    }catch(ex){
                        if(typeof ex.customError !== "undefined"){
                            if(ex.customError){
                                throw ex;
                            }
                        }
                        throw {message:"Datamatrix/QR incompatible con el elemento seleccionado.",customError: true};  
                    }finally{
                        collCeldaMD.setFilter("");    
                    }
                }else{
                    throw {message:"No se ha podido localizar el material en el catalogo del equipo. Informe de la propiedades incorrectas manualmente",customError: true};
                }
                
                break;
            case 'CUADRO_BT':
                
                if(campos.length<=4) throw {message:"Formato inválido.",customError: true};
                
                respuestaFormateada.NUM_SERIE = campos[2];
                respuestaFormateada.FEC_FABRIC = campos[4];
                respuestaFormateada.NUM_MAT_SAP = campos[campos.length-2];
                respuestaFormateada.COD_FAB = campos[campos.length-1];
                
                let collCuadroMD = appData.getCollection("MaestroVtECuadrobtMd");
                collCuadroMD.clear();
                try{
                    collCuadroMD.setFilter("NUM_MAT_SAP='"+respuestaFormateada.NUM_MAT_SAP+"'");
                    await collCuadroMD.loadAll();
                    
                    if(collCuadroMD.getCount() > 0){
                        let item = collCuadroMD.getItem(0);
                        respuestaFormateada.COD_MOD_CUADRO_BT = item.COD_MOD_CUADRO_BT;
                        respuestaFormateada.CAN_SALID_POSIBLES = item.CAN_SALID_POSIBLES;
                    }
                }catch(ex){
                    throw {message:"Datamatrix/QR incompatible con el elemento seleccionado.",customError: true};
                }finally{
                    collCuadroMD.setFilter("");    
                }
                
                
                break;
            case 'TRAFO':
                break;
            default:
                throw {message:"Elemento no soportado",customError: true};
        }
    }
        
    return respuestaFormateada;
}

async function ComprobarValoresReales(respuestaFormateada,row,elem){
    let tipo_centro = null;
    
    // obtener el tipo centro
    let collCTTC = appData.getCollection("ObtenerTIpoCentroCT");
    collCTTC.setMacro("##CELDA##",row.G3E_FID);
    collCTTC.clear();
    await collCTTC.loadAll();
    
    if(collCTTC.getCount() == 0){
        let collCTCTC = appData.getCollection("ObtenerTIpoCentroCTC");
        collCTCTC.setMacro("##CELDA##",row.G3E_FID);
        collCTCTC.clear();
        await collCTCTC.loadAll();
        
        if(collCTCTC.getCount() > 0){
            let objCTC = collCTCTC.getItem(0);
            tipo_centro = objCTC.MAP_TIPO_CENTRO;
        }
    }else{
        let objCTCTC = collCTTC.getItem(0);
        tipo_centro = objCTCTC.MAP_TIPO_CENTRO;
    }
    
    if(tipo_centro == null) return;
    
    let coll = null;
    if(row.ID_OBRA_GENERADORA == null || row.ID_OBRA_GENERADORA == "" || (row.ID_OBRA_GENERADORA != null && row.ID_OBRA_GENERADORA.length == 0)){
        coll = appData.getCollection("RiPropiedadesMarcadas");
        coll.setMacro("##G3E_FID##",row.G3E_FID);
        coll.setMacro("##G3E_FNO##",row.G3E_FNO);
        coll.setMacro("##NUMEROORDEN##",row.NUMEROORDEN);
    }
    else{
        coll = appData.getCollection("RiPropiedadesMarcadas");
        coll.setMacro("##G3E_FID##",row.G3E_FID);
        coll.setMacro("##G3E_FNO##",row.G3E_FNO);
        coll.setMacro("##ID_OBRA_GENERADORA##",row.ID_OBRA_GENERADORA);
    }
    
    coll.setFilter("mp.TABLA='"+row.TABLA+"' AND TIPO_CENTRO='"+tipo_centro+"' AND TIPO_PROPIEDAD in ('EXPERTO','AUTOMATICA') AND VISIBLE=1");
    coll.setSort("ORDEN ASC");
    await coll.loadAll();
    
    // PROPIEDAD
    // MAP_DATAMATRIX: (item.DATAMATRIX == 1 || item.CATALOGO == 1) ? 1 : 0,
    // MAP_VALOR_REAL: (item.TIPO_CAMPO == 3) ? this.ObtenerTituloPropiedadesExpertas(item) : this.objself.MAP_ELEMENTO[item.PROPIEDAD],
    
    if(coll.getCount() > 0){
        for(let i=0;i<coll.getCount(); i++){
            let item = coll.getItem(i);
            if(item.DATAMATRIX == 1 || item.CATALOGO == 1){
                if(ComprobarSiEsCorrecto(item,respuestaFormateada,elem) == 1){
                    row.MAP_PROPIEDAD = item.PROPIEDAD;
                    await GuardarPropiedad(row,
                        ObtenerValorSeguro(item,respuestaFormateada),
                        elem[item.PROPIEDAD]);
                }
            }
        }
    }
}


function ObtenerValorSeguro(row,respuesta){
    if(typeof respuesta[row.PROPIEDAD] !== "undefined"){
        return respuesta[row.PROPIEDAD];
    }
    
    return null;
}

function ComprobarSiEsCorrecto(row,respuesta,elem){
    if(typeof respuesta[row.PROPIEDAD] !== "undefined"){
        
        if(respuesta[row.PROPIEDAD] == null) return 1;
        
        let valorReal = (row.TIPO_CAMPO == 3) ? ObtenerTituloPropiedadesExpertas(row,elem) : elem[row.PROPIEDAD];
        
        if(respuesta[row.PROPIEDAD] != valorReal){
            return 1;
        }
    }
    
    return 0;
}

function ObtenerTituloPropiedadesExpertas (propiedad,elem){
    try{
        if(propiedad.FORMATO != null){
            if(propiedad.FORMATO.length > 0 ){
                // ui.msgBox(propiedad.FORMATO,"",0);
                // ui.msgBox(propiedad.PROPIEDAD,"",0);
                // ui.msgBox(this.objself.MAP_ELEMENTO[propiedad.PROPIEDAD],"",0);
                let elm = elem[propiedad.PROPIEDAD];
                if(elm != null){
                    // ui.msgBox(elm,"",0);
                    let dElm = safeToDate(elm);
                    // ui.msgBox(dElm,"",0);
                    let fechaFormateada = propiedad.FORMATO;
                    // ui.msgBox(fechaFormateada,"",0);
                    fechaFormateada = fechaFormateada.replace("YYYY",dElm.getFullYear());
                    fechaFormateada = fechaFormateada.replace("MM",dElm.getMonth()+1);
                    fechaFormateada = fechaFormateada.replace("DD",dElm.getDay());
                    fechaFormateada = fechaFormateada.replace("HH",dElm.getHours());
                    fechaFormateada = fechaFormateada.replace("MI",dElm.getMinutes());
                    fechaFormateada = fechaFormateada.replace("SS",dElm.getSeconds());
                    // ui.msgBox(fechaFormateada,"",0);
                    return fechaFormateada;
                }else{
                    return "";
                }
            }
        }
        return elem[propiedad.PROPIEDAD];
    }catch(e){
        let sterror=e.message;
        ui.showToast(sterror);
        return "";
    }
}

async function ObtenerDatosTabla(objself){
    try
    {
        ui.showWaitDialog();
        var queue = appData.getCollection("MasterReplicaQueue");
        var queueSec = appData.getCollection("MasterReplicaQueueSeq");
        var id = 0;
        
        if(!objself.MAP_TABLA){
            ui.msgBox("Debe indicar una tabla","¡Aviso!",0);
            return;
        }
        
        ui.hideWaitDialog();
        let a = ui.msgBox("¿Está seguro que desea recargar la tabla "+objself.MAP_TABLA+"?","¡ATENCION!",1);
      	if ( a == 1){
            ui.showWaitDialog();
            var genericSQL = appData.getCollection("ReprocesadoGetData");
            genericSQL.setMacro("##SQL##", "select * from " + objself.MAP_TABLA);
            
            genericSQL.clear();
            await genericSQL.loadAll();
            
            var tot = genericSQL.getCount();
            
            if(!tot) {
                ui.showToast("No hay registros que procesar.");
                return;
            }
            if(tot <= 0 ) {
                ui.showToast("No hay registros que procesar.");
                return;
            }
            
            var totst = separadorDeMiles(tot.toString());
            // objself.setFieldPropertyValue("MAP_NUM_REGISTROS","title","(" + totst + ")");
            
            ui.hideWaitDialog();
            let b = ui.msgBox("Hay unos "+totst+" registros ¿Desea continuar?","¡ATENCION!",1);
      	    if ( b == 1){
                ui.showWaitDialog();
      	        var collColumns = appData.getCollection("ReprocesadoGetColumns");
                collColumns.setMacro("##TABLE_NAME##", objself.MAP_TABLA);
                
                collColumns.clear();
                await collColumns.loadAll();
                
                for(var i=0; i<tot ; i++ ){
                    var item = genericSQL.getItem(i);
                    
                    var newQueue = await queue.createObject();
                
                    var sentence = PrepareInsertSQLForMasterReplicaQueue(item,collColumns,objself.MAP_TABLA);
                    var newDate = formatearFechas();
                    
                    if(sentence){
                        if(sentence.length > 0){
                            // newQueue.ID = id;
                            newQueue.ROWID = item.ROWID;
                            newQueue.MID = 9991;
                            newQueue.DMID = 0;
                            newQueue.CGSSQL = sentence;
                            newQueue.OPER = 1; 
                            newQueue.TBL = objself.MAP_TABLA;
                            newQueue.TIMESTAMP = newDate.fmt1;
                            newQueue.OPERID = "1-9991-"+item.ROWID+"-"+newDate.fmt2;
                            
                            await newQueue.save();
                        }
                    }
                }
      	    }
      	}
    }
  	catch(ex){
        let sterror=e.message;
        ui.showToast("Ha ocurrido un error, vuelve a intentarlo.");
  	}finally{
  	    ui.showToast("Proceso terminado");
  	    objself.MAP_TABLA_ID = 0;
  	    objself.MAP_TABLA = "";
        ui.hideWaitDialog();
  	}
}

function PrepareInsertSQLForMasterReplicaQueue(data, columns,table_name){
    var columns_names = "";
    var columns_values = "";
    var sentence = "INSERT INTO "+table_name+" (@columns_names) VALUES (@columns_values)";
    
    for(var i=0;i < columns.getCount(); i++){
        var column = columns.getItem(i);
        
        if(data[column.COLUMN_NAME]){
            var val = data[column.COLUMN_NAME];
            
            if(val){
                if(column.DATA_TYPE == "varchar"){
                    val = "'"+val.replace("'","")+"'";
                }else if (column.DATA_TYPE == "datetime"){
                    // formatear la fecha ...
                    val = "'"+val.replace("T"," ")+"'";
                }
            }else{
                val = "NULL"
            }
            
            if(columns_values.length > 0){
                columns_values += "," + val.toString();
            }else{
                columns_values = val.toString();
            }
            
            if(columns_names.length > 0){
                columns_names += "," + column.COLUMN_NAME.toString();
            }else{
                columns_names = column.COLUMN_NAME.toString();
            }
        }
    }
    
    sentence = sentence.replace("@columns_names",columns_names);
    sentence = sentence.replace("@columns_values",columns_values);
    
    return sentence;
}

function formatearFechas() {
    var fecha = new Date();

    // --- Formato 1: dd-mm-yyyy HH:MI:SS ---

    var dia = fecha.getDate().toString().padStart(2, "0");
    var mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
    var anio = fecha.getFullYear();
    var hora = fecha.getHours().toString().padStart(2, "0");
    var minuto = fecha.getMinutes().toString().padStart(2, "0");
    var segundo = fecha.getSeconds().toString().padStart(2, "0");

    var formato1 = dia+"-"+mes+"-"+anio+" "+hora+":"+minuto+":"+segundo;

    // --- Formato 2: yyyymmddHHMISSZZZ ---
    var miliseg = fecha.getMilliseconds().toString().padStart(3, "0");
    var formato2 = dia.toString()+mes.toString()+anio.toString()+hora.toString()+minuto.toString()+segundo.toString()+miliseg.toString();

    return { "fmt1" : formato1 , "fmt2" : formato2 };
}

var _visorState = { fotos: [], idx: 0, padre: null, keyHandler: null, contentName: null, interactions: 0, limitInteractions: 100};

function _getVisorTipo(nombre) {
    if (!nombre) return 2;
    var ext = nombre.split('.').pop().toLowerCase();
    var imageExts = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'tiff', 'tif', 'svg'];
    return imageExts.indexOf(ext) >= 0 ? 1 : 2;
}

function _getVisorIcono(ext) {
    if (ext === 'pdf')                              return 'icon_pdf.png';
    if (ext === 'doc'  || ext === 'docx')           return 'icon_doc.png';
    if (ext === 'xls'  || ext === 'xlsx')           return 'icon_xls.png';
    if (ext === 'ppt'  || ext === 'pptx')           return 'icon_ppt.png';
    return 'icon_file_generico.png';
}

function descargarDocumento() {
    try {
        var nombre = _visorState.fotos[_visorState.idx].nombre;
        ui.downloadFile(nombre, nombre);
    } catch (e) {
        ui.msgBox(e.message, "", 0);
    }
}

function abrirVisorFotos(self, contentName) {
    var padre = self.getParent();
    var coll  = padre.getContents("@" + contentName);
    var count = coll.getCount();

    // Recopilar todas las fotos de la colección para navegación
    _visorState.fotos = [];
    _visorState.contentName = contentName;
    for (var i = 0; i < count; i++) {
        var item = coll.getItem(i);
        var _ext = item.NOMBRE_FICHERO ? item.NOMBRE_FICHERO.split('.').pop().toLowerCase() : '';
        _visorState.fotos.push({ doc: item.DOC, nombre: item.NOMBRE_FICHERO, id: item.ID , tipo: _getVisorTipo(item.NOMBRE_FICHERO) , extension: _ext });
    }

    // Localizar el índice del elemento actual
    _visorState.idx = 0;
    for (var j = 0; j < _visorState.fotos.length; j++) {
        if (_visorState.fotos[j].id === self.ID) {
            _visorState.idx = j;
            break;
        }
    }

    _visorState.padre = padre;
    padre["MAP_VISOR_ERROR_"+contentName]   = 0;
    padre["MAP_VISOR_LOADING_"+contentName]   = 1;
    _visorActualizar(contentName);
    padre["MAP_VISOR_VISIBLE_"+contentName] = 1;
    
    _subscribirEventos();
    // _subscribirEventosImagen();
    // setTimeout(_subscribirEventosImagen, 500);    
}

function _visorActualizar(contentName) {
    var padre = _visorState.padre;
    var idx   = _visorState.idx;
    var fotos = _visorState.fotos;
    if (!padre || fotos.length === 0) return;
    
    padre["MAP_VISOR_LOADING_"+contentName]   = 1;
    padre["MAP_VISOR_ERROR_"+contentName]   = 0;
    padre["MAP_VISOR_FOTO_"+contentName]     = fotos[idx].nombre; 
    padre["MAP_VISOR_NOMBRE_"+contentName]   = fotos[idx].nombre;
    padre["MAP_VISOR_HAS_PREV_"+contentName] = (idx > 0) ? 1 : 0;
    padre["MAP_VISOR_HAS_NEXT_"+contentName] = (idx < fotos.length - 1) ? 1 : 0;
    padre["MAP_VISOR_IDX_"+contentName]      = idx;
    padre["MAP_VISOR_TIPO_"+contentName]     = fotos[idx].tipo;
    if (fotos[idx].tipo === 2) {
        padre["MAP_VISOR_DOC_ICONO_"+contentName] = _getVisorIcono(fotos[idx].extension);
    }else{
        _visorState.interactions = 0;
        setTimeout(_subscribirEventosImagen, 50);
    }
}

function cerrarVisorFotos(self,contentName) {
    _desubscribirEventos();
    _desubscribirEventosImagen();
    var padre = _visorState.padre || self;
    if (padre) padre["MAP_VISOR_VISIBLE_"+contentName] = 0;
    _visorState.padre = null;
}

function navegarVisorFotos(self, direccion, contentName) {
    var nuevo = _visorState.idx + direccion;
    if (nuevo < 0 || nuevo >= _visorState.fotos.length) return;
    _visorState.idx = nuevo;
    _visorActualizar(contentName);
}

function _subscribirEventosImagen(){
    console.log('intentando subscribirse');
    var img = _webDoc.querySelector('[xone-name="MAP_VISOR_FOTO_'+_visorState.contentName+'"] img');
    if(img){
        img.addEventListener('load',_handleLoadImage);
        img.addEventListener('error',_handleLoadErrorImage);
        _visorState.padre["MAP_VISOR_LOADING_"+_visorState.contentName]   = 0;
        console.log('subscrito');
    }else{
        console.log('no subscrito');
        if(_visorState.interactions < _visorState.limitInteractions){
            _visorState.interactions += 1;
            setTimeout(_subscribirEventosImagen, 50);
        }else{
            _handleLoadErrorImage();
        }
    }
}

function _desubscribirEventosImagen(){
    console.log('no subscrito');
    _visorState.interactions = 0;
    var img = _webDoc.querySelector('[xone-name="MAP_VISOR_FOTO_'+_visorState.contentName+'"] img');
    if(img){
        img.addEventListener('load',_handleLoadImage);
        img.addEventListener('error',_handleLoadErrorImage);
    }
}


function _subscribirEventos(){
    _webDoc.addEventListener('keydown', _handleKeyDown);
}

function _desubscribirEventos(){
    _webDoc.removeEventListener('keydown', _handleKeyDown);
}

function _handleKeyDown(event){
    switch (event.key) {
        case 'ArrowLeft':
          navegarVisorFotos(null,-1,_visorState.contentName);
          break;
        case 'ArrowRight':
          navegarVisorFotos(null,1,_visorState.contentName);
          break;
        case 'Escape':
          cerrarVisorFotos(null,_visorState.contentName);
          break;
      }
}

function _handleLoadImage(){
    console.log('✅ Imagen cargada');
    _visorState.padre["MAP_VISOR_LOADING_"+_visorState.contentName]   = 0;
    _visorState.padre["MAP_VISOR_ERROR_"+_visorState.contentName]   = 0;
}

function _handleLoadErrorImage(){
    console.log('❌ Error al cargar');
    _visorState.padre["MAP_VISOR_ERROR_"+_visorState.contentName]   = 1;
    _visorState.padre["MAP_VISOR_LOADING_"+_visorState.contentName]   = 0;
}


async function mostrarLogNormal(objself){
    await FiltrarListado(objself,"ListadoMredApiLog_G4","NUMEROORDEN='"+objself.NUMEROORDEN+"'","ID DESC");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_NORMAL","bgcolor","#2b7400");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_NORMAL","forecolor","#ffffff");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_HISTORICO","bgcolor","#ffffff");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_HISTORICO","forecolor","#2b7400");
    objself.MAP_VER_HISTORICO = 0;
}

async function mostrarLogHistorico(objself){
    await FiltrarListado(objself,"ListadoMredApiLogHistory_G4","NUMEROORDEN='"+objself.NUMEROORDEN+"'","ID DESC");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_HISTORICO","bgcolor","#2b7400");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_HISTORICO","forecolor","#ffffff");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_NORMAL","bgcolor","#ffffff");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_NORMAL","forecolor","#2b7400");
    objself.MAP_VER_HISTORICO = 1;
}

async function mostrarLogNormalDevice(objself){
    await FiltrarListado(objself,"ListadoMredApiLog_G4","DISPOSITIVO='"+objself.MAP_DISPOSITIVO+"'","ID DESC");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_NORMAL","bgcolor","#2b7400");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_NORMAL","forecolor","#ffffff");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_HISTORICO","bgcolor","#ffffff");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_HISTORICO","forecolor","#2b7400");
    objself.MAP_VER_HISTORICO = 0;
}

async function mostrarLogHistoricoDevice(objself){
    await FiltrarListado(objself,"ListadoMredApiLogHistory_G4","DISPOSITIVO='"+objself.MAP_DISPOSITIVO+"'","ID DESC");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_HISTORICO","bgcolor","#2b7400");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_HISTORICO","forecolor","#ffffff");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_NORMAL","bgcolor","#ffffff");
    objself.setFieldPropertyValue("MAP_MOSTRAR_LOG_NORMAL","forecolor","#2b7400");
    objself.MAP_VER_HISTORICO = 1;
}

async function nuevoTipoFormulario(self) {
    var obj = appData.getCollection("ListadoMaestroTipoFormulario").createObject();
    ui.openEditView(obj);
}

function aplicarFiltro(self) {
    ui.getView(self).refresh("ListadoMaestroTipoFormulario");
}

function VBScriptSupport() {
	this.cstr = function(value) {
		return safeToString(value);
	};
 
	this.now = function() {
		return new Date();
	};
 
	this.len = function(str) {
		return safeToString(str).length;
	};
 
	this.cint = function(value) {
		return parseInt(value);
	};
 
	this.left = function(str, n) {
		if (n <= 0) {
			return new String();
		} else if (n > String(str).length) {
			return safeToString(str);
		} else {
			return safeToString(str).substring(0, n);
		}
	}; 
 
	this.replace = function(source, search, replacement) {
		source = safeToString(source);
		search = safeToString(search);
		replacement = safeToString(replacement);
		search = escapeRegularExpression(search);
		source.replace(search, replacement);
		return source;
	};
 
	this.day = function(mDate) {
		mDate = safeToDate(mDate);
		return mDate.getDate();
	};
 
	this.month = function(mDate) {
		mDate = safeToDate(mDate);
		return mDate.getMonth();
	};
 
	this.year = function(mDate) {
		mDate = safeToDate(mDate);
		return mDate.getFullYear();
	};
 
	this.right = function(str, n) {
		str = new String(str);
		if (n <= 0 || n > str.length) {
			return str;
		} else {
			var iLen = str.length;
			return str.substring(iLen, iLen - n);
		}
	};
 
	this.mid = function(str, start, len) {
		if (start < 0 || len < 0) {
			return str;
		}
		var iEnd, iLen = new String(str).length;
		if (start + len > iLen) {
			iEnd = iLen;
		} else {
			iEnd = start + len;
		}
		return new String(str).substring(start, iEnd);
	};
 
	this.inStr = function(strSearch, charSearchFor) {
		for (let i = 0; i < len(strSearch); i++) {
			if (charSearchFor == this.mid(strSearch, i, 1)) {
				return i;
			}
		}
		return -1;
	};
 
	this.lcase = function(str) {
		if (isString(str)) {
			return str.toLowerCase();
		}
		return new String(str).toLowerCase();
	};
 
	this.ucase = function(str) {
		if (isString(str)) {
			return str.toUpperCase();
		}
		return new String(str).toUpperCase();
	};
 
	this.abs = function(value) {
		return Math.abs(value);
	};
 
	this.trim = function(str) {
		str = safeToString(str);
		return str.trim();
	};
 
	this.split = function(str, delimiter) {
		return str.split(delimiter);
	};
 
	this.dateDiff = function(sPeriod, mDate1, mDate2) {
		mDate1 = safeToDate(mDate1);
		mDate2 = safeToDate(mDate2);
		let nDiff = Math.abs(mDate1.getTime() - mDate2.getTime());
		switch(sPeriod) {
			case "h":
				return nDiff / 3600000;
			case "n":
				return nDiff / 60000;
			default:
				throw new Error("dateDiff(): Unknown date period " + sPeriod);
		}
	};
 
	this.dateAdd = function(sPeriod, nNumber, mDate) {
		mDate = safeToDate(mDate);
		switch(sPeriod) {
			case "yyyy":
				//Year
				mDate.setYear(mDate.getYear() + nNumber);
				return mDate;
			case "q":
				//Quarter
				return mDate;
			case "m":
				//Month
				mDate.setMonth(mDate.getMonth() + nNumber);
				return mDate;
			case "y":
				//Day of year
				return mDate;
			case "d":
				//Day
				mDate.setDate(mDate.getDate() + nNumber);
				return mDate;
			case "w":
				//Weekday
				return mDate;
			case "ww":
				//Week of year
				return mDate;
			case "h":
				//Hour
				mDate.setHours(mDate.getHours() + nNumber);
				return mDate;
			case "n":
				//Minute
				mDate.setMinutes(mDate.getMinutes() + nNumber);
				return mDate;
			case "s":
				//Second
				mDate.setSeconds(mDate.getSeconds() + nNumber);
				return mDate;
			default:
				throw new Error("dateAdd(): Unknown date period " + sPeriod);
		}
	};
}
 
var vbSupport = new VBScriptSupport();
 
function isNothing(obj) {
	if (obj === null) {
		return true;
	}
	if (obj == "undefined") {
		return true;
	}
	return false;
}
 
function isSomething(obj) {
	if (obj === null) {
		return false;
	}
	if (obj == "undefined") {
		return false;
	}
	return true;
}
 
function getClassName(obj) {
	if(isNothing(obj)) {
		return null;
	}
	return obj.constructor.name;
}
 
function isFloatNumber(n) {
	return n === +n && n !== (n | 0);
}
 
function isIntegerNumber(n) {
	return n === +n && n === (n | 0);
}
 
function isNumber(obj) {
	if (isNothing(obj)) {
		return false;
	}
	return !isNaN(parseFloat(obj)) && isFinite(obj);
}
 
function isString(obj) {
	return typeof obj === 'string' || obj instanceof String;
}
 
function isEmptyString(obj) {
	if(!isString(obj)) {
		return false;
	}
	return(!obj || 0 === obj.length);
}
 
function isDate(obj) {
	if (obj instanceof Date) {
		return true;
	}
	return false;
}
 
function safeToString(value) {
	if(isNothing(value)) {
		return new String();
	}
	return new String(value);
}
 
function safeToDate(mDate) {
	if(isDate(mDate)) {
		return mDate;
	}
	return new Date(replaceAll(safeToString(mDate), '-', '/'));
}
 
function escapeRegularExpression(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}
 
function replaceAll(sSource, sSearch, sReplacement) {
	sSearch = escapeRegularExpression(sSearch);
	return sSource.split(sSearch).join(sReplacement);
}

// ===== exports para MPA Island mode =====
export { fileNameEntradaApp, Opciones, SubOpciones, CargarOpciones, filtroMenu, CargarSubOpciones, _webDoc, ObjMenuPadre, comprobarMenu, selectedItemPadre, selectedItemHijo, goToColl, logout, noop, onBack, expandOrCollapseMenu, textoIntroducido, onTextChangetoSearchMenuListado, onEditorAction, FiltrarMenus, FiltrarListado, FiltrarListadoPaginado, obtenerestadoAnteriorOT, PasarOtaAceptada, PasarOtaEnViaje, PasarOtaEnEjecucion, PasarOtaNotificada, PasarOtaFinalizada, PasarOtaRechazada, PasarOtaFinColaboracion, PasarOtaInterrumpida, ObtenerSiguienteDiaLaborable, CrearObjetoContent, OnChangeCamposContent, AplicarCambiosListado, onSaveDataAnMotivosAnulacion, onSaveDataAnTipoAnomalia, onSaveDataAnTipoFoto, onSaveDataArMaestroRiesgo, onSaveDataMaestroTipoFormulario, onSaveDataMaCapaElemento, onSaveDataMaestroClaseActividad, onSaveDataMaestroClaseOrden, onSaveDataMaestroCordenesCactividad, onSaveDataMaestroEstados, onSaveDataMaestroEstadoAviso, onSaveDataMaestroGradoHumedad, onSaveDataMaestroMetodosMedida, onSaveDataMaestroMotivosNoMedicion, onSaveDataMaestroRazonesInterrupcion, onSaveDataMaestroRazonesRechazo, onSaveDataMaestroRegion, onSaveDataMaestroTipoMotivosAviso, onSaveDataMaestroTipoTerreno, onSaveDataOperacioneshr, onSaveDataMaestroAgrupacionesTipeqstar, onSaveDataMaestroExepcionesDatamatrix, onSaveDataMaestroTiposCierre, onSaveDataMaestroZdaccion, onSaveDataMaestroZdactuacion, onSaveDataMaestroZdcausastg, onSaveDataMaestroZdequsgt, onSaveDataMaestroZdgtipinc, onSaveDataMenuMaestroZdrelacDiagno, onSaveDataMaestroZdsGlobal, onSaveDataMaestroZdsgtipinc, onSaveDataMaestroZdsolustg, onSaveDataMaestroZdtipinc, onSaveDataMaestroZdtipodiag, onSaveDataRelacionBrigadas, onSaveDataMaestroPropiedades, onSaveDataMaestroTipoFotos, onSaveDataMaestroTrabtip, onSaveDataMaestroZdptpdc, onSaveDataMaestroZdptda, onSaveDataMaestroZdptca, onSaveDataMaestroRecEstados, onSaveDataMaestroDocumentacion, onSaveDataMaestroListados, Guardar, onValudacionesAnMotivosAnulacion, onValidacionesAnTipoAnomalia, onValidacionesAnTipoFoto, onValidacionesArMaestroRiesgo, onValidacionesFormularios, onValidacionesItfMadrugada, onValidacionesMaestroTipoFormulario, onValidacionesMaCapaElemento, onValidacionesMaestroClaseActividad, onValidacionesMaestroClaseOrden, onValidacionesMaestroCordenesCactividad, onValidacionesMaestroEstados, onValidacionesMaestroEstadoAviso, onValidacionesMaestroGradoHumedad, onValidacionesMaestroMetodosMedida, onValidacionesMaestroMotivosNoMedicion, onValidacionesMaestroRazonesInterrupcion, onValidacionesMaestroRazonesRechazo, onValidacionesMaestroRegion, onValidacionesMaestroTipoMotivosAviso, onValidacionesMaestroTipoTerreno, onValidacionesOperacioneshr, onValidacionesMaestroAgrupacionesTipeqstar, onValidacionesMaestroExepcionesDatamatrix, onValidacionesMaestroTiposCierre, onValidacionesMaestroZdaccion, onValidacionesMaestroZdactuacion, onValidacionesMaestroZdcausastg, onValidacionesMaestroZdequsgt, onValidacionesMaestroZdgtipinc, onValidacionesMaestroZdrelacDiagno, onValidacionesMaestroZdsGlobal, onValidacionesMaestroZdsgtipinc, onValidacionesMaestroZdsolustg, onValidacionesMaestroZdtipinc, onValidacionesMaestroZdtipodiag, onValidacionesRelacionBrigadas, onValidacionesMaestroPropiedades, onValidacionesMaestroTipoFotos, onValidacionesMaestroTrabtip, onValidacionesMaestroZdptpdc, onValidacionesMaestroZdptda, onValidacionesMaestroZdptca, onValidacionesMaestroRecEstados, onValidacionesMaestroDocumentacion, onValidacionesMaestroListados, onValudacionesUsuario, borrarElementoUsuario, confirmarCC, abrirDispositivo, RegistrarAccionUsuario, reintentarCOnseguirCodigoGamad, reintentarEnvioPDFGAMAD, reintentarEnvioPDFIFS, obtenerRowId, ListadoOtActivasSelectedItem, onchangeErrores, reintentarTask_id, reintentarCargaCompleta, GuardarCambiosOT, reprocesarProcesadoComprobarFoto, reprocesarProcesado, reprocesarProcesadoFoto, refrescarListado, refrescarListadoConFiltro, GuardarCalculoHoras, ObtenerTodosLosExpedientes, ObtenerExpedientesAccesos, onCheckFilter, guardarCambiosEstados, guardarCambiosBrigada, actualizarAdmSelectivityData, generarProvisioningTask, ObtenerFechaHoraActual, ObtenerFechaActual, ObtenerHoraActual, ObtenerFechaAccionUsuario, marcarProcesado, obtenerFechaHoraMenos, separadorDeMiles, obtenertTotalOperacionesQueue, obtenertTotalOperacionePendAnalizar, obtenertTotalEstadisticaSistema, obtenertTotalDispositivosUltimaHora, obtenertTotalOperacionesQ, obtenertTotalOperacionesSQ, obtenertTotalPdfSinGenerarMas10Min, replaceMacro, AnnadirBrigada, ActualizarambitoExtendido, CalcularNumeroBrigadas, AnnaDirBrigadasDesdeAmbito, BorrarBrigadasDesdeAmbito, AplicarCambiosListadoSelectividad, reprocesarElementosDatamatrix, InterpretarRespuestaServicioDataMatrix, obtenerFechaFabricante, formatearNumero, obtenerFormato, GuardarPropiedad, formatearRespuesta, ComprobarValoresReales, ObtenerValorSeguro, ComprobarSiEsCorrecto, ObtenerTituloPropiedadesExpertas, ObtenerDatosTabla, PrepareInsertSQLForMasterReplicaQueue, formatearFechas, _visorState, _getVisorTipo, _getVisorIcono, descargarDocumento, abrirVisorFotos, _visorActualizar, cerrarVisorFotos, navegarVisorFotos, _subscribirEventosImagen, _desubscribirEventosImagen, _subscribirEventos, _desubscribirEventos, _handleKeyDown, _handleLoadImage, _handleLoadErrorImage, mostrarLogNormal, mostrarLogHistorico, mostrarLogNormalDevice, mostrarLogHistoricoDevice, nuevoTipoFormulario, aplicarFiltro, VBScriptSupport, vbSupport, isNothing, isSomething, getClassName, isFloatNumber, isIntegerNumber, isNumber, isString, isEmptyString, isDate, safeToString, safeToDate, escapeRegularExpression, replaceAll };
